<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light px-1 py-3 m-0">
    <!-- alert message -->
    <div> <v-alert :type="alert_type" :model-value="alert" class="text-left" :value="alert" transition="scale-transition">{{alert_message}}</v-alert> </div>
    <!-- popup dailogs -->
    <v-row justify="center">
      <v-dialog v-model="allocateTob2bdailog" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 custom-shadow ma-0">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span></span>
                  <v-spacer></v-spacer>
                    <v-icon @click="allocateTob2bdailog = false">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
          <v-container>
            <v-row  class="p-3 text-center">
              <span>  Are you sure you want to allocate the following {{ this.selected.length }} items to B2B? </span><br>
            </v-row>
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small" class="text-none " variant="outlined"  color="blue darken-1" text @click="allocateTob2bdailog = false">Cancel</v-btn>
            <v-btn size="small" class="text-none "  variant="flat" color="primary" @click="allocationchanel">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="allocateTob2cdailog" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 custom-shadow ma-0">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span></span>
                  <v-spacer></v-spacer>
                    <v-icon @click="allocateTob2cdailog = false">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
          <v-container>
            <v-row  class="p-3 text-center">
              <span>  Are you sure you want to allocate the following {{ this.selected.length }} items to B2C? </span><br>
            </v-row>
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small" class="text-none" color="blue darken-1" variant="outlined" @click="allocateTob2cdailog = false">Cancel</v-btn>
            <v-btn size="small"  class="text-none" variant="flat" color="primary" @click="allocationchanelb2c">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- dialog for competitive bidding -->
    <v-row justify="center">
      <v-dialog v-model="competitiveBiddibg" persistent max-width="424px">
        <v-card class="v-card-100">
          <template v-slot:append>
            <v-btn icon variant="text" color="primary" @click="competitiveBiddibg = false" >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <!-- <v-card-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="competitiveBiddibg = false" >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title> -->
          <v-container>
            <v-row  class="p-3 text-center">
              <span>  Are you sure you want to select Competitive Bidding for the following items? </span><br>
            </v-row>
            <!-- <v-row>
              <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                <v-table class="gray-border v-data-simple-adjust">
                  <template>
                    <thead>
                      <tr>
                        <th class="text-left">Total items</th>
                        <th class="text-right">{{ this.selected.length }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in selected" :key="item.id" class="d-inline-block m-1">
                        <td>{{ item.id }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-table>
              </v-col>
            </v-row> -->
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small" class="text-none" variant='outlined' color="blue darken-1" text @click="competitiveBiddibg = false">Cancel</v-btn>
            <v-btn size="small" class="text-none" variant='flat' color="primary" @click="competitiveBiddingconfirm">confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Dialog for contracted -->
    <v-row justify="center">
      <v-dialog v-model="contractedPopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <template v-slot:append>
            <v-btn icon variant="text" color="primary" @click="contractedPopup = false" >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <!-- <v-card-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="contractedPopup = false" >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title> -->
          <v-container>
            <v-row  class="p-3 text-center">
              <span>  Are you sure you want to select allocate the following {{ this.selected.length }} items to Contracted? </span><br>
            </v-row>
            <!-- <v-row>
              <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                <v-table class="gray-border v-data-simple-adjust">
                  <template>
                    <thead>
                      <tr>
                        <th class="text-left">Total items</th>
                        <th class="text-right">{{ this.selected.length }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in selected" :key="item.id" class="d-inline-block m-1">
                        <td>{{item.tag_number}}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-table>
              </v-col>
            </v-row> -->
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small"  class="text-none" variant="text" color="blue darken-1" text @click="contractedPopup = false">Cancel</v-btn>
            <v-btn size="small" class="text-none" variant="flat" color="primary" @click="contractedConfirm">Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- moq dialog inentory move in price discovery method -->
    <v-row justify="center">
      <v-dialog v-model="moqLotcreationdilog" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 custom-shadow ma-0">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span></span>
                  <v-spacer></v-spacer>
                    <v-icon @click="moqLotcreationdilog = false">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
          <v-container>
            <v-row  class="p-3 text-center">
              <span>  Are you sure you want to allocate the following {{ this.selected.length }} items to MOQ? </span><br>
            </v-row>
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small" class="text-none" variant="outlined" color="blue darken-1" text @click="moqLotcreationdilog = false">Cancel</v-btn>
            <v-btn size="small" class="text-none" variant="flat" color="primary" @click="Moqcreation">Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- item move comm to moq -->
     <v-row justify="center">
      <v-dialog v-model="moveItemCommToMoq" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 custom-shadow ma-0">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span></span>
                  <v-spacer></v-spacer>
                    <v-icon @click="moveItemCommToMoq = false">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
          <v-container>
            <v-row  class="p-3 text-center">
              <span> Are you sure you want to allocate the following {{ this.selected.length }} item(s) to MOQ? </span><br>
            </v-row>
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small" class="text-none" variant="outlined" color="blue darken-1" text @click="moveItemCommToMoq = false">Cancel</v-btn>
            <v-btn size="small" class="text-none" variant="flat" color="primary" @click="moveToMAQFromComBidd">Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="markewastedailog" max-width="450px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 custom-shadow ma-0">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span>Mark As E-Waste?</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="markewastedailog = false">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
          <v-container>
              <v-row class="p-3">
                <v-col cols="6" sm="6" md="6" >        
                  <input type="radio" id="Yes" class="custom-radio me-1" value="Yes" v-model="picked" />
                  <label class="custom-label" for="Yes">Yes</label>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="6" sm="6" md="6">
                  <input type="radio" id="No" value="No" class="custom-radio me-1" v-model="picked" />
                  <label class="custom-label" for="No">No</label>
                </v-col>
              </v-row>
            </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn class="text-none" size="small" :color="((number > 0) || !picked) ?  'gray' : 'primary'" variant="flat"  @click="savemarkeWast" :disabled="number > 0 || !picked ">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- upload file popup -->
    <v-row justify="center">
      <v-dialog v-model="uploadlotfiledilog" persistent max-width="450px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-item-center">
              <span class='pt-2'>Upload Lot file</span>
              <v-spacer></v-spacer>
              <v-btn icon variant="text" color="primary" @click="closeFilePopup">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="4" class="border-opacity-25 m-0"/>
          <v-card-text>
            <v-container>
              <v-col cols="12" sm="12">
                <v-file-input class="upload" v-model="file" variant="underlined" clear-icon="mdi-close" label="Attach CSV File" accept='.csv' @change="changeFile" :error="fileError" :error-messages="fileErrorMessage"></v-file-input>
              </v-col>
            </v-container>
          </v-card-text>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small" variant="flat" class="text-none" :color="number > 0 || !file || file && !file.length ? '' : 'primary'" @click="fileLotCreatecontract" :disabled="number > 0 || !file || fileError">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- lot creation -->
    <v-row justify="center">
      <v-dialog v-model="lotCreationdilog" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Create Lot</span>
            <v-spacer></v-spacer>
            <v-btn variant="text" icon @click="closePopupLotCreate">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="4" md="12">
                  <v-text-field  label="Lot Name" variant="outlined" v-model="lot_name" type="text"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" md="12" class="pb-0">
                  <v-autocomplete v-model="assign_buyer" variant="outlined" :items="contracted__buyer_items" item-title="displayText"
                  item-value="id" label="Assign Buyer" ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                 <v-col cols="12" sm="4" md="12">
                  <v-text-field  label="Contracted Value" variant="outlined" v-model="contracted_value" type="text" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" md="12" >
                  <v-table class="gray-border v-data-simple-adjust">
                      <thead>
                        <tr>
                          <th class="text-left">Total items</th>
                          <th class="text-right">{{ this.selected.length }}</th>
                        </tr>
                      </thead>
                      <!-- <tbody>
                        <tr v-for="item in selected" :key="item.id" class="d-inline-block m-1">
                          <td>{{item.tag_number}}</td>
                        </tr>
                      </tbody> -->
                  </v-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small" elevation="3" color="normal"  variant="outlined" class="mb-3 text-none" @click="closePopupLotCreate">Cancel</v-btn>
            <v-btn size="small" :color="!lot_name || !assign_buyer || number > 0 ? '' : 'primary'" variant="flat" class="mb-3 text-none" @click="createLotContract" :disabled="!lot_name || !assign_buyer || number > 0">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- confirm dialog -->
    <v-row>
      <v-dialog v-model="confirmDialog" max-width="400px">
        <v-card>
          <v-card class="v-card-100">
            <template v-slot:append>
            <v-btn icon variant="text" color="primary" @click="confirmDialog = false" >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
            <!-- <v-card-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="confirmDialog = false" > <v-icon>mdi-close</v-icon> </v-btn>
            </v-card-title> -->
          </v-card>
            <v-card-text style="justify-content: center;">
              <span>item succesfully marked as E-wast</span>
            </v-card-text>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small" color="primary" class="mb-3 text-none">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--  Success messeage popup -->
    <v-row justify="center">
      <v-dialog v-model="successpopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 ma-0 custom-shadow">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span></span>
                  <v-spacer></v-spacer>
                  <!-- <v-btn icon @click="createTripPopup = false"> -->
                    <v-icon @click="afterClickOkLoadData">mdi-close</v-icon>
                  <!-- </v-btn> -->
                </v-row>              
            </v-card-title>
            </v-card>
            <v-card-text v-if="ewasteYes === true" class="text-center" style="margin-bottom: -20px;">
              <span style="color: #F04545;">ERROR!</span>
            </v-card-text>
            <v-card-text class="text-center">
              <span> {{ successmessage }}</span>
            </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" color="primary" class="mb-3  text-none" @click="afterClickOkLoadData">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="datadetailpopupdisposition" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span v-if="active_tab === 'In Progress B2B'">
              <span>Publish Information: "{{ publishID }}"</span><span class="creation-date">Creation Date:{{ creationDate}}</span>
            </span>
            <span v-else><span>Lot Information: "{{ id }}"</span><span class="creation-date">Creation Date:{{ creationDate}}</span></span>            
            
          <v-spacer></v-spacer>
            <v-btn variant="text" icon @click="datadetailpopupdisposition = false" > <v-icon>mdi-close</v-icon> </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
            <v-card-text>
              <v-container class="p-0">
                <div>
                  <v-row v-if="active_tab === 'In Progress B2B'">
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span class="mr2" style="font-weight: 500;">Lot ID</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.lot_id ? item_details.lot_id : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span class="mr2" style="font-weight: 500;">Lot Name</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.lot_name ? item_details.lot_name : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">Lot Type</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.lot_type ? item_details.lot_type : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">Lot Category</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.lot_category ? item_details.lot_category : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">Floor Price (₹)</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.floor_price ? item_details.floor_price.toLocaleString('en-IN') : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">Incremental Bid (₹)</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.increment_slab ? item_details.increment_slab.toLocaleString('en-IN') : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">Reserve Price (₹)</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.reserve_price ? item_details.reserve_price.toLocaleString('en-IN') : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">Buy Now Price (₹)</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.buy_now_price ? item_details.buy_now_price.toLocaleString('en-IN') : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">AI Recommended Price (₹)</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.ai_price ? item_details.ai_price.toLocaleString('en-IN') : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">Start Date & Time</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.start_date ? item_details.start_date : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">End Date & Time</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.end_date ? item_details.end_date : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">Images</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <a  @click="openDialog" style="color: #1976d2;">
                          <u>View</u>
                        </a>
                        <!-- {{ item_details.reserve_price ? item_details.reserve_price : '-'}} -->
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">Videos</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <a style="color: #1976d2;">
                          <u>View</u>
                        </a>
                        <!-- {{ item_details.reserve_price ? item_details.reserve_price : '-'}} -->
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">Delivery TimeLine In Days</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.delivery_timeline ? item_details.delivery_timeline : '-'}}
                      </v-col>
                    </v-row>

                    <v-row v-if="active_tab == 'Pending Decision' || active_tab == 'In Progress B2B'">
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">Highest Bid (₹)</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.higest_bid ? item_details.higest_bid.toLocaleString('en-IN') : '-'}}
                      </v-col>
                    </v-row>
                    <v-row v-if="active_tab == 'Pending Decision' || active_tab == 'In Progress B2B'">
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">No. Of Unique Bids</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.uniq_bids_no ? item_details.uniq_bids_no : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                      <a v-if="active_tab == 'In Progress B2B'" @click="viewBidOpenPopup" style="color: #1976d2;">
                          <u>View Bid Details</u>
                        </a><br>
                        <a v-if="active_tab == 'Pending B2B Publish'" @click="editinventorydilog" style="color: #1976d2;">
                          <u>View & Edit The Inventory</u>
                        </a>
                        <a v-if="active_tab == 'Pending Decision' || active_tab == 'In Progress B2B' || active_tab == 'Pending Payment' || active_tab == 'Pending dispatch confirmation & Time' || active_tab == 'Pending ORRD' || active_tab == 'Dispatch' || active_tab == 'Closed'" @click="editinventorydilog" style="color: #1976d2;">
                          <u>View The Inventory</u>
                        </a>
                      </v-col>
                    
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" class="p-2 d-flex">
                        <a v-if="active_tab == 'Pending B2B Publish'" @click="navigateeditinventorydilogToComponent" style="color: #1976d2;">
                          <u>Edit lot details</u>
                        </a>
                        <v-spacer></v-spacer>
                        <span>                              
                          <span>
                            <img src="@/assets/images/icons/bb-price-engine.png" class="img-fluid" />
                          </span>
                        </span>
                      
                      </v-col>                     
                    </v-row>
                  </div>
                  
              </v-container>
            </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Image show popup -->
    <v-dialog v-model="dialogVisible" persistent max-width="600">
      <v-card class="v-card-100">
        <v-card-title>
          <v-row>
            <v-col cols="11">
              <span class="headline">Images</span>
            </v-col>
            <v-col cols="1">
              <v-btn variant="text" icon @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        
        <v-card-text>
          <v-row>
            <v-col v-for="(imageUrl, index) in imageUrls" :key="index" cols="4">
              <v-img :src="imageUrl" width="100%" contain></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- edit time and date popup -->
    <v-row justify="center" ref="createForm">
      <v-dialog v-model="ecitBidTimeDilog" persistent max-width="780px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span v-if="active_tab === 'Pending B2B Publish'">Edit Bid Timings</span>
              <span v-if="active_tab === 'Pending Decision' || active_tab == 'Pending Payment'">Re-Publish Lots</span>
            <v-spacer></v-spacer>
            <v-btn variant="text" icon @click="closeEditBidDailog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <v-form ref="editDateTimeForm">
              <v-row v-if="active_tab === 'Pending B2B Publish'">
                <v-col cols="13" sm="6" md="6">                                    
                  <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :return-value="bid_start_date" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ props }">
                      <v-text-field variant="outlined"
                      v-model="formattedStartDate"
                      label="Bid Start Date"
                      color="primary"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="props"
                     
                      ></v-text-field>
                    </template>
                    <!-- <v-date-picker :min="new Date().toISOString().substr(0, 10)" v-model="bid_start_date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="$refs.menu1.save(bid_start_date)">OK</v-btn>
                    </v-date-picker> -->
                    <v-card class="m-0 overflow-hidden calendar-layout" width="315">
                      <v-date-picker :min="new Date().toISOString().substr(0, 10)"  v-model="isDatePickerBidStartDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                      </v-date-picker>
                      <v-card-action class="d-flex justify-end pb-3">
                        <v-spacer></v-spacer>
                        <v-btn variant="text" color="primary" @click="menu1 = false">Cancel</v-btn>
                        <v-btn variant="text" color="primary" @click="handleSaveDate('menu1', 'bid_start_date', 'isDatePickerBidStartDate', 'startDate' , 'bid_end_date', 'isDatePickerBidEndDate')">OK</v-btn>
                      </v-card-action>
                    </v-card>
                  </v-menu>
                </v-col>
                <v-col cols="14" sm="6" md="6">                                    
                 <!-- <v-menu
                    ref="menu_1"
                    v-model="menu_1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                    >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="time1"
                        label="Bid Start Time"
                        prepend-inner-icon="mdi-clock-time-four-outline"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      ampm-in-title
                      v-if="menu_1"
                      v-model="time1"
                      :allowed-minutes="allowedStep"
                      full-width
                      @click:minute="$refs.menu1.save(time1)">
                    </v-time-picker>
                  </v-menu> -->
                  <inlineTimePicker label="Bid Start Time" required :timeValue="time1" :allow_time="allow_start_time" :getSelectedTime="(selectedTime)=>{time1 = selectedTime}" />
                </v-col>
              </v-row>
               <v-row style="margin-bottom: -25px;">
                <v-col cols="16" sm="6" md="6">                                    
                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :return-value="bid_end_date" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ props }">
                        <v-text-field variant="outlined"
                        color="primary"
                        v-model="formattedEndDate"
                        label="Bid End Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="props"
                        >
                        </v-text-field>
                    </template>
                    <!-- <v-date-picker :min="minium_end_date"  v-model="bid_end_date" no-title scrollable >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.menu2.save(bid_end_date)">OK</v-btn>
                    </v-date-picker> -->
                    <v-card class="m-0 overflow-hidden calendar-layout" width="315">
                      <v-date-picker :min="minium_end_date"  v-model="isDatePickerBidEndDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                      </v-date-picker>
                      <v-card-action class="d-flex justify-end pb-3">
                        <v-spacer></v-spacer>
                        <!-- <v-btn variant="outlined" class="text-none" color="primary" @click="menu2= false">Cancel</v-btn>
                        <v-btn variant="flat" class="text-none" color="primary" @click="handleSaveDate('menu2', 'bid_end_date', 'isDatePickerBidEndDate')">OK</v-btn> -->
                        <v-btn variant="text" color="primary" @click="menu2= false">Cancel</v-btn>
                        <v-btn variant="text" color="primary" @click="handleSaveDate('menu2', 'bid_end_date', 'isDatePickerBidEndDate')">OK</v-btn>
                      </v-card-action>
                    </v-card>
                    </v-menu>
                </v-col>
                <v-col cols="17" sm="6" md="6">                                    
                    <!-- <v-menu
                        ref="menu_2"
                        v-model="menu_2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            v-model="time2"
                            label="Bid End Time"
                            prepend-inner-icon="mdi-clock-time-four-outline"
                            outlined
                            v-bind="attrs"
                            v-on="on"
                            >
                            </v-text-field>
                        </template>
                        <v-time-picker
                            ampm-in-title
                            v-if="menu_2"
                            v-model="time2"
                            :allowed-minutes="allowedStep"
                            full-width
                            @click:minute="$refs.menu_2.save(time2)">
                        </v-time-picker>
                        </v-menu> -->
                        <inlineTimePicker label="Bid End Time"  required :timeValue="time2" :allow_time="allow_end_time" :getSelectedTime="(selectedTime)=>{time2 = selectedTime}" />
                </v-col>
               </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small" variant="outlined" color="primary"  class="mb-3 text-none" @click="closeEditBidDailog">Cancel</v-btn>
            <v-btn size="small" v-if="active_tab === 'Pending B2B Publish'" variant="flat" color="primary" class="mb-3 text-none" @click="SaveBidTime" :disabled="!bid_start_date || !bid_end_date ||  !time1 || !time2 || number > 0">Save</v-btn>
            <v-btn size="small" v-if="active_tab === 'Pending Decision' || active_tab == 'Pending Payment'" color="primary" class="mb-3 text-none" @click="republishWithDate" :disabled="!bid_end_date || !time2 || number > 0">Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- edit inventory -->
    <v-row justify="center">
      <v-dialog v-model="editinventory" persistent :max-width="upload_doc === 'upload_doc_view' ? '900px' : '424px'">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span v-if="upload_doc === 'upload_doc_view'">Compliance Documents For "{{ id }}"</span>
            <span v-else>Edit Inventory: {{ id }}</span>
            <v-spacer></v-spacer>
            <v-btn variant="text" icon @click="cancelEditInvePopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-container>
            <v-row  class="p-3 text-center">
              <span class="text-right" style="color:#9C9C9C;">{{upload_doc === 'upload_doc_view' ? 'Total:' : 'Total Items:' }} {{ this.edit_inventory.length }}</span>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                <flex md6 class="table-scroll">
                  <v-data-table  
                    density="compact"
                    :search="search" 
                    v-model="selected" 
                    disable-pagination 
                    :hide-default-footer="true"
                    :headers="itemsheader" 
                    :items="edit_inventory" 
                    fixed-header
                    height="100%"
                    :loading="loading" 
                    loading-text="Loading Data... Please wait"
                    class="elevation-1 v-data-simple-adjust">
                    <template #[`item.delete_item`]="{item}">
                      <img v-if="active_tab == 'Pending B2B Publish' || active_tab == 'Compliance Docs'" @click="deleteEvent(item, index)" src="@/assets/images/delete_red.png" title="Delete Item" />
                    </template>
                    <template #[`item.preview`]="{ item }">
                      <div>
                        <span><a style="text-decoration:underline; color:#007BFF;" @click="complianceImageShow(item)">Preview</a></span>
                        <!-- <span v-else>-</span> -->
                      </div>
                    </template>
                     <template #[`item.download`]="{ item }">
                      <div>
                        <span><a :href="item.document_url" :download="isPdfFile(item.document_url) ? 'file.pdf' : 'image.png'" target="_blank" style="text-decoration:underline; color:#007BFF;">Download</a></span>
                        <!-- <span v-else>-</span> -->
                      </div>
                    </template>
                    <template #bottom></template>
                  </v-data-table>
                </flex>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions v-if="active_tab == 'Pending B2B Publish'" style="justify-content: center;">
            <v-btn size="small" class="text-none" variant="outlined" color="blue darken-1" @click="cancelEditInvePopup">Cancel</v-btn>
            <v-btn size="small" class="text-none" :color="eventDeleteClicked || number > 0 ? '' : 'primary'" variant="flat" @click="allocationchanelb2cconfirm" :disabled="number > 0 || !tagIds.length > 0">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- update lote conform -->
    <v-row justify="center">
            <v-dialog v-model="updatelotconfirm" persistent max-width="450px">
            <v-card class="v-card-100">
              <v-card-title>
                <span>Confirmation</span><br>                 
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                  <span>  Are you sure want delete the Items? </span><br>  
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn size="small" class="text-none" text color="normal" @click="updatelotconfirm = false">Cancel</v-btn>
                <v-btn size="small" class="text-none" color="primary" @click="allocationchanelb2csubmit">Confirm</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
    </v-row>
    <!-- delete lot -->
    <v-row justify="center">
            <v-dialog v-model="deletelotDilog" persistent max-width="450px">
            <v-card class="v-card-100">
              <v-card-title>
                <span>Confirmation</span><br>                 
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                  <span>  Are you sure want delete the lot? </span><br>  
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions style="justify-content: center;">
                <v-btn size="small" variant="outlined" color="primary" @click="deletelotDilog = false">Cancel</v-btn>
                <v-btn size="small" variant="flat" color="primary" @click="deletelotconfirm">Confirm</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
    </v-row>
    <!-- Reserve Lot Form -->
    <v-row justify="center" ref="reserveLotForm">
      <v-dialog v-model="reserveLotPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Reserve Lot "{{ liq_id }}"</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closePopups"><v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
          <v-container>
            <row style="margin-bottom: -25px">
              <input type="radio" id="option1" value="option1" v-model="select_buyer">
              <label for="option1" style="color:#2D2D2D">Select Buyer:</label>
            </row>
            <v-row>
              <v-col cols="1" sm="6" md="6">
                <v-autocomplete prepend-inner-icon="mdi-magnify" v-model="assign_buyer" variant="outlined" :items="assign_user_items" item-title="full_name"
                  item-value="username" label="Buyer Name" :disabled="select_buyer !== 'option1'">
                </v-autocomplete>
              </v-col>
            </v-row>
            <!-- <row style="margin-bottom: -25px">
              <input type="radio" id="option2" value="option2" v-model="select_buyer">
              <label for="option2">Add New Buyer Details:</label>
            </row>
            <v-row style="margin-bottom: -25px;">
              <v-col cols="1" sm="6" md="6">
                <v-text-field label="Buyer Name" outlined v-model="buyer_name" type="text"
                  :disabled="select_buyer !== 'option2'">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row style="margin-bottom: -25px;">
              <v-col cols="1" sm="6" md="6">
                <v-text-field label="Address Line 1" outlined v-model="address_line_1" type="text"
                  :disabled="select_buyer !== 'option2'">
                </v-text-field>
              </v-col>
              <v-col cols="2" sm="6" md="6">
                <v-text-field label="Address Line 2" outlined v-model="address_line_2" type="text"
                  :disabled="select_buyer !== 'option2'">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row style="margin-bottom: -25px;">
              <v-col cols="1" sm="6" md="6">
                <v-text-field label="City" outlined v-model="city" type="text"
                  :disabled="select_buyer !== 'option2'">
                </v-text-field>
              </v-col>
              <v-col cols="2" sm="6" md="6">
                <v-text-field label="State" outlined v-model="state" type="text"
                  :disabled="select_buyer !== 'option2'">
                </v-text-field>
              </v-col>
            </v-row> -->
          </v-container>
        </v-card-text>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small" color="normal" variant="outlined" class="mb-3 text-none" @click="closePopups">Cancel</v-btn>
            <v-btn size="small" color="primary" variant="flat" class="mb-3 text-none" @click="reserveConfirm" :disabled="!assign_buyer">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Move to b2b dailog -->
    <v-row justify="center">
            <v-dialog v-model="moveToB2B" persistent max-width="424px">
            <v-card class="v-card-100">
              <template v-slot:append>
            <v-btn icon variant="text" color="primary" @click="moveToB2B = false" >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
              <!-- <v-card-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="moveToB2B = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title> -->
            <v-card-text class="text-center">
              <span> Are you sure you want to move the selected item to B2B?</span>
            </v-card-text>
              <v-card-actions style="justify-content: center;">
                <v-btn size="small" class="text-none" variant="outlined" text color="primary" @click="moveToB2B = false">Cancel</v-btn>
                <v-btn size="small" class="text-none" variant="flat" color="primary" @click="consfirmMoveToB2B">Confirm</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
    </v-row>
    <!-- publish dialog details -->
    <v-row justify="center" ref="reserveLotForm">
      <v-dialog v-model="publishDialog" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Update details</span>
            <v-spacer></v-spacer>
            <v-btn variant="text" icon @click="publishDialog = false"><v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
          <v-container>
            <v-form ref="lotPublishForm">
            <v-row>
              <v-col cols="1" sm="12" md="12" class="pb-0">
                <v-autocomplete v-model="platform" variant="outlined" :items="platform_items" item-title="name"
                  item-value="id" label="Platform">
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2" sm="6" md="6" style="padding-top:42px; padding-bottom: 0px">
                <v-text-field label="Publish Price (₹)" :rules="publishPriceValidationRules"  variant="outlined" v-model="format_publish_price"  :min="0" :disabled="publishpriceDisable" v-on:keyup="calculateDiscPercent" :error-messages = "showPriceError ? ['Publish Price should be less than or equal to Benchmark Price !'] : []">
                </v-text-field>
              </v-col>
              <v-col cols="3" sm="6" md="6" class="pb-0">
                <span>Note: Benchmark Price (₹) is {{ formatCurrency(benchmark_price) }}</span>
                <v-text-field label="Discount (%)" variant="outlined" v-model="discount" type="number" :min="0" :disabled="discountDisable" v-on:keyup="calculatePublishPrice" class="pt-2" :error-messages = "showDiscError ? ['Discount % should be less than or equal to 100!'] : []">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>                               
              <v-col cols="4" sm="6" md="6">
                  <v-expansion-panels class="custom-control_outlined" ref="imagepopup" readonly>
                  <v-expansion-panel variant="outlined" @click="openImagePopup">
                    <v-expansion-panel-title> Lot Images </v-expansion-panel-title>
                  </v-expansion-panel>
                  </v-expansion-panels>
                  <span>
                    <div class="selected_rule_box">
                      <span  v-for="image in lotImageNames" :key="image" class="rule-type_option" :label="getImageName(image)" >
                        {{ image }}
                        <span style="color: #000000; cursor: pointer" class="text-black"
                                  @click="removeImage(index)">x</span>
                      </span >
                    </div>
                  </span>
              </v-col>
              <v-col cols="5" sm="6" md="6">                                    
                <v-expansion-panels class="custom-control_outlined" ref="imagepopup" readonly disabled>
                  <v-expansion-panel disab variant="outlined" >
                    <v-expansion-panel-title> Lot Videos </v-expansion-panel-title>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
            <v-row style="margin-bottom: -25px;">
                <v-col cols="6" sm="6" md="6">                                    
              <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" :return-value="bid_start_date" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ props }">
                      <v-text-field variant="outlined"
                      v-model="bid_start_date"
                      label="Publish Start Date"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="props"
                      ></v-text-field>
                  </template>
                  <!-- <v-date-picker :min="new Date().toISOString().substr(0, 10)" v-model="bid_start_date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu3 = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="$refs.menu3.save(bid_start_date)">OK</v-btn>
                  </v-date-picker> -->
                  <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                    <v-date-picker :min="new Date().toISOString().substr(0, 10)"  v-model="isDatePickerBidStartDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                    </v-date-picker>
                    <v-card-action class="d-flex justify-end pb-3">
                      <v-spacer></v-spacer>
                      <v-btn variant="outlined" class="text-none" color="primary" @click="menu3 = false">Cancel</v-btn>
                      <v-btn variant="flat" class="text-none" color="primary" @click="handleSaveDate('menu3', 'bid_start_date', 'isDatePickerBidStartDate', 'startDate' , 'bid_end_date', 'isDatePickerBidEndDate')">OK</v-btn>
                    </v-card-action>
                  </v-card>
                  </v-menu>
                </v-col>
                <v-col cols="7" sm="6" md="6">                                    
                <!-- <v-menu
                    ref="menu_3"
                    v-model="menu_3"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                    >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="time3"
                        label="Publish Start Time"
                        prepend-inner-icon="mdi-clock-time-four-outline"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      ampm-in-title
                      v-if="menu_3"
                      v-model="time3"
                      :allowed-minutes="allowedStep"
                      full-width
                      @click:minute="$refs.menu3.save(time3)">
                    </v-time-picker>
                  </v-menu> -->
                  <inlineTimePicker label="Bid Start Time"  required :timeValue="time1" :allow_time="allow_start_time" :getSelectedTime="(selectedTime)=>{time1 = selectedTime}" />
                </v-col>
              </v-row>
              <v-row style="margin-bottom: -25px;">
                <v-col cols="8" sm="6" md="6">                                    
                    <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" :return-value="bid_end_date" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ props }">
                        <v-text-field variant="outlined"
                        v-model="bid_end_date"
                        label="Publish End Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="props"
                        >
                        </v-text-field>
                    </template>
                    <!-- <v-date-picker :min="new Date().toISOString().substr(0, 10)"  v-model="bid_end_date" no-title scrollable >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu4 = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.menu4.save(bid_end_date)">OK</v-btn>
                    </v-date-picker> -->
                    <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                    <v-date-picker :min="minium_end_date"  v-model="isDatePickerBidEndDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                    </v-date-picker>
                    <v-card-action class="d-flex justify-end pb-3">
                      <v-spacer></v-spacer>
                      <v-btn variant="outlined" class="text-none" color="primary" @click="menu4= false">Cancel</v-btn>
                      <v-btn variant="flat" class="text-none" color="primary" @click="handleSaveDate('menu4', 'bid_end_date', 'isDatePickerBidEndDate')">OK</v-btn>
                    </v-card-action>
                  </v-card>
                    </v-menu>
                </v-col>
                <v-col cols="9" sm="6" md="6">                                    
                    <!-- <v-menu
                        ref="menu_4"
                        v-model="menu_4"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            v-model="time4"
                            label="Bid End Time"
                            prepend-inner-icon="mdi-clock-time-four-outline"
                            outlined
                            v-bind="attrs"
                            v-on="on"
                            >
                            </v-text-field>
                        </template>
                        <v-time-picker
                            ampm-in-title
                            v-if="menu_4"
                            v-model="time4"
                            :allowed-minutes="allowedStep"
                            full-width
                            @click:minute="$refs.menu_4.save(time4)">
                        </v-time-picker>
                        </v-menu> -->
                        <inlineTimePicker label="Bid End Time"  required :timeValue="time2" :allow_time="allow_end_time" :getSelectedTime="(selectedTime)=>{time2 = selectedTime}" />
                </v-col>
                </v-row>
              </v-form>
          </v-container>
        </v-card-text>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small" color="normal" variant="outlined" class="mb-3 text-none" @click="publishDialog = false">Cancel</v-btn>
            <v-btn size="small" color="primary" variant="flat" class="mb-3 text-none" @click="publishLot" >Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
      <!-- add image popup -->
      <v-row justify="center">
      <v-dialog v-model="addImagesPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Select images</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeImageDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
            <v-card-text class="mt-3">
              <v-row>
                <v-col v-for="image in lotImages" :key="image" cols="3">
                  <img :src="image" alt="Lot Image" style="width: 186px; height: 184px;" @click="openImagePopupSingle(image)"/>
                </v-col>
              </v-row>
              <label for="fileInput" class="icon-container">
          <v-icon color="#91C6FF" class="custom-icon" size="25">mdi-plus</v-icon>
        </label>
        <input type="file" id="fileInput" accept="image/*" @change="handleImageUpload" style="display: none" />
            </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" class="cancel-color mb-3 text-none" @click="closeImageDialog">Cancel</v-btn>
            <v-btn color="primary" variant="flat" @click="addImagesPopup = false" class="mb-3 text-none">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Update sales popup -->
    <v-row justify="center" ref="reserveLotForm">
        <v-dialog v-model="updateSalesPopup" persistent max-width="700px">
          <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Update Sales Details</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="updateSalesPopup = false"><v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="4" class="m-0" />
            <v-card-text>
            <v-container>
              <v-row style="margin-bottom: -25px;">
                <v-col cols="1" sm="6" md="6">
                  <v-text-field label="Buyer Name" variant="outlined" v-model="buyer_name" type="text">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-bottom: -25px;">
                <v-col cols="1" sm="6" md="6">
                  <v-text-field label="Address Line 1" variant="outlined" v-model="address_line_1" type="text">
                  </v-text-field>
                </v-col>
                <v-col cols="2" sm="6" md="6">
                  <v-text-field label="Address Line 2" variant="outlined" v-model="address_line_2" type="text">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row style="margin-bottom: -25px;">
                <v-col cols="1" sm="6" md="6">
                  <v-text-field label="City" variant="outlined" v-model="city" type="text">
                  </v-text-field>
                </v-col>
                <v-col cols="2" sm="6" md="6">
                  <v-text-field label="State" variant="outlined" v-model="state" type="text">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
            <v-card-actions style="justify-content: center;">
              <v-btn size="small" color="normal" variant="outlined" class="mb-3 text-none" @click="updateSalesPopup = false">Cancel</v-btn>
              <v-btn size="small" color="primary" variant="flat" class="mb-3 text-none" @click="submitUpdateSalesDetails" >Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-row>
    <!-- Update Payment Deatils -->
    <v-row justify="center" ref="reserveLotForm">
      <v-dialog v-model="updatePaymentPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Update Payment Details</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closePopups"><v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
            <v-container>
              <v-row>
            <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
              <v-table class="gray-border v-data-simple-adjust">
                  <thead>
                    <tr>
                      <th class="text-left">Purchase Amount</th>
                      <th class="text-right"> ₹ {{ this.purchaseAmount ? Number(this.purchaseAmount).toLocaleString('en-IN') : '-' }}</th>
                    </tr>
                  </thead>
                  <thead>
                    <tr>
                      <th class="text-left">Partial Amount Received</th>
                      <th class="text-right"> ₹ {{ this.amountReceived ? Number(this.amountReceived).toLocaleString('en-IN') : '-' }}</th>
                    </tr>
                  </thead>
              </v-table>
            </v-col>
          </v-row>
          <v-row>
              <v-col cols="2" sm="6" md="6">
                <v-text-field label="Purchase Amount (₹)" variant="outlined" v-model="formattedPurchaseAmount"  :min="0" :rules="[validateAmount]">
                </v-text-field>
              </v-col>
              <v-col cols="3" sm="6" md="6">
                <v-text-field label="Payment Reference Number" variant="outlined" v-model="payment_ref_number" type="text"  @keyup="validateInput">
                </v-text-field>
              </v-col>
            </v-row>
            </v-container>
          <v-card-text>
        </v-card-text>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small" color="normal" variant="outlined" class="mb-3 text-none" @click="closePopups">Cancel</v-btn>
            <v-btn size="small" color="primary" variant="flat" class="mb-3 text-none"  @click="paymentUpdateDetailsSubmit" :disabled="!formattedPurchaseAmount || !payment_ref_number || number > 0">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- cancel pending payment -->
    <v-row justify="center">
      <v-dialog v-model="cancelPaymentPopup" persistent max-width="400px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 custom-shadow ma-0">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span>Choose The Next Action</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="closePopups">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
            <v-container>
              <!-- <row style="margin-bottom: -25px">
                <v-col cols="1" sm="8" md="8" style="margin-bottom: 20px">
                  <input type="radio" id="option1" class="custom-radio" value="option1" @click="assignLotOne" v-model="select_buyer" :disabled="assignDisabled == true">
                  <label class="custom-label" for="option1">Assign Lot</label>                    
                </v-col>                  
                <v-row>
              <v-col cols="1" sm="10" md="10" v-if="select_buyer === 'option1'" style="margin-bottom: 20px">
                <v-autocomplete v-model="assign_buyer" variant="outlined" :items="assign_user_items" item-title="user_name"
                  item-value="higest_bid_id" label="Assign Buyer" :disabled="select_buyer !== 'option1'" @change="getDataAssign">
                </v-autocomplete>
              </v-col>
              </v-row>         
            </row> -->
            <!-- <row style="margin-bottom: -25px">
              <v-col cols="1" sm="8" md="8">
                <input type="radio" id="option2" class="custom-radio" value="option2" @click="republishShowAlert" v-model="select_buyer" :disabled="assignDisabled == true">
              <label class="custom-label" for="option2">Republish Lots</label>
              </v-col>              
            </row> -->
            <row style="margin-bottom: -25px">
              <v-col cols="1" sm="8" md="8">
                <input type="radio" id="option3" class="custom-radio" value="option3" @click="deleteShowAlert" v-model="select_buyer">
              <label class="custom-label" for="option3">Delete Lots</label>
              </v-col>               
            </row>
            <row style="margin-bottom: -25px">
              <v-col cols="1" sm="8" md="8">
                <input type="radio" id="option4" class="custom-radio" value="option4" @click="unReserveLotShowAlert" v-model="select_buyer" :disabled="reserveLotDisabled == true">
                <label class="custom-label" for="option4">Unreserve Sub-Lots</label>
              </v-col>                
            </row>
            </v-container>
          <v-card-text>
        </v-card-text>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small" color="normal" variant="outlined" class="mb-3 text-none" @click="closePopups">Cancel</v-btn>
            <v-btn size="small" color="primary" variant="flat" class="mb-3 text-none" @click="lotCancelApiCall" :disabled="!select_buyer">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Update Dispatch date dialog -->
    <v-row justify="center">
      <v-dialog v-model="updateDispatchDatePopup" persistent max-width="400px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Update Dispatch Date</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closePopups"><v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
            <v-container>
              <v-row style="margin-bottom: -25px;">
                <v-col cols="1" sm="12" md="12">                                    
                    <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" :return-value="publish_end_date" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ props }">
                        <v-text-field variant="outlined"
                        v-model="dateFormattedPublish"
                        label="Select the date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="props"
                        >
                        </v-text-field>
                    </template>
                    <!-- <v-date-picker :min="new Date().toISOString().substr(0, 10)"  v-model="publish_end_date" no-title scrollable >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu4 = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.menu4.save(publish_end_date)">OK</v-btn>
                    </v-date-picker> -->
                    <v-card class="m-0 overflow-hidden calendar-layout" width="315">
                    <v-date-picker :min="new Date().toISOString().substr(0, 10)"  v-model="isDatePickerPublishEndDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                    </v-date-picker>
                    <v-card-action class="d-flex justify-end pb-3">
                      <v-spacer></v-spacer>
                      <v-btn class="text-none" variant="outlined" color="primary" @click="menu4 = false">Cancel</v-btn>
                      <v-btn variant="flat" class="text-none" color="primary" @click="handleSaveDate('menu4', 'publish_end_date', 'isDatePickerPublishEndDate')">OK</v-btn>
                    </v-card-action>
                  </v-card>
                    </v-menu>
                </v-col>
                </v-row>
            </v-container>
          <v-card-text>
        </v-card-text>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small" color="normal" variant="outlined" class="mb-3 text-none" @click="closePopups">Cancel</v-btn>
            <v-btn size="small" color="primary" variant="flat" class="mb-3 text-none" @click="submitUpdateDispatchDate" :disabled="!publish_end_date">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- MOQ Lot Information -->
    <v-row justify="center">
      <v-dialog v-model="moqaLotInformation" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span v-if="active_tab === 'In Progress B2B'">
              <span>Publish Information: "{{ publishID }}"</span><span class="creation-date">Creation Date:{{ creationDate}}</span>
            </span>
            <span v-else>
              <span>Lot Information: "{{ id }}"</span><span class="creation-date">Creation Date:{{ creationDate}}</span>
          </span>  
            <!-- <span>Lot Information: "{{ id }}"</span><span class="creation-date">Creation Date:{{ creationDate}}</span> -->
            <v-spacer></v-spacer>
            <v-btn variant="text" icon @click="moqaLotInformation = false" > <v-icon>mdi-close</v-icon> </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
            <v-card-text>
              <v-container class="p-0">
                <div>
                  <v-row v-if="active_tab === 'In Progress B2B'">
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span class="mr2" style="font-weight: 500;">Lot ID</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.lot_id ? item_details.lot_id : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span class="mr2" style="font-weight: 500;">Lot Name MOQ</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.lot_name ? item_details.lot_name : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">Lot Type</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.lot_type ? item_details.lot_type : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">Lot Category</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.lot_category ? item_details.lot_category : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">No. Of Sub-Lots</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{item_details.possible_sub_lots ? item_details.possible_sub_lots : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">Start Date & Time</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.start_date ? item_details.start_date : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">End Date & Time</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.end_date ? item_details.end_date : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <span style="font-weight: 500;">Delivery TimeLine In Days</span>
                      </v-col>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        {{ item_details.delivery_timeline ? item_details.delivery_timeline : '-'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" class="p-2">
                        <a 
                           v-if="active_tab == 'Pending B2B Publish'" 
                           @click="navigateToMOQComponent('edit_moq')" 
                           style="color: #1976d2;" class="cursor-pointer"
                           >
                          <u>View & Edit The Inventory</u>
                        </a>
                        <a v-if="active_tab == 'In Progress B2B'" @click="navigateToMOQComponent('view_moq_items')" style="color: #1976d2;" class="cursor-pointer">
                          <u>View The Inventory</u>
                        </a>
                        <a v-if="active_tab == 'Pending Decision'|| active_tab == 'Pending Payment' || active_tab == 'Pending dispatch confirmation & Time' || active_tab == 'Pending ORRD' || active_tab == 'Dispatch'" @click="navigateToMOQComponent('vie_moq_PD')" style="color: #1976d2;" class="cursor-pointer">
                          <u>View The Inventory</u>
                        </a>
                      </v-col>
                    
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" class="p-2 d-flex">
                        <a 
                        v-if="active_tab == 'Pending B2B Publish' && creatingStatus !== 'Creating Sub Lots'" 
                          @click="navigateToMOQGridFrom('edit_lot_moq')" 
                          style="color: #1976d2; cursor:pointer"
                          :class="{ 'disabled-link': creatingStatus === 'Creating Sub Lots' }"
                          >
                          <u>Edit lot details</u>
                        </a>
                        <v-spacer></v-spacer>
                        <span>                              
                          <span>
                            <img src="@/assets/images/icons/bb-price-engine.png" class="img-fluid" />
                          </span>
                        </span>
                      
                      </v-col>                     
                    </v-row>
                  </div>
                  
              </v-container>
            </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
     <!-- popup dailogs move competivebidding-->
     <v-row justify="center">
      <v-dialog v-model="movecommbidd" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 custom-shadow ma-0">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span>Create Trip</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="movecommbidd = false">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
          <v-container>
            <v-row  class="p-3 text-center">
              <span>  Are you sure you want to allocate the following {{ this.selected.length }} items to competitive Bidding? </span><br>
            </v-row>
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small"  class="text-none" color="blue darken-1" variant="outlined" @click="movecommbidd = false">Cancel</v-btn>
            <v-btn size="small"  class="text-none" color="primary" variant="flat" @click="submitMoveCommBidd">SUBMIT</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--Change Disposition confirm popup -->
    <v-row justify="center">
            <v-dialog v-model="confirmationPopup" persistent max-width="424px">
                <v-card class="v-card-100">
                    <v-card class="v-card-100 custom-shadow ma-0">
                      <v-card-title class="pa-0">              
                          <v-row class="ma-1">
                            <span></span>
                            <v-spacer></v-spacer>
                              <v-icon @click="confirmationPopup = false">mdi-close</v-icon>
                          </v-row>              
                      </v-card-title>
                      </v-card>
                    <v-card-text class="text-center">
                        <span > Are you sure want to move this item to {{ disposition_action }} bucket? </span>
                    </v-card-text>
                <v-card-actions center class="mt-2">
                    <v-spacer></v-spacer>
                        <v-btn size="small" variant="outlined" color="primary" class="cancel-color mb-3 text-none" @click="confirmationPopup = false">Cancel</v-btn>   
                        <v-btn size="small" variant="flat" color="primary" class="mb-3 text-none" :disabled="number > 0" @click="confirmedDispo">Confirm</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
                </v-card>
            </v-dialog>
    </v-row>
    <!-- View Bid Details -->
    <v-row justify="center">
      <v-dialog v-model="viewBidDetailsPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <span>Bid For: "{{ publishID }}"</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="viewBidDetailsPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-container>
            <v-row  class="p-3 text-center">
              <span class="text-right">Total: {{ bid_details.length }}</span>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                <flex md6 class="table-scroll">
                  <v-data-table 
                  :dense="true" 
                  disable-pagination 
                  :hide-default-footer="true"
                  :headers="bidheader" 
                  :items="bid_details" 
                  :loading="loading" 
                  fixed-header
                  height="100%"
                  loading-text="Loading Data... Please wait"
                  class="elevation-1 v-data-simple-adjust">
                  <template #[`item.higest_bid_id`]="{item}">
                    <span>{{ item.higest_bid_id ? item.higest_bid_id : "-" }}</span>
                  </template>
                  <template #[`item.user_name`]="{item}">
                    <span>{{ item.user_name ? item.user_name : "-" }}</span>
                  </template>
                  <template #[`item.organization`]="{item}">
                    <span>{{ item.organization ? item.organization : "-" }}</span>
                  </template>
                  <template #[`item.higest_bid`]="{item}">
                    <span>{{ item.higest_bid ? item.higest_bid : "-" }}</span>
                  </template>
                </v-data-table>
              </flex>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Compliance image show popup -->
    <v-dialog v-model="complaince_image_show" persistent max-width="600">
      <v-card class="v-card-100">
        <v-card-title class="d-flex">
          <!-- <span class="headline">Images</span> -->
          <v-spacer></v-spacer>
          <v-btn icon @click="complaince_image_show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-img v-if="!isPdf" :src="imageUrls" width="100%" contain></v-img>
              <iframe
                v-if="isPdf"
                :src="pdfViewerUrl"
                style="width: 100%; height: 500px"
                frameborder="0"
              ></iframe>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Uplpad Documents popup -->
    <v-row justify="center">
      <v-dialog v-model="upload_documents" persistent max-width="364px">
        <v-card class="v-card-100">
          <v-card class="v-card-100">
            <v-card-title class="d-flex">
            <v-row  class="ma-1">
              <span>Upload Documents</span>
              <v-spacer></v-spacer>
                <v-icon @click="upload_documents = false">mdi-close</v-icon>
                </v-row>
            </v-card-title>
          </v-card>
          <v-card-text class="download-email">
            <v-row style="display: inline">
              <v-autocomplete
                v-model="select_documents"
                :items="select_documents_items"
                label="Select Documents"
                variant="outlined"
                type="text"
                hide-details
                class="mb-5"
              ></v-autocomplete>
              <v-file-input
                v-model="file_compliance"
                accept="csv"
                @update:modelValue="changeFile"
                class="mb-5 mt-10"
                variant="outlined"
                prepend-inner-icon="mdi-paperclip"
                prepend-icon=""
                label="Attach pdf/jpg/ file"
                :error="fileError"
                :error-messages="fileErrorMessage"
              >
              </v-file-input>
              <div v-if="fileName" style="margin: -20px 10px 0px 0px">
                <v-chip class="ma-2" close @click:close="closeChip">
                  {{ fileName }}
                </v-chip>
              </div>
              <div v-if="uploading">
                Uploading file ({{ uploadPercentage }}%)
                <v-progress-linear :value="uploadPercentage" color="blue" height="10"></v-progress-linear>
              </div>
              <div v-if="completed">
                <v-progress-linear :value="uploadPercentage" color="blue" height="10"></v-progress-linear>
                <p style="color: green; text-align: right">Completed</p>
              </div>
              <v-row v-if="file_data">
                <v-col v-for="(file, index) in file_data" :key="index" cols="2" sm="6" md="6" class="p-0">
                  <v-chip class="mt-1 ml-4" closable @click:close="removeFile(file.document_name, index)">
                    <span v-if="file.document_name && file.document_name.length > 10">{{ file.document_name.slice(0, 10) }}...</span>
                     <span v-else>{{ file.document_name}}</span>
                  </v-chip>
                </v-col>
              </v-row>
            </v-row>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <!-- <v-btn small class="text-none" outlined large color="primary" @click="upload_documents = false">Cancel</v-btn> -->
            <v-btn
              color="primary"
              class="mb-3 text-none"
              variant="flat"
              v-if="this.confirmButton != 'FINISH'"
              @click="confirmUploadFile"
              :disabled="!file_compliance || number > 0 || fileError"
              >Upload</v-btn
            >
            <v-btn
              color="primary"
              class="mb-3 text-none"
              v-if="this.confirmButton == 'FINISH'"
              @click="clickFinish"
              variant="flat"
              >Finish</v-btn
            >
            <v-btn
              color="primary"
              class="mb-3 text-none"
              variant="flat"
              v-if="this.confirmButton == 'CONFIRM' && active_tab === 'Compliance Docs'"
              :disabled="!file_data.length > 0"
              @click="openAddWeight"
              >Next</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Update Weight dialog -->
    <v-row justify="center">
      <v-dialog v-model="add_weight" persistent max-width="400px">
        <v-card class="v-card-100">
          <v-card class="v-card-100">
            <v-card-title class="d-flex">
              <span>Add Weight</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="add_weight = false"
                ><v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
          <v-container>
            <v-row style="margin-bottom: -25px">
              <v-col cols="1" sm="12" md="12">
                <v-text-field
                  label="Enter Weight (In Kg)"
                  outlined
                  v-model="add_weight_kg"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-card-text> </v-card-text>
          <v-card-actions style="justify-content: center">
            <v-btn
              large
              color="primary"
              class="mb-3 text-none"
              @click="saveFiles('skip')"
              :disabled="number > 0"
              v-if="skip_button"
              >Skip</v-btn
            >
            <v-btn
              large
              color="primary"
              class="mb-3 text-none"
              @click="saveFiles('save')"
              :disabled="!add_weight_kg || number > 0"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- confirm buyer popup -->
    <v-row justify="center" ref="createForm">
      <v-dialog v-model="confirmBuyerPopup" persistent max-width="780px">
        <v-card class="v-card-100"> 
          <v-card class="v-card-100 ma-0 custom-shadow">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                   <span>{{(select_value === 'confirm_buyer' || select_value === 'approvefrom_pending') ? 'Remarks' : 'Reason & Remarks'}}</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="confirmBuyerPopup = false">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
          <v-card-text>
            <v-container>
              <v-row>                
                <v-autocomplete
                   v-if="(select_value === 're_assign_buyer' && select_reason !== 'Others') || select_value === 'reject_from_pending' && select_reason !== 'Others'"
                   class="m-3"  
                   v-model="select_reason" 
                   variant="outlined" 
                   :items="select_reason_items"
                   label="Select Reason"
                   width="200px"
                   ></v-autocomplete>
                   <v-text-field width="200px" v-if="(select_value === 're_assign_buyer' && select_reason === 'Others') || (select_value === 'reject_from_pending' && select_reason === 'Others')" v-model="reason_others" class="m-3" label="Reason" variant="outlined">                
                  </v-text-field>
                  <v-text-field width="200px" v-if="select_value !== 'reject_from_pending'" v-model="remarks_confirm_buyer" class="m-3" label="Remarks" variant="outlined">                
                </v-text-field>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions style="justify-content: center;">
            <v-btn 
              @click="confirmBuyerPopup = false"
              variant="outlined"
              color="indigo"
              class="text-none"
              >Cancel</v-btn>
            <v-btn 
              color="primary"
              class="text-none"
              :disabled="isConfirmDisabled || number > 0"
              @click="handleConfirm"
              variant="flat"
             >Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- popup dailogs end -->
    <!-- main header -->
    <div style="max-height: 106px;"> <HeaderComponent :headerTitle="headerText"  :router-link="getRouterLink" :router-link-text="getRouterLinkText" :return-condition="true" :component-name="componentsName"/> </div>
    <!-- main header end -->
    <!-- tabs -->
    <v-card class="v-card-100" v-if="closed_report !== 'Closed'">
        <v-tabs v-model="tab_index" color="primary">
          <v-tab @click="loadData(tab, 'tab_clicked', index)" style="text-transform:none" v-for="(tab, index) in tabs1" :key="`${tab+index}`" class="tab-color" :disabled="user_role=='finance_manager'">{{ mapped_tab(tab) }}</v-tab>
          
          <div ref="createLotDropDownContainer">
            <v-menu offset-y>
              <template v-slot:activator="{ props }">
                <v-tab v-bind="props" @click="createLotDropDownFunction" style="text-transform:none;  padding : 0px 0px !important"  :disabled="user_role == 'finance_manager'">
                <span style="padding: 12px;" class="tab-color">{{ mapped_tab(selectedCreateLotSubtab) }}
                    <v-icon>{{ createLotDropDown ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon></span>
                </v-tab>
              </template>
              <v-list>
                <v-list-item v-for="subtab in filteredCreateLotSubTabs" :key="subtab" @click="loadData(subtab, 'subtab_clicked1', index)">
                  <v-list-item-title class="tab-color">
                    {{ mapped_tab(subtab) }}
                   <img v-if="subtab === 'AI-Lot-Optimization'" src="@/assets/images/icons/ai_chat.png" class="img-fluid ai_img" />
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <div ref="pendingPublishDropDownContainer">
            <v-menu offset-y>
              <template v-slot:activator="{ props }">
                <v-tab  v-bind="props" @click="pendingPublishDropDownFunction" style="text-transform:none; padding : 0px 0px !important" :disabled="user_role == 'finance_manager'">
                  <span style="padding: 12px;" class="tab-color">{{ mapped_tab(selectedPendingPublishSubtab) }}
                  <v-icon>{{ pendingPublishPopUp ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon></span>
                </v-tab>
              </template>
              <v-list>
                <v-list-item v-for="subtab in pendingPublishSubTab" :key="subtab" @click="loadData(subtab, 'subtab_clicked2', index)" >
                  <v-list-item-title class="tab-color">{{ mapped_tab(subtab) }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          
            <div ref="inProgressDropDownContainer">
              <v-menu offset-y>
                <template v-slot:activator="{ props }">
                  <v-tab  v-bind="props" @click="inProgressDropDownFunction" style="text-transform:none; padding : 0px 0px !important" :disabled="user_role == 'finance_manager'">
                    <span style="padding: 12px;" class="tab-color">{{ mapped_tab(selectedInProgrssSubtab) }}
                      <v-icon>{{ InProgressDropDown ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon></span>
                  </v-tab>
                </template>
                <v-list>
                  <v-list-item v-for="subtab in subtabs3" :key="subtab" @click="loadData(subtab, 'subtab_clicked3', index)">
                    <v-list-item-title class="tab-color">{{ mapped_tab(subtab) }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
          </div>

          <v-tab v-for="(tab, index) in filteredTabs" :key="`${tab + index}`"  style="text-transform:none" @click="loadData(tab, 'tab_clicked', index)" class="tab-color" :disabled="isTabDisabled(tab, user_role)">{{mapped_tab(tab)}}</v-tab>
        </v-tabs>
      </v-card>
    <!-- tabs end -->
    <!--  -->
    <v-card-title style="padding: 25px 25px 15px 15px;" class="action-style pb-1">
      <v-row>
          <v-combobox class="text-left m-3 mr-0"
           v-if="active_tab === 'Channel Allocation' || active_tab === 'Price Discovery Method' || active_tab === 'Create Lots (Con)' || active_tab === 'Create Lots (ComBid)' || active_tab === 'Create Lots (MOQ)' || active_tab === 'Pending For Approval'"
           v-model="select_field" 
           item-title="name" 
           item-value="id" 
           :items="select_field_items" 
           label="Select Field" 
           variant="outlined" 
           style="max-width: 158px;">
        </v-combobox>
        <v-text-field color="primary" class="m-3" 
            prepend-inner-icon="mdi-magnify"  
            :disabled="!select_field && (active_tab === 'Channel Allocation' || active_tab === 'Price Discovery Method' || active_tab === 'Create Lots (Con)' || active_tab === 'Create Lots (ComBid)' || active_tab === 'Create Lots (MOQ)' || active_tab === 'Pending For Approval')"
            v-model="Liquidation_search" 
            v-no-edge-space
            label="Search" 
            style="max-width: 300px;" 
            variant="outlined" 
            v-on:keyup.enter="loadData(active_tab)"
            >            
        </v-text-field>
                  <v-spacer></v-spacer>
              <!-- action buttons -->
              <v-card-actions style="margin-bottom: 24px;" v-if="active_tab == 'Channel Allocation' && isActionAllowed(role)">
                <!-- <v-btn class="ma-2 text-none" variant='flat' size="x-large" color="primary" :disabled="(this.selected.length == 0)" @click="allocateTob2b">Allocate <br class="text-break"> To B2B</v-btn>
                <v-btn class="ma-2 text-none" variant='flat' size="x-large" color="primary" :disabled="(this.selected.length == 0)" @click="allocateTob2c">Allocate <br class="text-break"> To B2C</v-btn>
                <v-btn class="ma-2 text-none" variant='flat' size="x-large" color="primary" :disabled="(this.selected.length == 0)" @click="markewaste">Mark As <br class="text-break"> E-Waste</v-btn> -->
                <v-menu offset-y>
                  <template v-slot:activator="{ props }">
                    <v-btn color="primary" variant='flat' v-bind="props" class="text-none ma-2 px-5" size="x-large" :disabled="selected.length == 0">
                      Allocation
                      <v-icon class="ml-1">mdi-menu-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in ['Allocate To B2B', 'Allocate To B2C']"
                      :key="index"
                    >
                      <v-list-item-title style="cursor: pointer;" @click="allocateAction(item)">{{ item }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-menu offset-y>
                  <template v-slot:activator="{ props }">
                    <v-btn color="primary" variant="flat" v-bind="props" class="text-none ma-2 px-5" size="x-large" :disabled="selected.length == 0">
                      Other Action
                      <v-icon class="ml-1">mdi-menu-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in ['Mark As E-Waste']"
                      :key="index"
                    >
                      <v-list-item-title style="cursor: pointer;" @click="markewaste">{{ item }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-menu offset-y>
                      <template v-slot:activator="{ props }">
                          <v-btn color="primary" variant='flat' v-bind="props" :disabled="selected.length == 0" class="ma-2 text-none" size="x-large">
                            Change <br class="text-break"> Disposition
                          <v-icon>
                            mdi-menu-down
                          </v-icon>
                          </v-btn>
                      </template>
                      <v-list>
                          <v-list-item v-for="(item, index) in change_disposition_list" :key="index" @click="changeDisposition(item)">
                            <v-list-item-title>{{ item.original_code }}</v-list-item-title>
                          </v-list-item>
                      </v-list>
                 </v-menu>
              </v-card-actions>
              <v-card-actions style="margin-bottom: 24px;" v-if="active_tab == 'Price Discovery Method' && isActionAllowed(role)">
                <!-- <v-btn class="ma-2  text-none" size="x-large" variant='flat' color="primary" :disabled="(this.selected.length == 0)" @click="contractedDialog">Contracted</v-btn>
                <v-btn class="ma-2 text-none" size="x-large"  variant='flat' color="primary" :disabled="(this.selected.length == 0)" @click="competitiveBiddibgdilog">Competitive Bidding</v-btn>
                <v-btn class="ma-2 text-none" size="x-large"  variant='flat' color="primary" :disabled="(this.selected.length == 0)" @click="createMoqlot">MOQ</v-btn> -->
                 <v-menu offset-y>
                <template v-slot:activator="{ props }">
                  <v-btn color="primary" variant="flat" v-bind="props" class="text-none ma-2 px-5" size="x-large" :disabled="selected.length == 0">
                    Select Action
                    <v-icon class="ml-1">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in sales_action_list"
                    :key="index"
                  >
                    <v-list-item-title style="cursor: pointer;" @click="updatePriceDiscMethod(item)">{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              </v-card-actions>      
              <v-card-actions style="margin-bottom: 24px;" v-if="active_tab == 'Create Lots (Con)' && isActionAllowed(role)">
                <!-- <v-btn class="ma-2 text-none" size="x-large" variant='flat' color="primary" :disabled="(this.selected.length == 0)" @click="lotCreation">Create Lots</v-btn>
                <v-btn class="ma-2 text-none" size="x-large" variant='flat' color="primary" @click="uploadlotfile">Upload Lot File</v-btn> -->
                 <v-menu offset-y>
                <template v-slot:activator="{ props }">
                  <v-btn color="primary" variant="flat" v-bind="props" class="text-none ma-2 px-5" size="x-large" :disabled="selected.length == 0">
                    Select Action
                    <v-icon class="ml-1">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in ['Create Lots']"
                    :key="index"
                  >
                    <v-list-item-title style="cursor: pointer;" @click="lotCreation">{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              </v-card-actions>
              <v-card-actions style="margin-bottom: 24px;" v-if="active_tab == 'Create Lots (ComBid)' && isActionAllowed(role)">
                <!-- <v-btn class="ma-2 text-none"  variant='flat' color="primary" :disabled="(this.selected.length == 0)" @click="navigateToComponent" size="x-large">Create <br class="text-break-combid"> Lot</v-btn>
                <v-btn class="ma-2 text-none" variant='flat' color="primary" disabled @click="autocreatelot" size="x-large">Auto <br class="text-break-combid"> Create Lot</v-btn>
                <v-btn class="ma-2 text-none" variant='flat' color="primary"  @click="navigateToFileUpload" size="x-large">Upload <br class="text-break-combid"> Lot File</v-btn>
                <v-btn class="ma-2 text-none" variant='flat' color="primary"  @click="downloadInventory" size="x-large">Download <br class="text-break-combid"> Inventory</v-btn>
                <v-btn class="ma-2 text-none" variant='flat' color="primary" :disabled="(this.selected.length == 0)" @click="itemMoveCommToMoqTab" size="x-large">Move <br class="text-break-combid"> To MOQ</v-btn> -->
                <v-menu offset-y>
                <template v-slot:activator="{ props }">
                  <v-btn color="primary" variant="flat" v-bind="props" class="text-none ma-2 px-5" size="x-large">
                    Lot Creation
                    <v-icon class="ml-1">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in [
                        'Create Lot',
                        'Auto Create Lot',
                        'Upload Lot File',
                        'Download Inventory',
                        // 'Move To MOQ'
                        'Move To Grading'
                        ]"
                    :key="index"
                    :disabled="(item == 'Auto Create Lot') || (selected.length == 0 && (item == 'Move To MOQ' || item == 'Move To Grading'))"
                  >
                    <v-list-item-title style="cursor: pointer;" @click="updateCreteCombid(item)">{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              </v-card-actions>
              <v-card-actions style="margin-bottom: 24px;" v-if="active_tab == 'Create Lots (MOQ)' && isActionAllowed(role)">
                <!-- <v-btn class="ma-2 text-none" size="x-large" variant='flat' color="primary" :disabled="(this.selected.length != 0)" @click="navigateToMOQComponent('create_moq')">Create Lots</v-btn>
                <v-btn class="ma-2 text-none" size="x-large" variant='flat' color="primary" :disabled="(this.selected.length == 0)" @click="competitivebidding">Move To Competitive Bidding</v-btn> -->
                 <v-menu offset-y>
                <template v-slot:activator="{ props }">
                  <v-btn color="primary" variant="flat" v-bind="props" class="text-none ma-2 px-5" size="x-large">
                    Lot Creation
                    <v-icon class="ml-1">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in ['Create Lots','Move To Competitive Bidding']"
                    :key="index"
                    :disabled="(selected.length == 0 && item == 'Move To Competitive Bidding')"
                  >
                    <v-list-item-title style="cursor: pointer;" @click="updateCreteMoqActions(item)">{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              </v-card-actions>
              <v-card-actions style="margin-bottom: 24px;" v-if="active_tab == 'Pending B2B Publish' && isActionAllowed(role)">
                <!-- <v-btn class="ma-2 text-none" size="x-large"  variant='flat' :color="this.selected.length !== 1 ? '' : 'primary'" :disabled="(selected.length !== 1)" @click="editbidtiming">Edit Bid Timings</v-btn>
                <v-btn class="ma-2 text-none" size="x-large"  variant='flat' color="primary" :disabled="(this.selected.length == 0)" @click="deletelot">Delete Lot</v-btn> -->
                 <v-menu offset-y>
                <template v-slot:activator="{ props }">
                  <v-btn color="primary" variant="flat" v-bind="props" class="text-none ma-2 px-5" v-on="on" size="x-large" :disabled="selected.length == 0">
                    Select Action
                    <v-icon class="ml-1">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in ['Edit Bid Timings','Delete Lot']"
                    :key="index"
                    :disabled="(selected.length != 1 && item == 'Edit Bid Timings')"
                  >
                    <v-list-item-title style="cursor: pointer;" @click="updateB2bAction(item)">{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
                <!-- <v-btn class="ma-2" color="primary" :disabled="number > 0 || (this.selected.length === 0) || disableB2BActionButton" @click="PublishLot">publish</v-btn> -->
              </v-card-actions>
              <v-card-actions style="margin-bottom: 24px;" v-if="active_tab == 'In Progress B2B' && isActionAllowed(role)">
                <!-- <v-btn class="ma-2 text-none" size="x-large" variant='flat' :color="this.selected.length !== 1 ? '' : 'primary'" :disabled="(selected.length !== 1)" @click="editbidtiming">Edit Bid Timings</v-btn>
                <v-btn class="ma-2 text-none" size="x-large" variant='flat' color="primary" :disabled="(this.selected.length == 0)" @click="deletelot">Delete Lot</v-btn> -->
                <v-menu offset-y>
                <template v-slot:activator="{ props }">
                  <v-btn color="primary" variant="flat" v-bind="props" class="text-none ma-2 px-5" v-on="on" size="x-large" :disabled="selected.length == 0">
                    Select Action
                    <v-icon class="ml-1">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in ['Edit Bid Timings','Delete Lot']"
                    :key="index"
                    :disabled="(selected.length != 1 && item == 'Edit Bid Timings')"
                  >
                    <v-list-item-title style="cursor: pointer;" @click="updateB2bAction(item)">{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
                <!-- <v-btn class="ma-2" variant='flat' color="primary" :disabled="(this.selected.length == 0)" @click="reserveLotDialog">Reserve Lot</v-btn> -->
              </v-card-actions>
              <v-card-actions style="margin-bottom: 24px;" v-if="active_tab == 'Pending Decision' && isActionAllowed(role)">
                <!-- <v-btn class="ma-2 text-none" size="x-large" variant='flat' :color="isMoqLot() ? '' : 'primary'" :disabled="isMoqLot()" @click="assignLotToBuyer">Assign Buyer</v-btn>
                <v-btn class="ma-2 text-none" size="x-large" variant='flat' :color="selected.length !== 1 ? '' : 'primary'" :disabled="(selected.length !== 1)" @click="navigateToRepublish('re_publish')">Republish</v-btn>
                <v-btn class="ma-2 text-none" size="x-large" variant='flat' color="primary" :disabled="(selected.length == 0)" @click="deletelot">Delete Lot</v-btn> -->
                 <v-menu offset-y>
                <template v-slot:activator="{ props }">
                  <v-btn color="primary" variant="flat" v-bind="props" class="text-none ma-2 px-5" v-on="on" size="x-large" :disabled="selected.length == 0">
                    Select Action
                    <v-icon class="ml-1">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in pending_decision_action"
                    :key="index"
                    :disabled="(isMoqLot() && item == 'Assign Buyer') || (selected.length !== 1 && item == 'Assign Buyer')"
                  >
                    <v-list-item-title style="cursor: pointer;" @click="updateDecisionAction(item)">{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              </v-card-actions>
              <v-actions style="margin-top: 8px;" v-if="active_tab == 'Pending Approval'">
                <v-btn class="ma-2 text-none" size="x-large" variant='flat' color="primary" :disabled="(selected.length == 0 || this.current_user !== 'admin' && this.current_user !== 'finance_manager' && this.current_user !== 'liquidation_manager' && this.current_user !== 'central_admin')" @click="openConfirmBuyer('approvefrom_pending')">Approve</v-btn>
                <v-btn class="ma-2 text-none" size="x-large" variant='flat' color="primary" :disabled="(selected.length == 0 || this.current_user !== 'admin' && this.current_user !== 'finance_manager' && this.current_user !== 'liquidation_manager' && this.current_user !== 'central_admin')" @click="openConfirmBuyer('reject_from_pending')">Reject</v-btn>
                <v-btn class="ma-2 text-none" size="x-large" variant='flat' color="primary" :disabled="selected.length == 0" @click="downloadPendingApprovalCsv">Download CSV</v-btn>
              </v-actions>
              <v-card-actions style="margin-bottom: 24px;" v-if="active_tab == 'Pending B2C Publish' && isActionAllowed(role)">
                <!-- <v-btn class="ma-2 text-none" size="x-large" variant='flat' color="primary" :disabled="(this.selected.length == 0)" @click="opendialogMoveToB2b">Move To B2B</v-btn>
                <v-btn class="ma-2 text-none" size="x-large" variant='flat' color="primary" :disabled="(this.selected.length == 0)" @click="openPublishDialog">Publish</v-btn> -->
                <v-menu offset-y>
                <template v-slot:activator="{ props }">
                  <v-btn color="primary" variant="flat" v-bind="props" class="text-none ma-2 px-5" v-on="on" size="x-large" :disabled="selected.length == 0">
                    Select Action
                    <v-icon class="ml-1">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in ['Move To B2B','Publish']"
                    :key="index"
                  >
                    <v-list-item-title style="cursor: pointer;" @click="updatePendingB2cAction(item)">{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              </v-card-actions>
              <v-card-actions style="margin-bottom: 24px;" v-if="active_tab == 'In Progress B2C' && isActionAllowed(role)">
                <!-- <v-btn class="ma-2 text-none" size="x-large" variant='flat' color="" disabled @click="openUpdateSalesDialog">Update Sales</v-btn>
                <v-btn class="ma-2 text-none" size="x-large"variant='flat' color="primary" :disabled="(this.selected.length == 0)" @click="deletelot">Delete</v-btn> -->
                <v-menu offset-y>
                <template v-slot:activator="{ props }">
                  <v-btn color="primary" variant="flat" v-bind="props" class="text-none ma-2 px-5" v-on="on" size="x-large" :disabled="selected.length == 0">
                    Select Action
                    <v-icon class="ml-1">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in ['Update Sales','Delete']"
                    :key="index"
                  >
                    <v-list-item-title style="cursor: pointer;" @click="updateInprB2cAction(item)">{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              </v-card-actions>
              <v-card-actions style="margin-bottom: 24px;" v-if="active_tab == 'Pending Payment' && isActionAllowed(role)">
                <!-- <v-btn class="ma-2 text-none" variant='flat'  color="primary" size="x-large"  :disabled="(selected.length !== 1) || (current_user === 'liquidation_manager')" @click="openupdatePaymentDialog">Update Payment</v-btn>
                <v-btn class="ma-2 text-none" size="x-large" variant='flat' color="primary" :disabled="(this.selected.length == 0)" @click="openCancelPendingPayment">Cancel</v-btn> -->
                <v-menu offset-y>
                <template v-slot:activator="{ props }">
                  <v-btn color="primary" variant="flat" v-bind="props" class="text-none ma-2 px-5" v-on="on" size="x-large" :disabled="selected.length == 0">
                    Select Action
                    <v-icon class="ml-1">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in ['Re-Assign','Update Payment','Re-Publish','Cancel']"
                    :key="index"
                     :disabled="(selected.length !== 1 && item == 'Update Payment') || (selected.length !== 1 && item == 'Re-Assign') || (current_user === 'finance_manager' && item != 'Update Payment') || (current_user === 'liquidation_manager' && item == 'Update Payment')"
                  >
                    <v-list-item-title style="cursor: pointer;" @click="updatePendingPaymentAction(item)">{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              </v-card-actions>
              <v-card-actions style="margin-bottom: 24px;" v-if="(active_tab == 'Pending dispatch confirmation & Time' || active_tab == 'Pending ORRD') && (isActionAllowed(role) || role == 'warehouse_manager')">
                <!-- <v-btn class="ma-2 text-none" size="x-large"color="primary" variant="flat" @click="redirect_to_upload">Upload</v-btn>
                <v-btn class="ma-2 text-none" size="x-large" :disabled="(selected.length == 0)" variant="flat" color="primary" @click="downloadConfiramtion">{{organization_name === 'Voltas' || $isRelianceClient() ? 'Download' : 'Download'}}</v-btn> -->
                 <v-menu offset-y>
                <template v-slot:activator="{ props }">
                  <v-btn color="primary" variant="flat" v-bind="props" class="text-none ma-2 px-5" v-on="on" size="x-large">
                    Select Action
                    <v-icon class="ml-1">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in ['Upload','Download',]"
                    :key="index"
                    :disabled="selected.length == 0 && item == 'Download'"
                  >
                    <v-list-item-title style="cursor: pointer;" @click="updateDispacthcConfirmTimeAction(item)">{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
                <!-- <v-btn class="ma-2 text-none" size="x-large" variant='flat' color="primary" v-if="organization_name !== 'Voltas' && $isRelianceClient() && !$isWhirlpoolClient()" :disabled="(this.selected.length == 0)" @click="openDispatchDateDialog">Update Dispatch Date</v-btn> -->
              </v-card-actions>
              <!-- action buttons end -->
              <!-- filter -->
              <v-expansion-panels v-if="active_tab !== 'Pending For Approval'" class="custom-control_outlined m-0 pt-4" ref="filterPopupRef" readonly :style="{ 
                'max-width': active_tab === 'Channel Allocation' ? '150px !important' : '150px !important', 
                'margin-bottom': '18px !important', 
                'min-height': '52px !important' 
              }" style="height: 52px">
                <v-expansion-panel variant="outlined" @click="filterListOfButtons" >
                  <v-expansion-panel-title>Filter
                  </v-expansion-panel-title>
                </v-expansion-panel>
              </v-expansion-panels>
      </v-row>
    </v-card-title>
    <!-- tabs data -->
    <v-layout column>
      <v-col cols="12" style="overflow: auto" class="px-0">
            <v-data-table 
          density="compact"
          :search="search" 
          v-model="selectedTableItem" 
          disable-pagination 
          :hide-default-footer="true"
          :headers="headers" 
          :items="table_data" 
          item-value="id"
          :loading="loading"
          fixed-header
          height="100%" 
          :items-per-page="pageSize"
          loading-text="Loading Data... Please wait"
          class="elevation-1"
          hover
          show-select
          return-object
          :style="dataTableStyle"
          >
          <template #[`header.disposition_age`]="{ column }">
            <span>{{ column.title }}
              <AgeingTooltip />
            </span>
          </template>
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
              <span v-if="header.title == 'Lot ID' && active_tab !== 'Pending For Approval'">
                <a href="#" @click.prevent="itemDetailpopup(item, item.id)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.lot_id}}</a>
              </span>
              <!-- <span v-if="header.key == 'lot_id' && active_tab === 'Pending Approval'">
                <a href="#" @click.prevent="itemDetailpopup(item, item.id)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.lot_id }}</a>
              </span> -->
              <!-- <span v-else-if="header.key == 'winning_buyer'">
              <a @click="navigateToBuyerDetails(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.winning_buyer}}</a>
              </span> -->
              <span v-else-if="header.key == 'dispatch_date'">
                <span>{{ formatDispatchDate(item) }}</span>
              </span> 
              <span v-else-if="header.key == 'bench_mark_price'">
                <span>{{ item.bench_mark_price ? item.bench_mark_price.toLocaleString('en-IN') : '-' }}</span>
              </span>  
              <span v-else-if="header.key == 'salvage_value'">
                <span>{{ item.salvage_value ? item.salvage_value.toLocaleString('en-IN') : '-' }}</span>
              </span> 
              <span v-else-if="header.key == 'higest_bid'">
                <span>{{ item.higest_bid ? item.higest_bid.toLocaleString('en-IN') : '-' }}</span>
              </span> 
              <span v-else-if="header.key == 'reserve_price'">
                <span>{{ item.reserve_price ? item.reserve_price.toLocaleString('en-IN') : '-' }}</span>
              </span>
              <span v-else-if="header.key == 'purchase_amount'">
                <span>{{ item.purchase_amount ? item.purchase_amount.toLocaleString('en-IN') : '-' }}</span>
              </span>
              <span v-else-if="header.key == 'amount_received'">
                <span>{{ item.amount_received ? item.amount_received.toLocaleString('en-IN') : '-' }}</span>
              </span>
              <span v-else-if="header.key == 'liquidation_benchmark_price'">
                <span>{{ item.liquidation_benchmark_price ? item.liquidation_benchmark_price.toLocaleString('en-IN') : '-' }}</span>
              </span>
              <span v-else-if="header.key == 'floor_price'">
                <span>{{ item.floor_price ? item.floor_price.toLocaleString('en-IN') : '-' }}</span>
              </span>
              <span v-else-if="header.key == 'recovery_benchmark_price'">
                <span>{{ item.recovery_benchmark_price ? item.recovery_benchmark_price.toLocaleString('en-IN') : '-' }}</span>
              </span>
              <span v-else-if="header.key == 'lot_name'">
                <span>{{ item.lot_name ? item.lot_name : '-' }}</span>
              </span>
              <span v-else-if="header.key == 'publishable_status'">
                <span v-if="item.publishable_status !== null && item.publishable_status.length <= 30">{{ item.publishable_status }}</span>
              <span v-else-if="item.publishable_status === null"> - </span>
              <span v-else>
                <v-tooltip location="top" text="item.publishable_status">
                  <template v-slot:activator="{ props }">
                    <a v-bind="props" style="color: #1976d2;" @click="showFullText(item.publishable_status)" >
                      {{ item.publishable_status.substring(0, 25) }}...
                    </a>
                  </template>
                  <span>{{ item.publishable_status }}</span>
                </v-tooltip>
              </span>              
              </span> 
              <span v-else-if="header.key == 'action'">
              <v-icon class="cancel-color my-1 text-none" color="primary" @click="uploadDocOpenPopup(item)" :disabled="current_user === 'finance_manager'">mdi-paperclip</v-icon>
                <!-- <v-btn
                  variant="outlined"
                  class="cancel-color my-1 text-none"
                  color="primary"
                  @click="uploadDocOpenPopup(item)"
                  >Upload Docs</v-btn>               -->
                </span> 
              <span v-else-if="header.key == 'remaning_compliance_documents'">
                <div>
                    <span v-if="item.remaning_compliance_documents"
                      ><a
                        style="text-decoration: underline; color: #007bff"
                        @click="editinventorydilog('upload_doc_view', item)"
                        >{{item.remaning_compliance_documents}}</a></span>
                      <span v-else>-</span>
                  </div>             
             </span>
             <span v-else-if="header.key == 'compliance_documents'">
              <div>
                <span v-if="item.compliance_documents"
                  ><a
                    style="text-decoration: underline; color: #007bff"
                    @click="editinventorydilog('upload_doc_view', item)"
                    >View</a
                  ></span>
                 <span v-else>-</span>
              </div>              
            </span> 
            <!-- <span v-else-if="header.key == 'lot_name'">
                <span v-if="item.lot_name !== null && item.lot_name.length <= 30">
                  {{ item.lot_name }}
                </span>
                <span v-else-if="item.lot_name === null">
                  N/A
                </span>
                <span v-else>
                  <v-tooltip top>
                    <template v-slot:activator="{props }">
                      <a v-bind="props" style="color: #1976d2;">{{ item.lot_name.substring(0, 30) }}...</a>
                    </template>
                    <div style="max-width: 400px; word-wrap: break-word;">
                    <span>{{ item.lot_name }}</span>
                  </div>
                  </v-tooltip>
                </span>         
            </span>  -->
              <span v-else-if="header.key !== 'actions' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
               
              <span v-else>-</span>
            </template>
          <!-- <template #[`item.ewaste`]="{item}">
            <span>{{ item.ewaste ? item.ewaste : "-"}}</span>
          </template> -->
          <!-- <template   #[`item.id`]="{ item }">
              <a v-if="active_tab === 'Pending B2B Publish'" @click="itemDetailpopup(item, item.id)" style="color: #1976d2;" class="cursor-pointer" >
                <u> {{ item.id }}</u>
              </a>
              <span v-else>
                 {{ item.id }}
              </span>
            </template>
          <template   #[`item.lot_id`]="{ item }">
              <a v-if="active_tab === 'Pending B2B Publish'" @click="itemDetailpopup(item, item.id)" style="color: #1976d2;" class="cursor-pointer">
                <u> {{ item.lot_id }}</u>
              </a>
              <span v-else>
                 {{ item.lot_id }}
              </span>
            </template> -->
            <!-- <template   #[`item.beam_lot_id`]="{ item }">
              <span v-if="item.beam_lot_id">
              <a @click="itemDetailpopup(item, item.id)" style="color: #1976d2;">
                <u> {{ item.beam_lot_id }}</u>
              </a>
              </span>
              <span v-else>-</span> -->
              <!-- <a v-else>
                 {{ item.beam_lot_id }}
              </a> -->
            <!-- </template> -->
            <!-- <template #[`item.price_discovery_method`]="{item}">
              <span>{{ item.price_discovery_method ? item.price_discovery_method : "-" }}</span>
            </template>
            <template #[`item.higest_bid`]="{item}">
              <span>{{ item.higest_bid ? item.higest_bid : "-" }}</span>
            </template>
            <template #[`item.article_description`]="{item}">
              <span>{{ item.article_description ? item.article_description : "-" }}</span>
            </template>
            <template #[`item.category`]="{item}">
              <span>{{ item.category ? item.category : "-" }}</span>
            </template>
            <template #[`item.buyer_name`]="{item}">
              <span>{{ item.buyer_name ? item.buyer_name : "-" }}</span>
            </template>
            <template #[`item.purchase_amount`]="{item}">
              <span>{{ item.purchase_amount ? item.purchase_amount : "-" }}</span>
            </template>
            <template #[`item.amount_received`]="{item}">
              <span>{{ item.amount_received ? item.amount_received : "-" }}</span>
            </template>
            <template #[`item.destination_city`]="{item}">
              <span>{{ item.destination_city ? item.destination_city : "-" }}</span>
            </template> -->
            <!-- <template #[`item.dispatch_date`]="{item}">
              <span>{{ formatDispatchDate(item) }}</span>
            </template> -->
            <!-- <template #[`item.publishable_status`]="{ item }">
              <span v-if="item.publishable_status !== null && item.publishable_status.length <= 30">{{ item.publishable_status }}</span>
              <span v-else-if="item.publishable_status === null"> - </span>
              <span v-else>
                <v-tooltip location="top" text="item.publishable_status">
                  <template v-slot:activator="{ props }">
                    <a v-bind="props" style="color: #1976d2;" @click="showFullText(item.publishable_status)" >
                      {{ item.publishable_status.substring(0, 25) }}...
                    </a>
                  </template>
                  <span>{{ item.publishable_status }}</span>
                </v-tooltip>
              </span>
            </template> -->
            <!-- <template #[`item.action`]="{ item }">
            <v-btn
              outlined
              class="cancel-color my-1 text-none"
              color="primary"
              @click="uploadDocOpenPopup(item)"
              >Upload Docs</v-btn
            >
          </template> -->
          <!-- <template #[`item.remaning_compliance_documents`]="{ item }">
            <div>
              <span v-if="item.remaning_compliance_documents"
                ><a
                  style="text-decoration: underline; color: #007bff"
                  @click="editinventorydilog('upload_doc_view', item)"
                  >{{item.remaning_compliance_documents}}</a
                ></span
              >
              <span v-else>-</span>
            </div>
          </template>
          <template #[`item.compliance_documents`]="{ item }">
            <div>
              <span v-if="item.compliance_documents"
                ><a
                  style="text-decoration: underline; color: #007bff"
                  @click="editinventorydilog('upload_doc_view', item)"
                  >View</a
                ></span
              >
              <span v-else>-</span>
            </div>
          </template> -->
          <!-- <template v-slot:item.lot_name="{ item }">
            <span v-if="item.lot_name !== null && item.lot_name.length <= 30">
                {{ item.lot_name }}
              </span>
              <span v-else-if="item.lot_name === null">
                N/A
              </span>
              <span v-else>
                <v-tooltip top>
                  <template v-slot:activator="{props }">
                    <a v-bind="props" style="color: #1976d2;">{{ item.lot_name.substring(0, 30) }}...</a>
                  </template>
                  <div style="max-width: 400px; word-wrap: break-word;">
                  <span>{{ item.lot_name }}</span>
                </div>
                </v-tooltip>
              </span>
          </template> -->
          <!-- <template #[`item.sub_location_name`]="{ item }">
            <span>{{ item.sub_location_name ? item.sub_location_name : '-' }}</span>
          </template>
          <template #[`item.salvage_value`]="{ item }">
              <span>{{ item.salvage_value ? item.salvage_value : '-' }}</span>
         </template>     -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
    <!-- tabs data end -->
     <!-- filter data popup -->
     <v-row justify="center">
        <v-dialog content-class="filter-liquidation" v-model="filteWithSubPopup" persistent :max-width="filter_width">
          <v-card class="filter_ui">
            <v-card-text>
              <v-container>
                <v-row class="flex-nowrap">
                  <v-col v-for="(row, index) in rows" :key="index">
                    <template v-if="row.element === 'select&search'">             
                      <v-combobox hide-details color="primary"  prepend-inner-icon="mdi-magnify" v-model="row.value" :items="row.menuItems"
                          item-title="label" item-value="label" :label="row.label" :multiple="row.multiple" variant="outlined">                      
                      </v-combobox>
                        <template v-if="row.value && row.value.length > 0">
                          <v-chip class="filterchip text-wrap my-1" v-for="item in row.value"
                            :key="item.label" color="#fffff" variant="outlined">
                            <span>{{ item.label }}</span>
                            <v-icon small @click="handelComboSelectValue(row, item)"
                              class="menuItemCloseIcon">mdi-close</v-icon>
                          </v-chip>
                        </template>
                        <template v-else-if="!row.multiple && row.value">
                          <v-chip class="filterchip text-wrap my-1" color="#fffff" variant="outlined">
                            <span>{{ row.value.label }}</span>
                            <v-icon small @click="row.value = null"
                              class="menuItemCloseIcon">mdi-close</v-icon>
                          </v-chip>
                        </template>
                    </template>
                    <template v-if="row.element === 'text'">
                        <v-text-field variant="outlined" :label="row.label" v-model="row.value"></v-text-field>
                      </template>
                      <template v-if="row.element === 'dropdownwithaction'">
                        <v-combobox hide-details 
                        color="primary"
                        :ref="'nextDialogRef' + row.label"
                        variant='outlined'
                            :label="row.label"
                            :items="dropStaticData"
                            item-title="name" item-value="id" 
                            multiple
                            :loading="dropStaticData.length === 0"
                            @focus="handleClickdropdownwithaction(row)"
                            >
                              <template v-slot:item="{ item }">
                                <v-list class="py-0 px-3" :style="{'width': (Number(filter_width.slice(0, -2))-200)/4 + 'px'}">
                                  <v-list-item class="p-0">
                                <v-row>
                                  <v-col cols="8" class="align-self-center">
                                    <span v-if="item.raw.name.length <= 15">{{ item.raw.name }}</span>
                                    <span v-else>
                                      <v-tooltip location="bottom">
                                        <template v-slot:activator="{ props }">
                                          <span v-bind="props">
                                            {{ item.raw.name.substring(0, 15) }}...
                                          </span>
                                        </template>
                                        <div style="max-width: 700px; word-wrap: break-word;">{{ item.raw.name }}</div>
                                      </v-tooltip>
                                    </span>
                                  </v-col>
                                  <v-col cols="4" class="text-right">
                                    <!-- :checked="true" -->
                                    <div class=" d-flex justify-content-center align-item-center">
                                      <v-checkbox hide-details class="ma-0" 
                                        :name="item.raw.name"
                                        item-value="id"
                                        :value="item.raw.id"
                                        density='compact'
                                        :checked="row.parentData ? row.parentData.filter(cate => cate.value.includes(item.raw.id)).length > 0 :  false"
                                        @change="handleCheckCategory(row, item.raw)"
                                        ></v-checkbox>
                                      <v-icon v-if="item.raw?.children?.length > 0"
                                        @click="handleDropDownFilterMenu(item.raw, row)" class="mt-2">mdi-chevron-right</v-icon>
                                    </div>
                                  </v-col>
                                </v-row>
                                </v-list-item>
                                </v-list>
                              </template>
                        </v-combobox>
                        <template v-if="row.parentData.length > 0">
                            <v-chip class="filterchip text-wrap my-1" v-for="selectedData in row.parentData"
                              :key="selectedData.label" color="#fffff" variant="outlined">
                              <span>{{ selectedData.value.join("/") }}</span>
                              <v-icon small @click="handlemenuItemClose(selectedData, row)"
                                class="menuItemCloseIcon">mdi-close</v-icon>
                            </v-chip>
                          </template>
                        <!-- <v-btn outlined :label="row.label" @click="handleOpenDispositionDialog"></v-btn> -->
                        <!-- <v-expansion-panels class="custom-control_outlined" :ref="'nextDialogRef' + row.label" readonly
                      style="width: 300px; margin-bottom: 28px; min-height: 56px;">
                      <v-expansion-panel outlined @click="handleOpenDispositionDialog(row, 'nextDialogRef' + row.label)">
                        <v-expansion-panel-header class="active_border-primary"><span class="active_float-label text-primary">{{ row.label }}</span>
                          <template v-slot:actions>
                            <v-icon color="primary">
                              mdi-menu-down
                            </v-icon>
                          </template>
                        </v-expansion-panel-header>
                      </v-expansion-panel>
                      
                    </v-expansion-panels> -->
                      </template>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="margin-10">
              <v-spacer></v-spacer>
              <v-btn size="small" class="text-none resetButton" @click="resetFields()">Reset</v-btn>
              <v-btn size="small" class="text-none " variant="outlined" color="normal" @click="handleCloseFilterPopup">Cancel</v-btn>
              <v-btn size="small" class="text-none " :color="number > 0 ? 'secondry' : 'primary'" variant="flat" @click="applyFilterFunc" :disabled="number > 0">Apply Filter(s)</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    <!-- pagination -->
            <div>
                <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
            </div>
  </v-card>  
</template>

<script>
  import HeaderComponent from "../../../../commoncomponents/HeaderComponent";
  import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
  import JwPagination from 'jw-vue-pagination';
  import Loading from 'vue-loading-overlay';
  // import 'vue-loading-overlay/dist/vue-loading.css';
    import 'vue-loading-overlay/dist/css/index.css';
  import inlineTimePicker from '../../../../commoncomponents/inlineTimePicker.vue';
  import { securedAxiosInstance, plainAxiosInstance,IS_QA_SERVER } from '@/backend/axios'
  import { mixinHelper } from "@//mixins/mixin-helper.js";
  import { moduleAccessFunc,module_that_allowed,signout,isOnlyViewAction} from '@/backend/axios/moduleAccess'
  // import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess';

  export default {
    mixins: [mixinHelper],

    data(){
      return {
        headerText: "Liquidation",
        tab_index: 0,
        lot_name:'',
        assign_buyer: null,
        search:"",
        alert: false,
        all_lots: [],
        selected: [],
        picked: [],
        category:[],
        grade: '',
        Buyer_status: '',
        Liquidation_search: [],
        liquidation_filter: '',
        dailog_confirm: '',
        dialog_title: '',
        bid_start_date:null,
        isDatePickerBidStartDate: new Date(),
        isDatePickerBidEndDate: new Date(),
        menu1: false,
        menu_1:false,
        time1: null,
        menu2:false,
        bid_end_date:null,
        menu_2:false,
        time2:null,
        eventDeleteClicked:true,
        // main tabs 
        tabs1: [
          "Channel Allocation",
          "Price Discovery Method",],
        tabs2 :[
          // "In Progress B2B",
          "Pending Decision",
          // "In Progress B2C",
          "Pending Approval",
          "Pending Payment",
          "Pending dispatch confirmation & Time",
          "Dispatch",
          "Compliance Docs",
          "Closed",
          "Pending For Approval"
        ],
        createLotSubTab : [
          "Contracted",
          "Competitive",
          "MOQ",
          "AI-Lot-Optimization",
        ],
        pendingPublishSubTab : [
          "B2B",
          "B2C",
        ],
        subtabs3 : [
          "B2B",
          "B2C"
        ],
        prev_tabIndex : 0,
        selectedCreateLotSubtab : "Create Lots",
        selectedPendingPublishSubtab : "Pending Publish",
        selectedInProgrssSubtab : "In Progress",
        // main tabs end
        active_tab: "Channel Allocation",
        // tabe headers
        headers: [
        { title: "Tag ID", key: "id" },
        { title: "Article ID", key: "article_id" },
        { title: "Article Description", key: "article_description" },
        { title: "Category", key: "category", },
        {title: "Grade", key:"grade"},
        {title: "Benchmark Price", key:"bench_mark_price"},
        { title: "Ageing", key:"disposition_age"},
        {title: "E-waste?", key:"ewaste"},
        ],
        table_data: [],
        change_assignment_items:[],
        loading: false,
        category_filter: '',
        selectedChannelAllocation: '',
        filteWithSubPopup: false,
        allocateTob2bdailog: false,
        allocateTob2cdailog: false,
        competitiveBiddibg : false,
        contractedPopup: false,
        moqLotcreationdilog: false,
        markewastedailog: false,
        uploadlotfiledilog: false,
        lotCreationdilog : false,
        confirmDialog : false,
        ecitBidTimeDilog : false,
        datadetailpopupdisposition : false,
        editinventory : false,
        deletelotDilog : false,
        updatelotconfirm: false,
        page: 1,
        totalPages: 1,
        totalCount: '',
        pageSize: defaultPageSize,
        pageSizes: defaultPageSizes,
        liq_id:[],
        file:'',
        assign_user_items:[],
        channel_liq_id:[],
        b2b_liq_id:[],
        selected_lot_item_id:'',
        successpopup:false,
        successmessage:'',
        item_details:[],
        edit_inventory:[],
        new_lot_name: '',
        tagIds: [],
        liq_lot_id:[],
        id:'',
        imageUrls:[],
        dialogVisible:false,
        reserveLotPopup:false,
        select_buyer:'',
        add_new_buyer:'',
        buyer_name:'',
        address_line_1:'',
        address_line_2:'',
        city:'',
        state:'',
        alert_type:'info',
        alert_message:'',
        number:'',
        time: null,
        itemsheader:[],
        moveToB2B:false,
        publishDialog:false,
        platform:'',
        createLotDropDown: false,
        pendingPublishPopUp: false,
        InProgressDropDown: false,
        platform_items:[],
        publish_price : '',
        discount: '',
        addImagesPopup : false,
        lotImageNames:[],
        lotImagesUrl:[],
        lotImages: [],
        imagePopup: false,
        lotImagesFileFormat:[],
        publish_start_date:null,
        menu3: false,
        menu_3:false,
        time3: null,
        menu4:false,
        publish_end_date:null,
        isDatePickerPublishEndDate: new Date(),
        menu_4:false,
        time4:null,
        updateSalesPopup:false,
        updatePaymentPopup:false,
        purchaseAmount:'',
        amountReceived:'',
        payment_ref_number:'',
        purchase_amount:'',
        cancelPaymentPopup: false,
        updateDispatchDatePopup: false,
        rows: [],
        dropStaticData: [],
        categoryList : [],
        creationdDate:'',
        action:'',
        biddername:'',
        highestBidId:'',
        usermail:'',  
        highestbid:'',
        itemsWithNullEwasteYes:'',
        ewasteYes:false,
        moqaLotInformation:false,
        reserveLotDisabled:false,
        assignDisabled:false,
        enableButtonContract:false,
        benchmark_price : '',
        showPriceError : false,
        showDiscError : false,
        publishpriceDisable : false,
        discountDisable : false,
        initialLotImagesLength: 0,
        disableB2BActionButton : false,
        movecommbidd:false,
        creationDate: "",
        dataChecking:false,
        publishID:'',
        moveItemCommToMoq: false,
        total_amount :'',
        creatingStatus:'',
        selectedTableItem: [],
        change_disposition_list: [],
        confirmationPopup: false,
        dispositionId: '',
        disposition_action: '',
        organization_name : '',
        viewBidDetailsPopup:false,
        bidheader:[],
        bid_details:[],
        fileErrorMessage:'',
        fileError: false,
        upload_doc:'',
        complaince_image_show:false,
        upload_documents: false,
        select_documents: null,
        select_documents_items: [],
        uploadPercentage: 0,
        upload_file: '',
        uploading: false,
        completed: false,
        confirmButton: 'CONFIRM',
        file_compliance: '',
        file_url: '',
        fileName: '',
        fileDate: '',
        file_data: [],
        add_weight_kg:'',
        add_weight:false,
        upload_doc_view:'',
        fileErrorMessage:'',
        fileError: false,
        currentUser:'',
        item_id:'',
        closed_report:'',
        isPdf: false,
        pdfViewerUrl: '',
        item_weight:'',
        skip_button:true,
        current_user:'',
        contracted_value:'',
        contracted__buyer_items:[],
        contracted_buyer:'',
        user_role:'',
        role:'',
        remarks_confirm_buyer:'',
        confirmBuyerPopup:false,
        select_value:'',
        select_reason:null,
        select_reason_items:[],
        reason_others:'',
        current_user_id:'',
        componentsName : '',
        getRouterLinkText : '',
        getRouterLink : '',
        pending_decision_action : [
          // 'Confirm Buyer',
            // 'Re-Assign Buyer',
            'Assign Buyer',
            'Republish',
            'Delete'],
        select_field_items: [
              {
                "name":"Tag ID",
                "id": "tag_number"
              },
              {
                "name":"Serial Number",
                "id": "serial_number"
              },
              {
                "name":"IRD Number",
                "id": "ird_number"
              },
              {
                "name":"IRRD Number",
                "id": "irrd_number"
              }
          ],
          select_field:null,
          filter_width:'950px',
          sales_action_list: ['Contracted','Competitive Bidding','MOQ']
      }
    },
    computed: {
      filteredTabs() {
        return this.tabs2.filter(tab => {
          return !(tab === "Compliance Docs" && !this.isConfigEnabled('LIQUIDATION_WASTE_FUNCTIONALITY'));
        });
      },
      filteredCreateLotSubTabs() {
        return this.createLotSubTab.filter(tab => {
          return !(tab === "MOQ" && !this.isConfigEnabled('LIQUIDATION_MOQ_FUNCTIONALITY_ENABLED'));
        });
      },
      formattedPurchaseAmount: {
        get() {
          return Number(this.purchase_amount).toLocaleString('en-IN') ;
        },
        set(value) {
          // Remove non-digit characters
          const numericValue = value ? Number(value.replace(/[^0-9.-]+/g, '')) : ''; 
          // Ensure positive value
          this.purchase_amount = Math.max(parseFloat(numericValue), 0);
        }
      },

      publishPriceValidationRules() {
        const rules = [
          v => /^(0|[1-9]\d*)(\.\d+)?$/.test(this.formatNumber(v)) || 'Enter a valid number',
        ];
        return rules;
      },
      
      format_publish_price: {
        get() {
          return Number(this.publish_price).toLocaleString('en-IN');
        },
        set(value) {
          // Parse the formatted value and update the numeric value in the data model
          const numericValue = value && Number(value.replace(/[^0-9.-]+/g, ''));
          this.publish_price = isNaN(numericValue) ? '' : numericValue;
        },
      },


      hasValidationError() {
        const totalAmount = this.amountReceived + parseFloat(this.formatNumber(this.formattedPurchaseAmount));
        return totalAmount > this.purchaseAmount;
      },
      allow_end_time() {
          if(this.selected.length !=0){
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const hours = String(currentDate.getHours()).padStart(2, '0');
            const minutes = String(currentDate.getMinutes()).padStart(2, '0');
            const formattedDate = `${day}/${month}/${year}`;
            const formattedTime = `${hours}:${minutes}`;
            const st_time = `${formattedDate} ${formattedTime}`;
            let bid_start_date = this.dateForCalander(st_time, 'date')
            let bid_start_time = this.dateForCalander(st_time, 'time')
            if(this.time1 !== bid_start_date && (this.bid_start_date === this.bid_end_date)){
              if(!this.time2 || (this.time2 && this.time2<this.time1)){ 
              // this.time2 = this.time1
              this.setComputedValue('time2', 'time1')
            }
              return this.time1
            }else if (bid_start_date && (bid_start_date === this.bid_end_date)) {
              return bid_start_time
            } else {
              return "00:00"
            }
        }
      },
      allow_start_time() {
        if(this.selected.length !=0){
          const currentDate = new Date();
          const currentMinutes = currentDate.getMinutes();
          let minutesToAdd;
          if(IS_QA_SERVER === true){
            minutesToAdd = 5 - (currentMinutes % 5); 
          }else{
            minutesToAdd = 30 - (currentMinutes % 15 || 15);
          }
          const roundedDate = new Date(currentDate.getTime() + minutesToAdd * 60000);
          const year = roundedDate.getFullYear();
          const month = String(roundedDate.getMonth() + 1).padStart(2, '0');
          const day = String(roundedDate.getDate()).padStart(2, '0');
          const hours = String(roundedDate.getHours()).padStart(2, '0');
          const minutes = String(roundedDate.getMinutes()).padStart(2, '0');
          const formattedDate = `${day}/${month}/${year}`;
          const formattedTime = `${hours}:${minutes}`;
          const st_time = `${formattedDate} ${formattedTime}`;
          let bid_start_date = this.dateForCalander(st_time, 'date')
          let bid_start_time = this.dateForCalander(st_time, 'time')
          // this.time1 = bid_start_time
          this.setComputedValue('time1', '', bid_start_time)

          if (bid_start_date && (bid_start_date === this.bid_start_date)) {
            return bid_start_time
          } else {
            return "00:00"
          }
      }
      },
      minium_end_date() {
        let date1 = new Date(this.bid_start_date)
        let date2 = new Date(this.bid_end_date)
        date1.setHours(0,0,0,0)
        date2.setHours(0,0,0,0)
        if (date1.getTime() > date2.getTime()) {
          this.setComputedValue('bid_end_date', 'bid_start_date')

          // this.bid_end_date = this.bid_start_date
          return this.bid_start_date
        } else if (date1.getTime() < date2.getTime()) {
          return this.bid_start_date
        } else if (date1.getTime() === date2.getTime()) {
          return this.bid_start_date
        }
        else {
          return new Date().toISOString().substr(0, 10)
        }
      },
      formattedStartDate() {
        if (this.bid_start_date) {
          const date = new Date(this.bid_start_date);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        }
        return '';
      },
      formattedEndDate(){
        if (this.bid_end_date) {
          const date = new Date(this.bid_end_date);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        }
        return '';
      },
      dateFormattedPublish(){
        if (this.publish_end_date) {
          const date = new Date(this.publish_end_date);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        }
        return '';
      },
      dataTableStyle() {
        // if(this.active_tab === 'Create Lots (ComBid)' && window.innerWidth < 1440){
        //   return { height: 'calc(var(--vh, 1vh) * 100 - 425px) !important' }
        // } 
        if(this.closed_report === 'Closed'){
          return { height: 'calc(var(--vh, 1vh) * 100 - 295px) !important' }
        }
        else {
          return { height: 'calc(var(--vh, 1vh) * 100 - 363px) !important' }
        }
        // }
            
      },
      isConfirmDisabled() {
        if (this.select_value === 'confirm_buyer') {
          // Confirm buyer case: remarks are required
          return !this.remarks_confirm_buyer;
        } else if (this.select_value === 're_assign_buyer' || this.select_value === 'reject_from_pending') {
          // Reassign buyer case: reason is required
          if (this.select_reason === 'Others') {
            return !this.reason_others;
          }
          return !this.select_reason;
        }else if(this.select_value === 'approvefrom_pending'){
          return false;
        }
        return true;
      }
    },
    async created() {
      this.organization_name = this.$store.state.organization_name;
      this.action = this.$store.state.action;
      this.current_user = this.$store.state.currentUser.roles[0]
      this.current_user_id = this.$store.state.currentUser.id
      this.role = this.user_role = this.$store.state.currentUser.roles[0]
      if(this.user_role in module_that_allowed && moduleAccessFunc(this.user_role,'Liquidation')){
        signout()
        return;
      }
      this.pending_app_item = this.$store.state.pending_approval_item
      if(!this.isConfigEnabled('LIQUIDATION_MOQ_FUNCTIONALITY_ENABLED')){
        this.sales_action_list = this.sales_action_list.filter(item => item !== 'MOQ')
      }
      
      if(this.pending_app_item && (this.pending_app_item.type_of_approval == 'Buyer lot Assign below Reserve Price' || this.pending_app_item.type_of_approval == 'Buyer lot Assigned other than highest bidder')){
          this.componentsName = 'Liquidation',
          this.getRouterLinkText = 'Pending Approval',
          this.getRouterLink = { name : 'physicalinspectionApproval'}
      } else {
          this.componentsName = '',
          this.getRouterLinkText = '',
          this.getRouterLink = ''
      }
      this.closed_report = this.$store.state.active_tab;
      if(this.closed_report != 'Closed')
        this.tabs2.splice(7,1)
      this.$store.state.action = '';
      this.scrollToTop();
      this.getdisposition();
      if(this.user_role == 'finance_manager'){
        this.tab_index = 7
        this.loadData('Pending Payment');
        return;
      }
      if(this.action == 'create_moq'){
        this.tab_index = 2;
        this.loadData('MOQ','tab_clicked');
        this.successmessage=this.$store.state.responseMessage;
          if(this.successmessage !== undefined && this.successmessage !== ''){
            this.successpopup = true
          }else if(this.successmessage === undefined){
            this.successpopup = false
          }
       }else if(this.action == 'edit_lot' || this.action == 'edit_moq'){
        this.tab_index = 3;
        this.loadData('B2B','subtab_clicked2');
        this.successmessage=this.$store.state.responseMessage;
        if(this.successmessage !== undefined && this.successmessage !== ''){
          this.successpopup = true
        }else if(this.successmessage === undefined){
          this.successpopup = false
        }
      }else if(this.action == 'edit_lot_view'){
        this.tab_index = 4;
        this.loadData('B2B','subtab_clicked3');
        this.successmessage=this.$store.state.responseMessage;
        if(this.successmessage !== undefined && this.successmessage !== ''){
          this.successpopup = true
        }else if(this.successmessage === undefined){
          this.successpopup = false
        }
      }else if(this.action == 'create_lot'){
        this.tab_index = 2;
        this.loadData('Competitive','tab_clicked');
        this.successmessage=this.$store.state.responseMessage;
        if(this.successmessage !== undefined && this.successmessage !== ''){
          this.successpopup = true
          }else if(this.successmessage === undefined){
            this.successpopup = false
          }
      }else if(this.action == 're_publish'){
        this.tab_index = 5;
        this.loadData('Pending Decision','tab_clicked');
        this.successmessage=this.$store.state.responseMessage;
          if(this.successmessage !== undefined && this.successmessage !== ''){
            this.successpopup = true
          }else if(this.successmessage === undefined){
            this.successpopup = false
          }
      }else if(this.action == 're_publish_return'){
        this.tab_index = 5;
        this.loadData('Pending Decision');
        this.$store.commit("setMessage", {lotIds:  JSON.stringify([])});
      }else if(this.action == 're_publish_return_payment'){
        this.tab_index = 7;
        this.loadData('Pending Payment');
        this.$store.commit("setMessage", {lotIds:  JSON.stringify([])});
      }else if(this.action == 'pending_dispatch_file_upload'){
        this.tab_index = 8;
        this.loadData('Pending dispatch confirmation & Time')
      }else if(this.closed_report === 'Closed'){
        this.headerText = "Closed Reports";
        this.tab_index = 11;
        this.loadData('Closed');
      }else{
        const tabName = this.$route.query.tab;
        if(!tabName){ this.tab_index = 0; this.loadData('Channel Allocation','tab_clicked'); }
        else if(tabName == 'Channel_Allocation'){ this.tab_index = 0; this.loadData('Channel Allocation'); }
        else if(tabName == 'Price_Discovery_Method'){ this.tab_index = 1; this.loadData('Price Discovery Method'); }
        else if(tabName == 'Create_Lots_Con'){ this.tab_index = 2; this.loadData('Create Lots (Con)'); }
        else if(tabName == 'Create_Lots_ComBid'){ this.tab_index = 2; this.loadData('Create Lots (ComBid)'); }
        else if(tabName == 'Create_Lots_MOQ'){ this.tab_index = 2; this.loadData('Create Lots (MOQ)'); }
        else if(tabName == 'Pending_B2B_Publish'){ this.tab_index = 3; this.loadData('Pending B2B Publish'); }
        else if(tabName == 'Pending_B2C_Publish'){ this.tab_index = 3; this.loadData('Pending B2C Publish'); }
        else if(tabName == 'In_Progress_B2B'){ this.tab_index = 4; this.loadData('In Progress B2B'); }
        else if(tabName == 'In_Progress_B2C'){ this.tab_index = 4; this.loadData('In Progress B2C'); }
        else if(tabName == 'Pending_Decision'){ this.tab_index = 5; this.loadData('Pending Decision'); }
        else if(tabName == 'Pending_Approval'){ this.tab_index = 6; this.loadData('Pending Approval'); }
        else if(tabName == 'Pending_Payment'){ this.tab_index = 7; this.loadData('Pending Payment'); }
        else if(tabName == 'Pending_dispatch_confirmation__Time'){ this.tab_index = 8; this.loadData('Pending dispatch confirmation & Time'); }
        else if(tabName == 'Pending_ORRD'){ this.tab_index = 9; this.loadData('Pending ORRD'); }
        else if(tabName == 'Compliance_Docs'){ this.tab_index = 11; this.loadData('Compliance_Docs'); }
        else if(tabName == 'Dispatch'){ this.tab_index = 10; this.loadData('Dispatch'); }
      }
      this.getCategoriesList();
      
    },
    components: {
        HeaderComponent, Loading, inlineTimePicker, JwPagination
    },
    watch: {
      selected(newVal) {
      
        this.disableB2BActionButton = false;
        const putawayInward = newVal.filter(liquidation => liquidation.is_putaway_inwarded === false)
        const isUnderPhysicalInspection = newVal.filter((insurances) => insurances.is_under_physical_inspection === true);
        const floor_price_valid = newVal.filter(liquidation => (liquidation.floor_price === "" || liquidation.floor_price === null || liquidation.floor_price === 0))
        let lotPendong = newVal.filter(liquidation => liquidation.republish_status === "pending")
        let lotError = newVal.filter(liquidation => liquidation.republish_status === "error")
        if(putawayInward.length > 0){
          this.showAlert("warning", "Please complete Putaway Process");
          this.selected.splice(0);
          this.$nextTick(() => {
            this.selectedTableItem.splice(0);
          });
        }else if(isUnderPhysicalInspection.length > 0) {
            this.showAlert("warning", "Action on item blocked as it is under cycle count process");
            this.selected.splice(0);
            this.$nextTick(() => {
              this.selectedTableItem.splice(0);
            });
          }
        if(this.active_tab === 'Pending B2B Publish'){
          if(lotError.length > 0 || lotPendong.length > 0){
            // this.selected = []
            this.disableB2BActionButton = true;
          }
        }

        if(floor_price_valid.length > 0 && this.active_tab === 'Create Lots (ComBid)'){
            this.showAlert("warning", "Please update floor price");
            // this.selected.splice(0); 
            // this.$nextTick(() => {
            //   this.selectedTableItem.splice(0); 
            // });
          }
        
      },
      selectedTableItem(newVal) {
        if(newVal.length){
          this.selected = newVal.map((item) => {
                const formattedItem = { ...item };
                      this.headers.forEach((header) => {
                        if (header.title.includes("₹")) {
                          formattedItem[header.value] = this.formatNumber(item[header.value]);   
                        }
                      });
                return formattedItem;
        });
        }else{
          this.selected = []
        }
      },
    },
    mounted() {
      document.addEventListener('click', this.handleOutsideClick);
    },
    beforeDestroy() {
      document.removeEventListener('click', this.handleOutsideClick);
    },
    methods: {
      isConfigEnabled(constantName) {
        const config = this.$store.state.configurations.filter(item => item.constant === constantName);
        return config.length ? config[0].is_enabled : {};
      },
      isActionAllowed(){
        return !isOnlyViewAction(this.role, 'Liquidation')
      },
      handleLocationInput(){
        this.Liquidation_search = this.Liquidation_search.trim();
        // this.Liquidation_search = this.Liquidation_search.replace(/\s+/g, '');
        // this.Liquidation_search = this.Liquidation_search.replace(/[^a-zA-Z,\d-]/g, '')
      },
      handleOutsideClick(event) {
        const container1 = this.$refs.createLotDropDownContainer;
        if (container1 && !container1.contains(event.target) && this.createLotDropDown) {
          this.createLotDropDownFunction();
        }
        const container2 = this.$refs.pendingPublishDropDownContainer;
        if (container2 && !container2.contains(event.target) && this.pendingPublishPopUp) {
          this.pendingPublishDropDownFunction();
        }
        const container3 = this.$refs.inProgressDropDownContainer;
        if (container3 && !container3.contains(event.target) && this.InProgressDropDown) {
          this.inProgressDropDownFunction();
        }
    },

    formatted_table_data(table_data){
      return table_data.map((item) => {
               const formattedItem = { ...item };
                    this.headers.forEach((header) => {
                      if (header.title.includes("₹")) {
                        formattedItem[header.value] = this.formatCurrency(item[header.value]);
                      }
                    });
               return formattedItem;
      });
    },

    setComputedValue(setStateName, formStateValue, value){
      this[setStateName] = this[formStateValue] || value
    },
    formatCurrency(value){
      return Number(value).toLocaleString('en-IN');
    },
    formatNumber(value){
        return typeof value === 'string' ? Number(value.replace(/,/g, '')) : value
    },
      createLotDropDownFunction(){
        if(this.createLotDropDown){
          this.createLotDropDown = false;
          this.tab_index = this.prev_tabIndex;
        } else {
          this.createLotDropDown = true;
        }
      },
      pendingPublishDropDownFunction(){
        if(this.pendingPublishPopUp){
          this.pendingPublishPopUp = false;
          this.tab_index = this.prev_tabIndex;
        } else {
          this.pendingPublishPopUp = true;
        }
      },
      inProgressDropDownFunction(){
        if(this.InProgressDropDown){
          this.InProgressDropDown = false;
          this.tab_index = this.prev_tabIndex;
        } else {
          this.InProgressDropDown = true;
        }
      },
      allowedStep: m => m % 15 === 0, 
      scrollToTop() {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        },
        mapped_tab(tab){
          if(tab == 'Channel Allocation') return 'Channel';
          else if(tab == 'Price Discovery Method') return 'Sales Method'
          else if(tab == 'Create Lots' || tab == 'Create Lots (ComBid)') return 'Create Lots'
          else if(tab == 'Pending Publish' || tab == 'Pending B2B Publish' || tab == 'Pending B2C Publish') return 'Publish'
          else if(tab == 'In Progress' || tab == 'In Progress B2B' || tab == 'In Progress B2C') return 'In Progress'
          else if(tab == 'Pending Decision') return 'Pending Dec'
          else if(tab == 'Pending Payment') return 'Pending Pmt'
          else if(tab == 'Pending dispatch confirmation & Time')  return 'Lot Handover'
          else if(tab == 'Pending Approval') return 'Lot Approval'
          else return tab
        },
      loadData(tab, tab_action) {
          this.createLotDropDown = false;
          this.pendingPublishPopUp = false;
          this.InProgressDropDown = false;
          if(tab == "Create Lots (Con)" || tab == "Create Lots (ComBid)" || tab == "Create Lots (MOQ)") { this.selectedCreateLotSubtab = tab; }
          else if(tab == 'Contracted'){ this.selectedCreateLotSubtab = "Create Lots (Con)"; tab = this.selectedCreateLotSubtab;}
          else if(tab == 'Competitive') { this.selectedCreateLotSubtab = "Create Lots (ComBid)"; tab = this.selectedCreateLotSubtab;} 
          else if(tab == 'MOQ'){ this.selectedCreateLotSubtab = "Create Lots (MOQ)"; tab = this.selectedCreateLotSubtab;}
          else { this.selectedCreateLotSubtab = "Create Lots";}

          if(tab == "Pending B2B Publish" || tab == "Pending B2C Publish") { this.selectedPendingPublishSubtab = tab; }
          else if(tab == "In Progress B2B" || tab == "In Progress B2C") { this.selectedInProgrssSubtab = tab; }
          else if(tab == 'B2B'){ if(tab_action === 'subtab_clicked2') {this.selectedPendingPublishSubtab = "Pending B2B Publish"; tab = this.selectedPendingPublishSubtab; this.selectedInProgrssSubtab = "In Progress";} else {this.selectedInProgrssSubtab = "In Progress B2B"; tab = this.selectedInProgrssSubtab; this.selectedPendingPublishSubtab = "Pending Publish";} }
          else if(tab == 'B2C') { if(tab_action === 'subtab_clicked2') {this.selectedPendingPublishSubtab = "Pending B2C Publish"; tab = this.selectedPendingPublishSubtab; this.selectedInProgrssSubtab = "In Progress";} else {this.selectedInProgrssSubtab = "In Progress B2C"; tab = this.selectedInProgrssSubtab; this.selectedPendingPublishSubtab = "Pending Publish";} } 
          else { this.selectedPendingPublishSubtab = "Pending Publish"; this.selectedInProgrssSubtab = "In Progress";}

          if(tab_action){
            this.Liquidation_search = ''
            this.select_field = null;
            var tabName = tab.replace(/\s/g,'_');
            tabName = tabName.split('(').join('');
            tabName = tabName.split(')').join('');
            tabName = tabName.replace(/&/g,'')
            this.$router.push({ name : 'liquidationNew', query : { tab : tabName } });
          }
          this.loading = true;
          this.selectedTableItem = []
          this.active_tab = tab
          this.table_data = []
          this.page = 1
          this.totalPages = 1
          this.dataChecking = false
          this.rows = []
          this.select_field_items= [
              {
                "name":"Tag ID",
                "id": "tag_number"
              },
              {
                "name":"Serial Number",
                "id": "serial_number"
              },
              {
                "name":"IRD Number",
                "id": "ird_number"
              },
              {
                "name":"IRRD Number",
                "id": "irrd_number"
              }
          ];
          if (tab == "Channel Allocation") {
            (this.headers = [
              {title: "Tag ID", key: "tag_number", sortable:false},
              {title: "Article ID", key: "article_id", minWidth: "200px"},
              {title: "Article Description", key: "article_description", minWidth: "200px"},
              {title: "Category", key: "category",},
              {title: "Grade", key:"grade"},
              {title: (this.$isRelianceClient() ? "ASP Price (₹)" : "Benchmark Price (₹)"), key:"bench_mark_price", minWidth: "200px"},
              {title: "E-waste?", key:"ewaste", minWidth: "200px"},
              {title: "Ageing", key:"disposition_age"},
              {title: "City", key:"destination_city"},
              {title: "Sub-Location", key:"sub_location_name"},
              {title: "IRRD Number", key: "irrd"},
              {title: "IRD Number", key:"ird"},
              {title: "Serial Number ", key: "serial_number" },
            ]);
            this.channelAllocation();
            this.prev_tabIndex=0;
          }
          if (tab == "Price Discovery Method") {
            (this.headers = [
              {title: "Tag ID", key: "tag_number", sortable:false, minWidth:"200px" },
              {title: "Article ID", key: "article_id", minWidth:"200px" },
              {title: "Article Description", key: "article_description", minWidth: "200px", minWidth:"200px" },
              {title: "Category", key: "category", minWidth:"200px" },
              {title: "Grade", key:"grade", minWidth:"200px" },
              {title: (this.$isRelianceClient() ? "ASP Price (₹)" : "Benchmark Price (₹)"), key:"bench_mark_price", minWidth:"200px" },
              {title: "E-waste?", key:"ewaste", minWidth: "200px", minWidth:"200px" },
              {title: "Ageing", key:"disposition_age"},
              {title: "Sub-Location", key:"sub_location_name"},
              {title: "IRRD Number", key: "irrd"},
              {title: "IRD Number", key:"ird"},
              {title: "Serial Number ", key: "serial_number" },
            ]);
            this.pricediscovery();
            this.prev_tabIndex=1;
          }
          if (tab == "Create Lots (Con)") {
            (this.headers = [
              {title: "Tag ID", key: "tag_number", sortable:false, minWidth:"200px" },
              {title: "Article ID", key: "article_id", minWidth: "200px"},
              {title: "Article Description", key: "article_description", minWidth:"200px" },
              {title: "Category", key: "category", minWidth:"200px" },
              {title: "Grade", key:"grade", minWidth:"200px" },
              {title: "Contracted Value (₹)", key:"salvage_value", minWidth:"200px" },
              {title: "E-waste?", key:"ewaste", minWidth: "200px"},
              {title: "Ageing", key:"disposition_age"},
              {title: "Sub-Location", key:"sub_location_name"},
              {title: "IRRD Number", key: "irrd"},
              {title: "IRD Number", key:"ird"},
              {title: "Serial Number ", key: "serial_number" },
            ]);
            this.create_lotCon();
            this.prev_tabIndex=2;
          }
          if (tab == "Create Lots (ComBid)") {
            (this.headers = [
              {title: "Tag ID", key: "tag_number", sortable:false, minWidth:"200px" },
              {title: "Article ID", key: "article_id", minWidth: "200px"},
              {title: "Article Description", key: "article_description", minWidth:"200px" },
              {title: "Category", key: "category", minWidth:"200px" },
              {title: "Grade", key:"grade", minWidth:"200px" },
              {title: (this.$isRelianceClient() ? "ASP Price (₹)" : "Benchmark Price (₹)"), key:"bench_mark_price", minWidth: "200px"},
              {title: "E-waste?", key:"ewaste", minWidth: "200px"},
              {title: "Ageing", key:"disposition_age"},
              {title: "City", key:"destination_city", minWidth: "200px"},
              {title: "Sub-Location", key:"sub_location_name"},
              {title: "IRRD Number", key: "irrd"},
              {title: "IRD Number", key:"ird"},
              {title: "Serial Number ", key: "serial_number" },
            ]);
            this.create_lotCombid();
            this.prev_tabIndex=2;
          }
          if (tab == "Create Lots (MOQ)") {
            (this.headers = [
              {title: "Tag ID", key: "tag_number", sortable:false},
              {title: "Article ID", key: "article_id", minWidth: "200px"},
              {title: "Article Description", key: "article_description", minWidth: "200px"},
              {title: "Category", key: "category", minWidth: "200px"},
              {title: "Grade", key:"grade", minWidth: "200px"},
              {title: (this.$isRelianceClient() ? "ASP Price (₹)" : "Benchmark Price (₹)"), key:"bench_mark_price", minWidth: "200px"},
              {title: "E-waste?", key:"ewaste", minWidth: "200px"},
              {title: "Ageing", key:"disposition_age"},
              {title: "City", key:"destination_city", minWidth: "200px"},
              {title: "Sub-Location", key:"sub_location_name"},
              {title: "IRRD Number", key: "irrd"},
              {title: "IRD Number", key:"ird"},
              {title: "Serial Number ", key: "serial_number" },
            ]);
            this.createLotsMOQ();
            this.prev_tabIndex=2;
          }
          if (tab == "Pending B2B Publish") {
            (this.headers = [
              {title: "Lot ID", key: "lot_id", minWidth: "200px"},
              {title: "Lot Name", key: "lot_name", minWidth: "200px"},
              {title: "Price Discovery Method", key: "price_discovery_method", minWidth: "200px"},
              {title: "Status", key: "publishable_status", minWidth: "200px"},
              {title: "Bid Start Date & Time", key:"start_date", minWidth: "200px"},
              {title: "Bid End Date & Time", key:"end_date", minWidth: "200px"}
            ]);
            this.pendingB2b_publish();
            this.prev_tabIndex=3;
          }
          if (tab == "In Progress B2B") {
            (this.headers = [
              {title: "Publish ID", key: "beam_lot_id", minWidth: "200px"},
              {title: "Lot ID", key: "lot_id"},
              {title: "Lot Name", key: "lot_name", minWidth: "200px"},
              {title: "Price Discovery Method", key: "price_discovery_method", minWidth: "200px"},
              {title: "Bid Start Date & Time", key:"start_date", minWidth: "200px"},
              {title: "Bid End Date & Time", key:"end_date", minWidth: "200px"},
              {title: "No. Of Unique Bids", key: "uniq_bids_no", minWidth: "200px"},
              {title: "Highest Bid (₹)", key: "higest_bid", minWidth: "200px"}
            ]);
            this.inProgressB2B();
            this.prev_tabIndex=4;
          }
          if (tab == "Pending Decision") {
            (this.headers = [
              {title: "Publish ID", key: "beam_lot_id", minWidth: "200px"},
              {title: "Lot ID", key: "lot_id" },
              {title: "Lot Name", key: "lot_name", minWidth: "200px"},
              {title: "Price Discovery Method", key: "price_discovery_method", minWidth: "230px"},
              {title: "Reserve Price (₹)", key:"reserve_price", minWidth: "200px"},
              {title: "No. Of Unique Bids", key: "uniq_bids_no", minWidth: "200px"},
              {title: "Highest Bid (₹)", key: "higest_bid", minWidth: "200px"},
              {title: "Lot Status", key: "lot_bid_status", minWidth: "200px"},
              { title: "Attach Doc", key: "action"}
            ]);
            this.pendingDecision();
            this.prev_tabIndex=5;
          }
          if (tab == "Pending Approval") {
            (this.headers = [
              { title: "Publish ID", key: "publish_id"},
              { title: "Lot ID", key: "lot_id"},
              {title: "Lot Name", key: "lot_name", minWidth: "200px"},
              // { title: "Lot Description", key: "lot_desc"},
              { title: "Liquidation Benchmark Price (₹)", key: "liquidation_benchmark_price"},
              { title: "Recovery Benchmark Price (₹)", key: "recovery_benchmark_price"},
              { title: "Floor Price (₹)", key: "floor_price"},
              { title: "Reserve Price (₹)", key: "reserve_price"},
              { title: "Highest Bid (₹)", key: "higest_bid"},
              { title: "Assigned Buyer Price (₹)", key: "higest_bid"},
              { title: "Assigned Buyer Name (₹)", key: "winning_buyer"},
              { title: "Recovery %", key: "recovery_percent"},
              { title: "Pending Approval At", key: "pending_approval_at"},
              // { title: "Price Discovery Method", key: "price_discovery_method"},
              // { title: "Approval Decision", key:"status"},
              { title: "Reason", key: "reason"},
              { title: "Comment", key: "comments"},
              // { title: "Winner Buyer", key: "winning_buyer"},
              { title: "Attach Doc", key: "action"}
              // { title: "Pending Approval At", value: "pending_approval_at"},
            ]);
            this.pendingApproval();
            this.prev_tabIndex=5;
          }
          if (tab == "Pending B2C Publish") {
            (this.headers = [
              {title: "Tag ID", key: "tag_number", sortable:false, minWidth: "200px"},
              {title: "Article ID", key: "article_id"},
              {title: "Article Description", key: "article_description", minWidth: "200px"},
              {title: "Category", key: "category", minWidth: "200px"},
              {title: "Grade", key:"grade", minWidth: "200px"},
              {title: (this.$isRelianceClient() ? "ASP Price (₹)" : "Benchmark Price (₹)"), key:"bench_mark_price", minWidth: "200px"},
            ]);
            this.pendingB2CPublish();
            this.prev_tabIndex=3;
          }
          if (tab == "In Progress B2C") {
            (this.headers = [
              {title: "Article ID", key: "article_id", minWidth: "200px"},
              {title: "Article Description", key: "article_description", minWidth: "200px"},
              {title: "Grade", key:"grade"},
              {title: "Platform", key:"platform"},
              {title: "Quantity", key:"quantity"},
            ]);
            this.inProgressB2C();
            this.prev_tabIndex=4;
          }
          if (tab == "Pending Payment") {
            (this.headers = [
              {title: "Publish ID", key: "beam_lot_id", minWidth: "200px"},
              {title: "Lot ID", key: "lot_id", width: '10%', sortable:false, minWidth: "200px"},
              {title: "Lot name", key: "lot_name", minWidth: "200px"},
              {title: "Organization Name", key: "buyer_organization_name"},
              {title: "Buyer Name", key: "buyer_name", minWidth: "200px"},
              {title: "Purchase Amount (₹)", key:"purchase_amount", minWidth: "200px"},
              {title: "Payment Received (₹)", key:"amount_received", minWidth: "200px"},
              {title: "Status", key:"status", minWidth: "200px"},
              { title: "Attach Doc", key: "action"}
            ]);
            this.pendingPayment();
            this.get_vendor_liquidation();
            this.prev_tabIndex=6;
          }
          if (tab == "Pending dispatch confirmation & Time") {
            (this.headers = [
              {title: "Publish ID", key: "beam_lot_id", minWidth: "200px"},
              { title: "Lot ID", key: "lot_id"},
              {title: "Lot name", key: "lot_name", minWidth: "200px"},
              {title: "SO Number", key: "so_number", minWidth: "200px"},
              { title: "Organization Name", key: "buyer_organization_name"},
              {title: "Buyer Name", key: "buyer_name", minWidth: "200px"},
              {title: "Purchase Amount (₹)", key:"purchase_amount", minWidth: "200px"},
              {title: "Dispatch Date", key:"dispatch_date", minWidth: "200px"},
              { title: "Attach Doc", key: "action"}
            ]);
            this.pendingDispatchConfirmTime();
            this.prev_tabIndex=7;
          }
          if (tab == "Pending ORRD") {
            (this.headers = [
              {title: "Publish ID", key: "beam_lot_id", minWidth: "200px"},
              { title: "Lot ID", key: "lot_id"},
              {title: "Lot name", key: "lot_name", minWidth: "200px"},
              {title: "SO Number", key: "so_number", minWidth: "200px"},
              { title: "Organization Name", key: "buyer_organization_name"},
              {title: "Buyer Name", key: "buyer_name", minWidth: "200px"},
              {title: "Purchase Amount (₹)", key:"purchase_amount", minWidth: "200px"},
              {title: "Dispatch Date", key:"dispatch_date", minWidth: "200px"},
              {title: "ORRD Request ID", key: "orrd_request_id", minWidth: "200px"},
              { title: "Attach Doc", key: "action"}
            ]);
            this.pendingOrrd();
            this.prev_tabIndex=8;
          }
          if (tab == "Dispatch") {
            (this.headers = [
              {title: "Publish ID", key: "beam_lot_id", minWidth: "200px"},
              {title: "Lot ID", key: "lot_id"},
              {title: "Lot name", key: "lot_name", minWidth: "200px"},
              {title: "SO Number", key: "so_number", minWidth: "200px"},
              { title: "Organization Name", key: "buyer_organization_name"},
              {title: "Buyer Name", key: "buyer_name", minWidth: "200px"},
              {title: "Purchase Amount (₹)", key:"purchase_amount", minWidth: "200px"},
              {title: "Invoice Number", key:"invoice_number", minWidth: "200px"},
              {title: "Invoice Value", key:"invoice_value", minWidth: "200px"},
              {title: "Dispatch Status", key:"warehouse_order_status", minWidth: "200px"},
              { title: "Attach Doc", key: "action"}
            ]);
            this.dispatch();
            this.prev_tabIndex=10;
          }
          if(tab == "Compliance Docs"){
            (this.headers = [
            { title: "Publish ID", key: "beam_lot_id", minWidth: "200px"},
            {title: "Lot ID", key: "lot_id"},
            { title: "Lot name", key: "lot_name", minWidth: "200px"},
            { title: "Organization Name", key: "buyer_organization_name"},
            { title: "Buyer Name", key: "buyer_name", minWidth: "200px"},
            {title: "Ageing (In Days)", key:"purchase_amount", minWidth: "200px"},
            {title: "Location", key:"buyer_name", minWidth: "200px"},
            {title: "Pending Status", key:"remaning_compliance_documents", minWidth: "200px"},
            { title: "Action", key: "action", minWidth: "200px"}
          ]);
          this.complianceDocs();
          this.prev_tabIndex=8;
        }
        if (tab == "Closed") {
          (this.headers = [
            { title: "Publish ID", key: "beam_lot_id", minWidth: "200px"},
            { title: "Lot ID", key: "lot_id"},
            { title: "Lot name", key: "lot_name", minWidth: "200px"},
            // { title: "SO Number", key: "so_number"},
            { title: "Organization Name", key: "buyer_organization_name"},
            { title: "Buyer Name", key: "buyer_name", minWidth: "200px"},
            { title: "Action Date", key: "start_date", minWidth: "200px"},
            { title: "Lot Closure Date", key: "end_date", minWidth: "200px"},
            { title: "Dispatch Date", key: "dispatch_date", minWidth: "200px"},
            { title: "Location", key: "location", minWidth: "200px"},
            // {title: "Purchase Amount (₹)", key:"purchase_amount"},
            // {title: "Invoice Number", key:"invoice_number"},
            // {title: "Invoice Value", key:"invoice_value"},
            // {title: "Dispatch Status", key:"warehouse_order_status"},
            {title: "Upload Documents", key:"compliance_documents", minWidth: "200px"},
          ]);
          this.closedTabData();
          this.prev_tabIndex=10;
        }
        if (tab == "Pending For Approval") {
          this.headers = [
                    { title: "Location", key: "location"},
                    { title: "IRD", key: "ird" },
                    { title: "Tag ID", key: "tag_number" },
                    { title: "Article ID", key: "article_id" },
                    { title: "Article Description", key: "article_description"},
                    { title: "Lot ID", key: "lot_id" },
                    { title: "Publish ID", key: "publish_id"},
                    { title: "Recovery Benchmark Price", key: "recovery_benchmark_price" },
                    { title: "Serial No.1", key: "serial_number" },
                    { title: "Serial No.2", key: "serial_number2"},
                    { title: "Approval Type", key: "approval_rule_type"},
                    { title: "Pending At", key: "next_approver_details"}
                ];
          this.select_field_items = [
             {
                "name":"Tag ID",
                "id": "tag_number"
              },
              {
                "name":"IRD",
                "id": "ird_number"
              },
              {
                "name":"Lot ID",
                "id": "lot_id"
              },
              {
                "name":"Publish ID",
                "id": "publish_id"
              },
              {
                "name":"Pending at",
                "id": "pending_at"
              }];
          this.fetchPendingForApproval();
          this.prev_tabIndex=10;
        }

        if(this.active_tab == "AI-Lot-Optimization"){
          this.$router.push({ name : 'MilPricingPage' });
        }
          
      },

    dateForCalander(date_str, type){
        //input    =  5/02/2021 08:32 AM
        // date op = '2021-02-05'
        // time op = 08:32
        if(date_str == null || date_str == '' || date_str == undefined){
          date_str = this.todaysDate();
        }
        var output = '';
        if('date' == type){
          var arr = date_str.substr(0,10).split('/');
          output  = arr[2]+'-'+arr[1]+'-'+arr[0]
        }else{
          output  = date_str.substr(11,8).split(' ')[0]
        }
        return output
      },
       getCategoriesList(){
        this.$httpSecured.get("/api/v2/warehouse/liquidation/channel_allocations/formatted_category_list")
        .then(response => {
          if(response.data.category_list){
            this.categoryList = response.data.category_list  
            this.dropStaticData = response.data.category_list
            // this.loading = false;
            this.selected = [];
          }else{
            this.loading = true;
          }
        })
        .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
        });
    },

    filterListOfButtons() {
      this.dropStaticData = this.categoryList;
      this.filter_width = "950px"
         if(window.innerWidth > 1400 && window.innerWidth < 1500)
             this.filter_width = "1050px"
         else if(window.innerWidth >= 1500 && window.innerWidth < 1600)
             this.filter_width = "1150px"
         else if(window.innerWidth >= 1600)
             this.filter_width = "1250px"
      if(this.table_data.length > 0) {
        this.filteWithSubPopup = true;
      }else if(this.dataChecking){
        this.filteWithSubPopup = true;
      }
      this.number = 0
      this.setFilterInputfields();
      document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top).toString() + 'px');
    },
    handleOpenDispositionDialog(row, ref) {
      row.nextDialog = true
      document.documentElement.style.setProperty('--dialog-leftpos', (this.$refs[ref] && this.$refs[ref][0].$el.getBoundingClientRect().left - 20).toString() + 'px');
      document.documentElement.style.setProperty('--dialog-yposi', (this.$refs[ref] && this.$refs[ref][0].$el.getBoundingClientRect().top + 60).toString() + 'px');
    },
    handleCloseFilterPopup() {
      // this.rows = []
      this.dropStaticData = ""
      this.filteWithSubPopup = false;
    },
    getRowMenuItems(key)
 {
      let myArray = this.table_data.map(data => data[key]).filter(value => value)
      return [...new Set(myArray)].map(data => ({ label: data, value: "" }))
    },
    setFilterInputfields() {
      const selectedValues = {};
      for (const row of this.rows) {
        selectedValues[row.label] = row.value;
      }

      let rows = []
      let ewaste = [{ label: "Yes", value: "" }, { label: "No", value: "" }, { label: "Not defined", value: "" }]
      let puttawayList = [{ label: "Pending", value: "" }, { label: "Completed", value: "" }]
      let lotStatus = [{ label: "Highest Bid More than Reserve Price", value: "Highest Bid More than Reserve Price" },{ label: "Highest Bid Less than Reserve Price", value: "Highest Bid Less than Reserve Price" }, { label: "No Bid", value: "No Bid" }]
      let price_discovery_method = [{ label: "Competitive Bidding", value: "Competitive Lot" }, { label: "MOQ", value: "MOQ Lot" }]
      let grades = [{ label: "A", value: "" }, { label: "B", value: "" }, { label: "C", value: "" }, { label: "D", value: "" }, { label: "AA", value: "" }, { label: "Not Tested", value:"" }]

      if (["Channel Allocation"].includes(this.active_tab)) {
        rows = [
          // { element: "dropdownwithaction", label: "Tag ID", inputTag: "selectWithCheckBox", nextDialog: false, parentData: [], menuItems: this.getRowMenuItems('tag_number') },
          // { element: "dropdownwithaction", label: "Article ID", inputTag: "selectWithCheckBox", nextDialog: false, parentData: [], menuItems: this.getRowMenuItems("article_id") },
          { element: "dropdownwithaction", label: "Category", inputTag: "checkBox", nextDialog: false, parentData: [] },
          { element: "select&search", label: "Grade", multiple: true, menuItems: grades, value: [] },
          { element: "select&search", label: "E-waste", multiple: true, menuItems: ewaste, value: [] },
          { element: "select&search", label: "Putaway Status", multiple: false, menuItems: puttawayList, value: null },

        ]
      } else if (["Price Discovery Method", "Create Lots (Con)", "Create Lots (ComBid)", "Create Lots (MOQ)"].includes(this.active_tab)) {
        rows = [
          { element: "select&search", label: "Grade", multiple: true, menuItems: grades, value: [] },
          { element: "dropdownwithaction", label: "Category", inputTag: "checkBox", nextDialog: false, parentData: [] },
          { element: "select&search", label: "E-waste", multiple: true, menuItems: ewaste, value: [] },
          { element: "select&search", label: "Putaway Status",multiple: false, menuItems: puttawayList, value: null },
        ]
      } else if (['Pending B2B Publish'].includes(this.active_tab)) {
        let status = [{ label: "Ready for Publishing", value: "Ready for publishing" }, { label: "Pending Lot Details", value: "Pending lot details" }]
        rows = [
          { element: "select&search", label: "Price Discovery Method", multiple: true, menuItems: price_discovery_method, value: [] },
          { element: "select&search", label: "Status", multiple: true, menuItems: status, value: [] },
        ]
      } else if (["In Progress B2B"].includes(this.active_tab)) {
        rows = [
          { element: "select&search", label: "Price Discovery Method", multiple: true, menuItems: price_discovery_method, value: [] },
        ]
        // ["Channel Allocation","Price Discovery Method", "Pending B2C Publish" , "Create Lots (Con)", "Create Lots (ComBid)"].includes(this.active_tab)
      }else if (["Pending Decision"].includes(this.active_tab)) {
        rows = [
          { element: "select&search", label: "Price Discovery Method", multiple: true, menuItems: price_discovery_method, value: [] },
          { element: "select&search", label: "Lot Status",multiple: false, menuItems: lotStatus, value: null },
        ]
      }else if (["Pending B2C Publish"].includes(this.active_tab)) {
        rows = [
          { element: "dropdownwithaction", label: "Category", inputTag: "checkBox", nextDialog: false, parentData: [], value: [] },
          { element: "select&search", label: "Grade", multiple: true, menuItems: grades, value: [] },
        ]
      } else if (["In Progress B2C"].includes(this.active_tab)) {
        rows = [
          { element: "select&search", label: "Grade", multiple: true, menuItems: grades, value: [] },
          { element: "select&search", label: "Platform", multiple: true, menuItems: this.getRowMenuItems("plateform"), value: [] },
        ]
      } else if (["Pending Payment"].includes(this.active_tab)) {
        let status = [{ label: "Pending Payment", value: "Pending Payment" }, { label: "Partially recieved", value: "Partial Payment" }]
        rows = [
          { element: "select&search", label: "Status", multiple: true, menuItems: status, value: [] },
          { element: "text", label: "Buyer Name", multiple: true, },
        ]
      } else if (["Pending dispatch confirmation & Time", "Pending ORRD", "Compliance Docs"].includes(this.active_tab)) {
        rows = [
          { element: "text", label: "Buyer Name", cols: "4", multiple: true },
        ]
      }else if (["Pending Approval"].includes(this.active_tab)) {
        rows = [
          { element: "text", label: "Buyer Name", multiple: true, value: ''  },
           { element: "select&search", label: "Price Discovery Method", multiple: true, menuItems: price_discovery_method, value: [] },
          // { element: "text", label: "Lot Name", multiple: true, value: ''  },
          // { element: "text", label: "Lot ID", multiple: true, value: ''  },
          // { element: "text", label: "Publish ID", multiple: true, value: ''  },
        ]
      } else if (["Dispatch"].includes(this.active_tab)) {
        let status = [{ label: "Pending Pick-Up", value: "Pending Pick" }, { label: "Pending Packaging", value: "Pending Pack" }, { label: "Pending Dispatch", value: "Pending Dispatch" }]
        rows = [
          { element: "text", label: "Buyer Name", multiple: true, menuItems: this.getRowMenuItems("buyer_name") },
          { element: "select&search", label: "Status", multiple: true, menuItems: status, value: [] },
        ]
      }else if (["Closed"].includes(this.active_tab)) {
        let status = [{ label: "Pending Pick-Up", value: "Pending Pick" }, { label: "Pending Packaging", value: "Pending Pack" }, { label: "Pending Dispatch", value: "Pending Dispatch" }]
        rows = [
          { element: "text", label: "Buyer Name", multiple: true, menuItems: this.getRowMenuItems("buyer_name"), value: '' },
          { element: "select&search", label: "Dispatch Status", multiple: true, menuItems: status, value: [] },
          { element: "select&search", label: "E-waste", multiple: true, menuItems: ewaste, value: [] },
        ]
      }
      for (const row of rows) {
        if (selectedValues.hasOwnProperty(row.label)) {
          row.value = selectedValues[row.label];
        }
      }
      for (const row of this.rows) {
        this.selectedValues = {
          ...this.selectedValues,
          [row.label] : row.value
        };
      }
      this.rows = rows
    },
    resetFields() {
      for (const row of this.rows) {
        if (row.label === 'Category') {
          row.value = [];
          row.parentData = [];
          this.dropStaticData = ""
          this.loading = false;
        } else {
          row.value = Array.isArray(row.value) ? [] : '';
        }
      }
    },

    apiCallForFilter(apiURL, requestBody) {
      this.$httpSecured
        .post(apiURL, requestBody)
        .then(response => {
          if (response.data) {
            this.table_data =  this.formatted_table_data(response.data.liquidations || response.data.liquidation_orders || response.data.approval_requests);
            if(this.table_data.length === 0){
              this.dataChecking = true
            }
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
            this.selected = [];

          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network: " + error);
        }).finally(() => {
          this.loading = false;
          // this.rows = []
          // this.dropStaticData = []

          this.number = 0
          this.filteWithSubPopup = false;
        });
    },

    generateOutputCategory(input) {
      let outputCategory = {};
      for (let i = 0; i < input.length; i++) {
        const categoryLevels = input[i].slice(0);
        for (let j = 0; j < categoryLevels.length; j++) {
          const categoryLevel = `category_l${j + 1}`;
          const categoryValue = categoryLevels[j];
          if (!outputCategory.hasOwnProperty(categoryLevel)) {
            outputCategory[categoryLevel] = [];
          }
          outputCategory[categoryLevel].push(categoryValue);
        }
      }

      // Convert category arrays to comma-separated strings
      for (const categoryLevel in outputCategory) {
        let data = outputCategory[categoryLevel]
        // let UniqueCat = [...new Set(data)]
        outputCategory[categoryLevel] = data.join(",");
      }
      return outputCategory;
    },

    getFilterKeyForApiParams() {
      let activeTab = this.active_tab
      let filter;
      let category = {} ;
      if (activeTab === "Channel Allocation") {
        let grades = this.rows.find(row => row.label === "Grade").value
        let Ewaste = this.rows.find(row => row.label === "E-waste").value
        let getcategory =  this.rows.find(row => row.label === "Category")
        let selectedCategory =  getcategory.parentData.map(item => item.value)
        let categoryKeys = this.generateOutputCategory(selectedCategory)
        let count = Object.keys(categoryKeys).length
        category = {
          ...categoryKeys,
          category_filter_count : count
        }
        filter = {
          grade: grades.map(grade => grade.label),
          ewaste: Ewaste.map(grade => grade.label)          
        }
      } else if (["Price Discovery Method", "Create Lots (Con)", "Create Lots (ComBid)", "Create Lots (MOQ)"].includes(this.active_tab)) {
        let grades = this.rows.find(row => row.label === "Grade").value
        let Ewaste = this.rows.find(row => row.label === "E-waste").value
 
         let getcategory =  this.rows.find(row => row.label === "Category")
        let selectedCategory =  getcategory.parentData.map(item => item.value)
        let categoryKeys = this.generateOutputCategory(selectedCategory)
        let count = Object.keys(categoryKeys).length
        category = {
          ...categoryKeys,
          category_filter_count : count
        }
        filter = {
          grade: grades.map(grade => grade.label),
          ewaste: Ewaste.map(grade => grade.label)
        }
      } else if (['Pending B2B Publish'].includes(this.active_tab)) {
        let price_discovery_method = this.rows.find(row => row.label === "Price Discovery Method").value
        let status = this.rows.find(row => row.label === "Status").value
        filter = {
          price_discovery_method: price_discovery_method.map(grade => grade.value),
          status: status.map(grade => grade.value)
        }
      } else if (["In Progress B2B"].includes(this.active_tab)) {
        let price_discovery_method = this.rows.find(row => row.label === "Price Discovery Method").value
        filter = {
          price_discovery_method: price_discovery_method.map(grade => grade.value),
        }
      }else if (["Pending Decision"].includes(this.active_tab)) {
        let price_discovery_method = this.rows.find(row => row.label === "Price Discovery Method").value
        let bid_status = this.rows.find(row => row.label === "Lot Status").value
        filter = {
          price_discovery_method: price_discovery_method.map(grade => grade.value),
          lot_bid_status : bid_status?.value || null
        }
      } else if(["Pending Approval"].includes(this.active_tab)){
        let buyer_name = this.rows.find(row => row.label === "Buyer Name").value
        let price_discovery_method = this.rows.find(row => row.label === "Price Discovery Method").value
        // let lot_desc = this.rows.find(row => row.label === "Lot Name").value
        // let lot_id = this.rows.find(row => row.label === "Lot ID").value
        // let publish_id = this.rows.find(row => row.label === "Publish ID").value
        filter = {
          buyer_name : buyer_name,
          price_discovery_method: price_discovery_method.map(grade => grade.value),
          // lot_desc : lot_desc,
          // lot_id : lot_id,
          // publish_id : publish_id
        }
        
      }else if (["Pending B2C Publish"].includes(this.active_tab)) {
        let grades = this.rows.find(row => row.label === "Grade").value
        let getcategory =  this.rows.find(row => row.label === "Category")
        let selectedCategory =  getcategory.parentData.map(item => item.value)
        let categoryKeys = this.generateOutputCategory(selectedCategory)
        let count = Object.keys(categoryKeys).length
        category = {
          ...categoryKeys,
          category_filter_count : count
        }
        filter = {
          grade: grades.map(grade => grade.label),
        }
      } else if (["In Progress B2C"].includes(this.active_tab)) {
        let grades = this.rows.find(row => row.label === "Grade").value
        let plateform = this.rows.find(row => row.label === "Platform").value
        filter = {
          grade: grades.map(grade => grade.label),
          plateform: plateform.map(grade => grade.label)
        }
      } else if (["Pending Payment"].includes(this.active_tab)) {
        let status = this.rows.find(row => row.label === "Status").value
        let buyer_name = this.rows.find(row => row.label === "Buyer Name").value
        filter = {
          payment_status: status.map(grade => grade.value),
          buyer_name: buyer_name
        }
      } else if (["Dispatch"].includes(this.active_tab)) {
        let status = this.rows.find(row => row.label === "Status").value
        let buyer_name = this.rows.find(row => row.label === "Buyer Name").value
        filter = {
          status: status.map(grade => grade.value),
          buyer_name: buyer_name
        }
      }
      else if (["Pending dispatch confirmation & Time", "Pending ORRD"].includes(this.active_tab)) {
        let buyer_name = this.rows.find(row => row.label === "Buyer Name").value
        filter = {
          buyer_name: buyer_name
        }
      }
      else if ([ "Compliance Docs"].includes(this.active_tab)) {
        let buyer_name = this.rows.find(row => row.label === "Buyer Name").value.split(',')
        filter = {
          buyer_name: buyer_name
        }
      }else if ([ "Closed"].includes(this.active_tab)) {
        let status = this.rows.find(row => row.label === "Dispatch Status").value
        let buyer_name = this.rows.find(row => row.label === "Buyer Name").value.split(',')
        let Ewaste = this.rows.find(row => row.label === "E-waste").value
        filter = {
          status: status.map(grade => grade.value),
          buyer_name: buyer_name,
          ewaste: Ewaste.map(grade => grade.label)
        }
      }

      return {filter , ...category}
    },

    applyFilterFunc() {
      
      let putaway = this.rows.find(row => row.label === "Putaway Status");
      this.number++;
      let params = this.getFilterKeyForApiParams()
      

      if(!this.isFilteringPage){
        this.page = 1;
        this.isFilteringPage = true;
      }
      let requestBody = {
      ...params,
        page: this.page,
        per_page: this.pageSize,
        status: this.active_tab,
      };
      if (
        this.active_tab === "Channel Allocation" ||
        this.active_tab === "Price Discovery Method" ||
        this.active_tab === "Create Lots (ComBid)"
      ) {
        requestBody.putaway = putaway?.value?.label || null;
      }

      if (this.active_tab === "Channel Allocation") {
        this.apiCallForFilter('/api/v2/warehouse/liquidation/channel_allocations', requestBody)
        this.updatePageSizesOnFilter('/api/v2/warehouse/liquidation/channel_allocations', requestBody)
      }
      if (this.active_tab === "Price Discovery Method") {

        this.apiCallForFilter('/api/v2/warehouse/liquidation/price_discovery', requestBody)
        this.updatePageSizesOnFilter('/api/v2/warehouse/liquidation/price_discovery', requestBody)
      }        
      if (this.active_tab === "Create Lots (Con)") {
        this.apiCallForFilter('/api/v2/warehouse/liquidation/contracted_price', requestBody)
        this.updatePageSizesOnFilter('/api/v2/warehouse/liquidation/contracted_price', requestBody)
      }
      if (this.active_tab === "Create Lots (ComBid)") {
        this.apiCallForFilter('/api/v2/warehouse/liquidation/competitive_bidding_price', requestBody)
        this.updatePageSizesOnFilter('/api/v2/warehouse/liquidation/competitive_bidding_price', requestBody)
      }
      if (this.active_tab === "Create Lots (MOQ)") {
        this.apiCallForFilter('/api/v2/warehouse/liquidation/moq', requestBody)
        this.updatePageSizesOnFilter('/api/v2/warehouse/liquidation/moq', requestBody)
      }
      if (this.active_tab === "Pending B2B Publish") {
        this.apiCallForFilter('/api/v2/warehouse/liquidation_order/b2b/pending_publish', requestBody)
        this.updatePageSizesOnFilter('/api/v2/warehouse/liquidation_order/b2b/pending_publish/index_new', requestBody)
      }
      if (this.active_tab === "In Progress B2B") {
        this.apiCallForFilter("/api/v2/warehouse/liquidation_order/b2b/in_progress", requestBody)
        this.updatePageSizesOnFilter("/api/v2/warehouse/liquidation_order/b2b/in_progress", requestBody)
      }
      if (this.active_tab === "Pending Decision") {
        this.apiCallForFilter("/api/v2/warehouse/liquidation_order/pending/decision", requestBody)
        this.updatePageSizesOnFilter("/api/v2/warehouse/liquidation_order/pending/decision", requestBody)
      }
      if (this.active_tab === "Pending Approval") {
        this.apiCallForFilter("/api/v2/warehouse/liquidation_orders/approval_requests", requestBody)
        this.updatePageSizesOnFilter("/api/v2/warehouse/liquidation_orders/approval_requests", requestBody)
      }
      if (this.active_tab === "Pending B2C Publish") {
        this.apiCallForFilter("/api/v2/warehouse/liquidation/b2c_pending_publish", requestBody)
        this.updatePageSizesOnFilter('/api/v2/warehouse/liquidation/b2c_pending_publish', requestBody)
      }
      if (this.active_tab === "Pending Payment") {
        this.apiCallForFilter("/api/v2/warehouse/liquidation_order/pending/payment", requestBody)
        this.updatePageSizesOnFilter('/api/v2/warehouse/liquidation_order/pending/payment', requestBody)
      }
      if (this.active_tab === "Pending dispatch confirmation & Time" || this.active_tab === "Pending ORRD") {
        this.apiCallForFilter("/api/v2/warehouse/liquidation_order/pending/dispatch_confirmation_time", requestBody)
        this.updatePageSizesOnFilter("/api/v2/warehouse/liquidation_order/pending/dispatch_confirmation_time", requestBody)
      }
      if (this.active_tab === "Dispatch") {
        this.apiCallForFilter("/api/v2/warehouse/liquidation_order/dispatch", requestBody)
        this.updatePageSizesOnFilter("/api/v2/warehouse/liquidation_order/dispatch", requestBody)
      }
      if (this.active_tab === "Compliance Docs") {
        this.apiCallForFilter("/api/v2/warehouse/liquidation_order/compliance_docs", requestBody)
        this.updatePageSizesOnFilter("/api/v2/warehouse/liquidation_order/compliance_docs", requestBody)
      }
      if (this.active_tab === "Closed") {
        this.apiCallForFilter("/api/v2/warehouse/liquidation_order/compliance_docs/closed_liquidation_orders", requestBody)
        this.updatePageSizesOnFilter("/api/v2/warehouse/liquidation_order/compliance_docs/closed_liquidation_orders", requestBody)
      }

    },
      updatePageSizesOnFilter(apiEndpoint, requestBody) {
      this.$httpSecured
        .post(apiEndpoint, requestBody)
        .then(response => {
          if (response.data && response.data.meta) {
            this.updatePageSizes(response.data.meta.total_count);
            this.selected = [];
          }
        })
        .catch(error => {
          // console.error("Error while updating page sizes on filter:", error);
        });
    },
    handleNextDialog(row) {
      if (row.label === "Category") {
        let multicheckTrue = this.dropStaticData.filter(data => data.value)
        if (multicheckTrue && multicheckTrue.length > 0) {
          if (row.parentData.length === 0) {
            let chckedData = multicheckTrue.map(data => ({
              name: data.name,
              value: [data.name]
            }))
            row.parentData = [...chckedData]
          } else {
            let chckedData = row.parentData.flatMap(item => {
              let includedValue = multicheckTrue.map(checkitem => 
                checkitem.parentLable && checkitem.parentLable.includes(item.value[item.value.length - 1]) ? { ...item, value: [...item.value, checkitem.name] } :
                !checkitem.parentLable && item.name !== checkitem.name ? {anem : checkitem.name , value : [checkitem.name]} 
                : item)
              return includedValue
            })
            row.parentData = [...chckedData]
          }
          
        } 
      }
     row.nextDialog = false
    },

    handleDropDownFilterMenu(category, row) {
      if (category.children.length > 0) {
        if(row.parentData && row.parentData.length > 0){
          let parentData =  row.parentData.flatMap(item => item.value)
          if(!parentData.includes(category.name)){
            this.addSelectedRowData(category, row)
          }
          this.dropStaticData = category.children.map(Sub_Cate => ({ ...Sub_Cate, value : parentData.includes(Sub_Cate.name) ? Sub_Cate.name : "", parentLable: category.parentLable && category.parentLable.length > 0 ? [...category.parentLable , category.name] : [category.name] }))
        }else{
          this.addSelectedRowData(category, row)
          this.dropStaticData = category.children.map(Sub_Cate => ({ ...Sub_Cate, parentLable: category.parentLable && category.parentLable.length > 0 ? [...category.parentLable , category.name] : [category.name] }))
        }
      }
    },
    handleClickdropdownwithaction(row ){
      let hasselectData = row.parentData ? row.parentData.map(cate => cate.name) : []
      this.dropStaticData = []
      if(hasselectData.length > 0){
        this.dropStaticData  =[...this.categoryList].map(cate => hasselectData.includes(cate.name) ? {...cate, value : cate.name} : cate)
      }else{
        this.dropStaticData  =[...this.categoryList].map(cate => ({...cate , value: ""}))
      }
    },

    handleCheckCategory(row, item) {
      let includedData = row.parentData.filter(cate => cate.value.includes(item.value))
      if (row.parentData && row.parentData.length > 0 && includedData.length > 0) {
        row.parentData = row.parentData.filter(cate => !cate.value.includes(item.value))
        item.value = ""
      } else {
        item.value = item.name
        if (item.parentLable && item.parentLable.length > 0) {
          let data = item.parentLable && row.parentData.filter(parentItem => parentItem.value.join("/") === item.parentLable.join("/"))
          if (data && data.length > 0) {
            let updateData = row.parentData.map(parentItem => parentItem.value.join("/") === item.parentLable.join("/") ?
              { ...parentItem, value: [...parentItem.value, item.name] }
              : parentItem
            )
            row.parentData = updateData
          } else {
            let Unique = item.parentLable && row.parentData.filter(parentItem => parentItem.value.join("/") !== item.parentLable.join("/"))
            if (Unique && Unique.length > 0) {
              row.parentData = [...row.parentData, { name: item.parentLable[0], value: [...item.parentLable, item.name] }]
            }
          }
        }
        else {
          row.parentData = [...row.parentData, { name: item.name, value: [item.name] }]
        }
      }
    },

    addSelectedRowData(category, row) {
      let updateData;
      if (row.parentData && row.parentData.length > 0 && category.parentLable && category.parentLable.length > 0) {
        updateData = row.parentData.map(data => category.parentLable.includes(data.name) ? { ...data, value: [...data.value, category.name] } : data)
      } else if (row.parentData && row.parentData.length > 0 && category.parentLable && category.parentLable.length === 0) {
        let findParentData = row.parentData.find(data => data.name === category.name)
        updateData = findParentData && findParentData.name ? row.parentData.map(data => category.name === data.name ? { ...data, value: [category.name] } : data) : [...row.parentData, { name: category.name, value: [category.name] }]
      } else {
        updateData = [...row.parentData, { name: category.name, value: [category.name] }]
      }
      row.parentData = updateData
    },

    handlemenuItemClose(selectedValue, row) {
      this.categoryList = [...this.categoryList].map(item => item.value && selectedValue.value.includes(item.name) ? {...item , value : ""} : item)
      this.dropStaticData = [...this.dropStaticData].map(item => item.value && selectedValue.value.includes(item.name) ? {...item , value : ""} : item)
      row.parentData = row.parentData.filter(data => data.value.join("/") !== selectedValue.value.join("/"))
      // menuItem.value = false
    },
    handelComboSelectValue(row , item){
      row.value =  row.value.filter(value => value.label !== item.label)
    },
      
      channelAllocation(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : []; 
              const requestBody = {
              page: this.page,
              per_page: this.pageSize
            };
          if (this.select_field && this.select_field.id && this.Liquidation_search) {
              requestBody[this.select_field.id] = this.Liquidation_search.trim();;
          }
        this.loading = true
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation/channel_allocations', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = this.formatted_table_data(response.data.liquidations)
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                // this.category = response.data.liquidations.map(liquidations => liquidations.category);
                this.grade = response.data.liquidations.map(liquidations => liquidations.grade);
                this.ewaste = response.data.liquidations.map(liquidations => liquidations.ewaste);
                this.loading = false;
                this.updatePageSizes(response.data.meta.total_count);
                this.selected = [];
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
          })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
      },
      pricediscovery(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              page: this.page,
              per_page: this.pageSize
            };
            if (this.select_field && this.select_field.id && this.Liquidation_search) {
              requestBody[this.select_field.id] = this.Liquidation_search.trim();;
          }
           this.loading = true
           this.$httpSecured
          .post('/api/v2/warehouse/liquidation/price_discovery', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = this.formatted_table_data(response.data.liquidations)
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                // this.category = response.data.liquidations.map(liquidations => liquidations.category);
                this.grade = response.data.liquidations.map(liquidations => liquidations.grade);
                this.ewaste = response.data.liquidations.map(liquidations => liquidations.ewaste);
                this.loading = false;
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      create_lotCon(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              page: this.page,
              per_page: this.pageSize
            };
          if (this.select_field && this.select_field.id && this.Liquidation_search) {
              requestBody[this.select_field.id] = this.Liquidation_search.trim();;
          }
        this.loading = true
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation/contracted_price', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = this.formatted_table_data(response.data.liquidations)
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                // this.category = response.data.liquidations.map(liquidations => liquidations.category);
                this.grade = response.data.liquidations.map(liquidations => liquidations.grade);
                this.ewaste = response.data.liquidations.map(liquidations => liquidations.ewaste);
                this.loading = false;
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      create_lotCombid(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              page: this.page,
              per_page: this.pageSize
            };
           if (this.select_field && this.select_field.id && this.Liquidation_search) {
              requestBody[this.select_field.id] = this.Liquidation_search.trim();;
          }
        this.loading = true
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation/competitive_bidding_price',requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = this.formatted_table_data(response.data.liquidations)
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                // this.category = response.data.liquidations.map(liquidations => liquidations.category);
                this.grade = response.data.liquidations.map(liquidations => liquidations.grade);
                this.ewaste = response.data.liquidations.map(liquidations => liquidations.ewaste);
                this.loading = false;
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      createLotsMOQ(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              page: this.page,
              per_page: this.pageSize
            };
           if (this.select_field && this.select_field.id && this.Liquidation_search) {
              requestBody[this.select_field.id] = this.Liquidation_search.trim();;
          }
        this.loading = true
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation/moq',requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = this.formatted_table_data(response.data.liquidations)
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                // this.category = response.data.liquidations.map(liquidations => liquidations.category);
                this.grade = response.data.liquidations.map(liquidations => liquidations.grade);
                this.ewaste = response.data.liquidations.map(liquidations => liquidations.ewaste);
                this.loading = false;
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      
      redirect_to_upload(){
      this.$store.commit("setLotIds", {
            lotIds:  JSON.stringify(this.selected.map(a => a.id)),
            action:'pending_dispatch_file_upload',
            inventoryId: 'Liquidation'
          });
      this.$router.push({ name: 'LotFileuploadComm' });
      },
      downloadConfiramtion(){
        this.$httpSecured
          .post("/api/v2/warehouse/liquidation_order/pending/dispatch_confirmation_time/download_liquidation_order_pending_dispatch_file",{
            "liquidation_order" : {
              "ids" : Array.from(this.selected.map(item => (item.id)))
            }
          })
          .then(response => {
            if (response.data) {
              const link = document.createElement('a');
              link.href = response.data.url; 
              link.target = '_blank';
              link.download = 'inventory.csv'; 
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } else {
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
          });
      },
      // Download CSV for selected lots in Pending Approval
      downloadPendingApprovalCsv() {
        if (!this.selected.length) return;
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation_orders/download_pending_approval_csv', {
            lot_ids: this.selected.map(item => item.lot_id || item.id)
          })
          .then(response => {
            if (response.data && response.data.url) {
              const link = document.createElement('a');
              link.href = response.data.url;
              link.target = '_blank';
              link.download = 'pending_approval_lots.csv';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } else {
              this.showAlert('error', 'No download URL received.');
            }
          })
          .catch(err => {
            this.showAlert('error', 'Failed to download CSV.');
          });
      },

      pendingB2b_publish(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              search_text:searchArray,
              page: this.page,
              per_page: this.pageSize
            };
        this.loading = true
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation_order/b2b/pending_publish/index_new', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = this.formatted_table_data(response.data.liquidation_orders)
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.loading = false;
                // this.category = response.data.liquidation_orders.map(liquidation_orders => liquidation_orders.category);
                this.grade = response.data.liquidation_orders.map(liquidation_orders => liquidation_orders.grade);
                this.ewaste = response.data.liquidation_orders.map(liquidation_orders => liquidation_orders.ewaste);                
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      inProgressB2B(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              search_text:searchArray,
              page: this.page,
              per_page: this.pageSize
            };
        this.loading = true
        this.$httpSecured
          .post('api/v2/warehouse/liquidation_order/b2b/in_progress', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = this.formatted_table_data(response.data.liquidation_orders)
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.loading = false;
                // this.category = response.data.liquidation_orders.map(liquidation_orders => liquidation_orders.category);
                this.grade = response.data.liquidation_orders.map(liquidation_orders => liquidation_orders.grade);
                this.ewaste = response.data.liquidation_orders.map(liquidation_orders => liquidation_orders.ewaste);                
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      pendingDecision(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              search_text:searchArray,
              page: this.page,
              per_page: this.pageSize
            };
        this.loading = true
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation_order/pending/decision', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = this.formatted_table_data(response.data.liquidation_orders)
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.loading = false;
                // this.category = response.data.liquidation_orders.map(liquidation_orders => liquidation_orders.category);
                this.grade = response.data.liquidation_orders.map(liquidation_orders => liquidation_orders.grade);
                this.ewaste = response.data.liquidation_orders.map(liquidation_orders => liquidation_orders.ewaste);
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      pendingApproval(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              filter : {
                search_text : searchArray
              },
              page: this.page,
              per_page: this.pageSize
            };
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation_orders/approval_requests', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = response.data.approval_requests
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count;
                this.updatePageSizes(response.data.meta.total_count);
                this.loading = false;
                
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      pendingB2CPublish(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              search_text:searchArray,
              page: this.page,
              per_page: this.pageSize
            };
        this.loading = true
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation/b2c_pending_publish', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = this.formatted_table_data(response.data.liquidations)
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.loading = false;
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      inProgressB2C(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              search_text:searchArray,
              page: this.page,
              per_page: this.pageSize
            };
        this.loading = true
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation_order/b2c/in_progress', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = this.formatted_table_data(response.data.ecom_liquidations)
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.loading = false;
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      pendingPayment(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              search_text:searchArray,
              page: this.page,
              per_page: this.pageSize
            };
        this.loading = true
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation_order/pending/payment', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = this.formatted_table_data(response.data.liquidation_orders)
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.loading = false;
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      pendingDispatchConfirmTime(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              search_text:searchArray,
              page: this.page,
              per_page: this.pageSize
            };
        this.loading = true
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation_order/pending/dispatch_confirmation_time', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = this.formatted_table_data(response.data.liquidation_orders)
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.loading = false;
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      pendingOrrd(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              search_text:searchArray,
              page: this.page,
              per_page: this.pageSize
            };
        this.loading = true
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation_order/pending/pending_orrd', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = this.formatted_table_data(response.data.liquidation_orders)
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.loading = false;
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      dispatch(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              search_text:searchArray,
              page: this.page,
              per_page: this.pageSize
            };
        this.loading = true
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation_order/dispatch', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = this.formatted_table_data(response.data.liquidation_orders)
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.loading = false;
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      fetchPendingForApproval(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : []; 
              const requestBody = {
              page: this.page,
              per_page: this.pageSize
            };
          if (this.select_field && this.select_field.id && this.Liquidation_search) {
              requestBody[this.select_field.id] = this.Liquidation_search.trim();;
          }
        this.loading = true
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation/channel_allocations?status=pending_approval', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = this.formatted_table_data(response.data.liquidations)
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.loading = false;
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      complianceDocs(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              search_text:searchArray,
              page: this.page,
              per_page: this.pageSize
            };
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation_order/compliance_docs', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = response.data.liquidation_orders
                this.totalPages = response.data.meta.total_pages
                this.loading = false;
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      closedTabData(){
        const searchArray = this.Liquidation_search && typeof this.Liquidation_search === 'string'
        ? this.Liquidation_search.split(',').map(value => value.trim())
        : [];
        const requestBody = {
              search_text:searchArray,
              page: this.page,
              per_page: this.pageSize
            };
            this.loading = true
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation_order/compliance_docs/closed_liquidation_orders', requestBody)
          .then(response => {
              if (response.data) {
                this.table_data = response.data.liquidation_orders
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
                this.updatePageSizes(response.data.meta.total_count);
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
      closePopups(){
        this.selectedTableItem = []
        this.reserveLotPopup = false
        this.select_buyer = '',
        this.assign_buyer = ''
        this.updatePaymentPopup = false
        this.purchase_amount = ''
        this.payment_ref_number = ''
        this.cancelPaymentPopup = false
        this.select_buyer = ''
        this.assign_buyer = ''
        this.updateDispatchDatePopup = false
        this.publish_end_date = ''
      },
      allocationchanel(){
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation/channel_allocations/allocate_channel', 
            {
              "liquidation":{
                "ids":this.channel_liq_id,
               "alloted_channel":"liquidation_status_allocate_b2b"
              }              
            }
          )
          .then(response => {
            if (response.data) {
                // this.table_data = response.data.liquidations
                this.successmessage = response.data.message
                this.showAlert("success", "Successfully alloted!");
                this.allocateTob2bdailog = false
                this.successpopup = true
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.number = 0;
          this.loading = false;

        });
      },
      allocationchanelb2c(){
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation/channel_allocations/allocate_channel', 
            {
              "liquidation":{
                "ids":this.channel_liq_id,
              "alloted_channel":"liquidation_status_pending_b2c_publish"
              }              
            }
          )
          .then(response => {
            if (response.data) {
                // this.table_data = response.data.liquidations
                // this.showAlert("success", "Successfully alloted");
                this.allocateTob2cdailog = false
                this.successmessage = response.data.message
                this.successpopup = true
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.allocateTob2cdailog = false
          this.number = 0;
          this.loading = false;

        });
      },
      itemDetailpopup(item, lot_id) {
        this.upload_doc = '';
        if(this.active_tab == 'In Progress B2B' || this.active_tab == 'Pending B2B Publish' || this.active_tab == 'Pending Decision'|| this.active_tab == 'Pending Payment' || this.active_tab === 'Pending dispatch confirmation & Time' || this.active_tab === 'Pending ORRD' || this.active_tab === 'Dispatch' || this.active_tab === 'Compliance Docs' || this.active_tab === 'Closed' || this.active_tab === 'Pending Approval'){
          this.$store.commit("setSelectedLot", { lot: this.active_tab === 'Pending Approval' ? item.lot_id : lot_id, action :  this.active_tab });
          this.$router.push({ name : 'PublishDetails'})
        }
      // if(this.active_tab == 'Pending B2B Publish' || this.active_tab == 'Pending Decision' || this.active_tab == 'In Progress B2B' || this.active_tab === 'Pending Payment' || this.active_tab === 'Pending dispatch confirmation & Time' || this.active_tab === 'Dispatch' || this.active_tab === 'Compliance Docs'){
      //   if(item.price_discovery_method == 'Competitive Bidding'){
      //     this.datadetailpopupdisposition = true
      //   }else if(item.price_discovery_method == 'MOQ'){
      //     this.creatingStatus = item.status
      //     this.moqaLotInformation = true
      //   }        
      //   this.id = item.id;
      //   this.publishID = item.beam_lot_id
      //   let str = String(this.id);
      //   this.lot_name = item.lot_name;
      //   this.created_at = item.created_at;
      //   this.id = str
      //   this.created_at = str;
      //   const id = item.id
      //   this.lot_ids = id
      //   this.$httpSecured
      //   .get(`api/v2/warehouse/liquidation_order/b2b/pending_publish/${id}`)
      //   .then(response => {
      //     if (response.data) {
      //       this.item_details = response.data.liquidation_order
      //       this.imageUrls = this.item_details.lot_image_urls
      //       const creationDate = new Date(this.item_details.created_at);
      //      this.creationDate = this.formatDateTime(creationDate);
      //       this.loading = false;
      //     } else {
      //       this.loading = false;
      //       this.showAlert("error", "No Data Found");
      //     }
      //   })
      //   .catch(error => {
      //     this.showAlert("error", "Something went wrong from Network" + error);
      //     this.loading = false;
      //   });
      // }   
    },
    formatDateTime(dateTime) {
      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true
      };
      const date = new Date(dateTime);
      return date.toLocaleString("en-GB", options);
    },

    allocateTob2b(){
        const itemsWithNullEwaste = this.selected.filter(liquidation => liquidation.ewaste === '');
        // const itemgatepass = this.selected.filter(liquidation => liquidation.has_inventory_gate_pass === false)
        if (itemsWithNullEwaste.length > 0) {
          const itemNames = itemsWithNullEwaste.map(liquidation => liquidation.tag_number).join(", ");
          this.showAlert("warning", `Please update the e_waste status for the following inventories: ${itemNames}`);
          this.allocateTob2bdailog = false;
          this.selectedTableItem = []
          return; // Stop further execution
        }
        else{
          this.allocateTob2bdailog = true;
        this.channel_liq_id = this.selected.map(liquidation => liquidation.id);
        }
               
        },
        allocateTob2c() {
          const itemsWithNullEwaste = this.selected.filter(liquidation => liquidation.ewaste === '');
          // this.itemsWithNullEwasteYes = this.selected.filter(liquidation => liquidation.ewaste === 'yes');
          // const itemgatepass = this.selected.filter(liquidation => liquidation.has_inventory_gate_pass === false)
          if (itemsWithNullEwaste.length > 0) {
          const itemNames = itemsWithNullEwaste.map(liquidation => liquidation.tag_number).join(", ");
          this.showAlert("warning", `Please update the e_waste status for the following inventories: ${itemNames}`);
          this.allocateTob2bdailog = false;
          this.selectedTableItem = []
          return; // Stop further execution
        }else if(this.itemsWithNullEwasteYes.length > 0){
          this.successmessage = 'E-waste items cannot be allocated to B2C.'
          this.successpopup = true
          this.ewasteYes = true
        }else{
          this.allocateTob2cdailog = true;
          this.channel_liq_id = this.selected.map(liquidation => liquidation.id);
        }
        },
        competitiveBiddibgdilog(){
          this.competitiveBiddibg = true
          this.channel_liq_id = this.selected.map(liquidation => liquidation.id);
        },
        contractedDialog(){
          this.contractedPopup = true
          this.channel_liq_id = this.selected.map(liquidation => liquidation.id);
        },
        createMoqlot(){
          this.moqLotcreationdilog = true
          this.channel_liq_id = this.selected.map(liquidation => liquidation.id);
        },
        deletelot(){
          if(this.active_tab == 'In Progress B2B'){
            for(let i=0;i<this.selected.length;i++){
              if(this.selected[i].bid_count != 0){
                this.showAlert("error","Bids are present, Not able to delete lot!");
                this.selectedTableItem = [];
                return;
              }
            }
          }
          this.deletelotDilog= true
          this.b2b_liq_id = this.selected.map(liquidation_order => liquidation_order.id);
        },
        PublishLot(){
          this.number++;
          this.liq_lot_id = this.selected.map(liquidation => liquidation.id);
          this.$httpSecured
          .post('/api/v2/warehouse/liquidation_order/b2b/pending_publish/publish',
            {
              "id":this.liq_lot_id
            }
          )
          
          .then(response => {
            if (response) {
              this.showAlert("success", "Lot Published");
              this.publishLotConfirmDialog = false;
              this.selectedTableItem = []
              this.successmessage = response.data.message
              this.successpopup = true
              this.liq_lot_id = '';
              this.number = 0;
            } else {
              this.publishLotConfirmDialog   = false;
              this.progress_overlay = false;
              this.number = 0;
              this.showAlert("error", "No Data Found");
            }                         
          })
          .catch(error => {
            this.publishLotConfirmDialog   = false;
            this.progress_overlay = false;
            this.number = 0;
            this.showAlert("error", error.response.data.error);
          });
        },
        savemarkeWast(){
          this.$httpSecured
          .post('api/v2/warehouse/liquidation/channel_allocations/mark_e_waste', 
            {
              "liquidation":{
                "ids":this.channel_liq_id,
                "ewaste":this.picked
              }
            }
          )
          .then(response => {
            if (response.data) {
                // this.table_data = response.data.liquidations
                this.showAlert("success", "Mark as E-waste updated");
                this.markewastedailog = false
                this.successmessage = response.data.message
                this.successpopup = true
              } else {                
                this.showAlert("error", "No Data Found");
                this.number = 0;
              }
          })
          .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.number = 0;
          this.loading = false;
        });
        },
        competitiveBiddingconfirm(){
          this.$httpSecured
          .post('api/v2/warehouse/liquidation/price_discovery/assign_price', 
            {
              "liquidation":{
                "ids":this.channel_liq_id,
                "price_type":"liquidation_status_competitive_bidding_price"
              }
            }
          )
          .then(response => {
            if (response.data) {
                // this.table_data = response.data.liquidations
                // this.showAlert("success", "Successfully alloted");
                this.competitiveBiddibg = false
                this.successmessage = response.data.message
                this.successpopup = true
              } else {
                  this.showAlert("error", "No Data Found");
                  this.number = 0;
                }              
          }).catch(error => {
            this.publishLotConfirmDialog   = false;
            this.progress_overlay = false;
            this.showAlert("error", error.response.data.error);
          });
        },
        contractedConfirm(){
          this.$httpSecured
          .post('api/v2/warehouse/liquidation/price_discovery/assign_price', 
            {
              "liquidation":{
                "ids":this.channel_liq_id,
                "price_type":"liquidation_status_contracted_price"
              }
            }
          )
          .then(response => {
            if (response.data) {
                // this.table_data = response.data.liquidations
                // this.showAlert("success", "Successfully alloted");
                this.contractedPopup = false
                this.successmessage = response.data.message
                this.successpopup = true
              } else {
                  this.showAlert("error","No Data Found");
                }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.number = 0;
          this.loading = false;

        });
        },
        Moqcreation(){
          const itemsWithNullEwaste = this.selected.filter(liquidation => liquidation.ewaste === 'yes');
          if (itemsWithNullEwaste === 'yes') {
            this.showAlert("error", "ERROR! E-waste Items cannot be sent to MOQ");
            return;
          }

          this.$httpSecured
          .post('api/v2/warehouse/liquidation/price_discovery/assign_price', 
            {
              "liquidation":{
                "ids":this.channel_liq_id,
                "price_type":"liquidation_status_moq_price"
              }
            }
          )
          .then(response => {
            if (response.data) {
                // this.showAlert("success", "Successfully alloted!");
                this.moqLotcreationdilog = false
                this.successmessage = response.data.message
                this.successpopup = true
                this.loading = false
                this.channel_liq_id = []
              }else {
                  this.showAlert("error", "No Data Found");                
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.number = 0;
          this.loading = false;

        });
        },
        dateformat(dateString){
        let dateTimeParts = dateString.split(' ');
        let timeParts     = dateTimeParts[1].split(':');
        let dateParts     = dateTimeParts[0].split('-');
        let date = new Date(dateParts[0],parseInt(dateParts[1], 10) - 1,dateParts[2],timeParts[0], timeParts[1])
        return date;
      },
        SaveBidTime(){
          var  start_dtime = this.dateformat(this.bid_start_date + " " + this.time1)
          var  end_dtime   = this.dateformat(this.bid_end_date + " " + this.time2)
          this.liq_lot_id = this.selected.map(liquidation => liquidation.id);
          // const formData = new FormData();
            if(end_dtime <= start_dtime){
              this.showAlert("error", "Invalid Date / Time ..!!");
            }else{

            this.number++;
            if(this.active_tab == 'Pending B2B Publish'){
              this.$httpSecured
            .post("/api/v2/warehouse/liquidation_order/b2b/pending_publish/update_timing", {
              "liquidation_order": {
                 "ids": this.liq_lot_id,
                "start_date": (this.bid_start_date + " " + this.time1),
                "end_date": (this.bid_end_date + " " + this.time2)
            }
            })
            .then(response => {
              if (response) {  
                  // this.showAlert("success", response.data.message);
                  this.ecitBidTimeDilog = false
                  this.successmessage = response.data.message
                  this.successpopup = true
                  this.liq_lot_id = '',
                  this.bid_start_date = null,
                  this.time1='',
                  this.bid_end_date = null,
                  this.time2 = ''
                  this.number = 0;
              } else {
                this.showAlert("error", "Something went Wrong !!");
                this.ecitBidTimeDilog = false;
                this.number = 0;
              }                         
            })
            .catch(error => {
              this.showAlert("error", error.response.data.error);
              this.number = 0;
            });
          }
            
            if(this.active_tab == 'In Progress B2B'){
              this.$httpSecured
            .post("/api/v2/warehouse/liquidation_order/b2b/in_progress/update_timing", {
              "liquidation_order": {
                 "ids": this.liq_lot_id,
                "start_date": (this.bid_start_date + " " + this.time1),
                "end_date": (this.bid_end_date + " " + this.time2)
            }
            })
            .then(response => {
              if (response) {  
                  // this.showAlert("success", response.data.message);
                  this.ecitBidTimeDilog = false
                  this.successmessage = response.data.message
                  this.successpopup = true
                  this.liq_lot_id = '',
                  this.bid_start_date = null,
                  this.time1='',
                  this.bid_end_date = null,
                  this.time2 = ''
                  this.number = 0;
              } else {
                this.showAlert("error", "Something went Wrong !!");
                this.ecitBidTimeDilog = false;
                this.number = 0;
              }                         
            })
            .catch(error => {
              this.showAlert("error", error.response.data.error);
              this.number = 0;
            }); 
            }
            }
            
        },
        deletelotconfirm(){
          if(this.active_tab == 'Pending B2B Publish'){
            this.$httpSecured
            .post("/api/v2/warehouse/liquidation_order/b2b/pending_publish/delete_lots", 
                {
                  "liquidation_order":{
                    "ids":this.b2b_liq_id
                  }
                }
            )
            .then(response => {
              if (response.data) {
                // this.showAlert("success", "Lot Deleted");
                this.ip_selected = [];
                this.deletelotDilog = false;
                this.successmessage = response.data.message
                this.successpopup = true
              } else {
                this.showAlert("error", "No Data Found");
              }
            }).catch(error => {
                  this.showAlert("error", "Something went wrong from Network" + error);
              });
          }
          if(this.active_tab == 'In Progress B2B'){
            this.$httpSecured
            .post("api/v2/warehouse/liquidation_order/b2b/in_progress/delete_lots", 
                {
                  "liquidation_order":{
                    "ids":this.b2b_liq_id
                  }
                }
            )
            .then(response => {
              if (response.data) {
                // this.showAlert("success", "Lot Deleted");
                this.ip_selected = [];
                this.deletelotDilog = false;
                this.successmessage = response.data.message
                this.successpopup = true
              } else {
                this.showAlert("error", "No Data Found");
              }
            }).catch(error => {
                  this.showAlert("error", "Something went wrong from Network" + error);
              }); 
          }
          if(this.active_tab == 'In Progress B2C'){
            this.$httpSecured
            .post("/api/v2/warehouse/liquidation_order/b2c/in_progress", 
                {
                  "liquidation_order":{
                    "ids":this.b2b_liq_id
                  }
                }
            )
            .then(response => {
              if (response.data) {
                // this.showAlert("success", "Lot Deleted");
                this.ip_selected = [];
                this.deletelotDilog = false;
                this.successmessage = response.data.message
                this.successpopup = true
              } else {
                this.showAlert("error", "No Data Found");
              }
            }).catch(error => {
                  this.showAlert("error", "Something went wrong from Network" + error);
              }); 
          } 
          if(this.active_tab == 'Pending Decision'){
            this.$httpSecured
            .post("/api/v2/warehouse/liquidation_order/pending/decision/delete_lots", 
                {
                  "liquidation_order":{
                    "ids":this.b2b_liq_id
                  }
                }
            )
            .then(response => {
              if (response.data) {
                // this.showAlert("success", "Lot Deleted");
                this.ip_selected = [];
                this.deletelotDilog = false;
                this.successmessage = response.data.message
                this.successpopup = true
              } else {
                this.showAlert("error", "No Data Found");
              }
            }).catch(error => {
                  this.showAlert("error", "Something went wrong from Network" + error);
              }); 
          }            
        },
        allocationchanelb2csubmit() {
          this.$httpSecured          
            .post(`/api/v2/warehouse/liquidation_order/b2b/pending_publish/${this.id}/remove_lot_items`, 
            {
              remove_tag_numbers: this.tagIds
            })
            .then(response => {
              if (response.status === 200) {
                this.successmessage = response.data.message
                this.files = [];
                this.loadData('Pending B2B Publish');
                this.$store.commit("setLotIds", { lotIds: JSON.stringify([]) });
                this.editinventory = false;
                this.datadetailpopupdisposition = false;
                this.updatelotconfirm = false;
                this.tagIds = ''
              } else {
                this.showAlert("error", "Something went Wrong !!");
                this.ecitBidTimeDilog = false;

              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.errors);
              this.number = 0;
            });
        },

        allocationchanelb2cconfirm(){
          this.updatelotconfirm = true;
          this.eventDeleteClicked = false;
        },
        deleteEvent(item) {
          if(this.upload_doc_view === 'upload_doc_view'){
            this.deletItemDoc(item)
          }else{
            const tagNumberToDelete = item.tag_number;
            this.tagIds.push(item.tag_number);
            const indexToDelete = this.edit_inventory.findIndex(
              (inventoryItem) => inventoryItem.tag_number === tagNumberToDelete
            );
            if (indexToDelete !== -1) {
              this.edit_inventory.splice(indexToDelete, 1);
            }
            this.eventDeleteClicked = false;
          }
        },
        markewaste(){
          var ewaste = Array.from(new Set(this.selected.map(x => x.ewaste)));
          if(ewaste.length === 1){
            this.picked = ewaste == 'yes' ? 'Yes' : 'No';
          }else{
           this.picked = '';
          }
          this.markewastedailog = true
          this.channel_liq_id = this.selected.map(liquidation => liquidation.id);
        },
        uploadlotfile(){
          this.uploadlotfiledilog = true
          this.fileErrorMessage = '';
          this.fileError = false;
        },
        changeFile(){
          if (this.file) {
            const fileType = this.file.type;
            if (fileType !== 'text/csv') {
                this.fileError = true;
                this.fileErrorMessage = 'Only CSV files are allowed.';
            } else {
                this.fileError = false;
                this.fileErrorMessage = '';
            }
          }
        },
        lotCreation(){
          this.liq_id = this.selected.map(liquidation => liquidation.id);
          this.number = 0;
          this.lotCreationdilog = true
          this.$httpSecured.get("api/v2/warehouse/liquidation/contracted_price/get_vendor_contract")
            .then(response => {
              this.contracted__buyer_items = response.data.buyers.map(vendor =>({
                  id:vendor.client_vendor_code,
                  displayText: `${vendor.name} (${vendor.client_vendor_code})`,
                }));
                this. getContractValue();
                this.loading = false;
           })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
        },
        getContractValue(){
        this.$httpSecured.post('/api/v2/warehouse/liquidation/contracted_price/get_salvage_values', {  
          "liquidation_ids":this.liq_id,
         }
          )
        .then(response => {
          if (response.data) {
               this.contracted_value = response.data.salvage_value
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
        });
      },
        formatDispatchDate(item) {
          if (item && item.dispatch_date) {
            const formattedDate = new Date(item.dispatch_date).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            });
            return formattedDate;
          } else {
            return "-";
          }
        },
        showAlert(alert_type, alert_message) {
          this.alert = true;
          this.alert_type = alert_type;
          this.alert_message = alert_message;
          this.scrollToTop();
          this.alertTimeOut();
        },
        alertTimeOut() {
          setTimeout(() => {
              this.alert = false;
          }, 3000);
        },
        handlePageSizeChange(size) {
          this.pageSize = size;
          this.page = 1
          this.filterPageNo = 1;
          if(this.isFilteringPage){
              this.applyFilterFunc();
              return;
          }
          if (this.active_tab == 'Channel Allocation') {
            this.channelAllocation();      
          }else if(this.active_tab == 'Price Discovery Method'){
            this.pricediscovery();
          }else if(this.active_tab == 'Create Lots (Con)'){
            this.create_lotCon();
          }else if(this.active_tab == 'Create Lots (ComBid)'){
            this.create_lotCombid();
          }else if(this.active_tab == 'Pending B2B Publish'){
            this.pendingB2b_publish();
          }else if(this.active_tab == 'In Progress B2B'){
            this.inProgressB2B(); 
          }else if(this.active_tab == 'Pending Decision'){
            this.pendingDecision();
          }else if(this.active_tab == 'Pending Approval'){
            this.pendingApproval();
          }else if(this.active_tab == 'Pending B2C Publish'){
            this.pendingB2CPublish();
          }else if(this.active_tab == 'In Progress B2C'){
            this.inProgressB2C();
          }else if(this.active_tab == 'Pending Payment'){
            this.pendingPayment();
          }else if(this.active_tab == 'Pending dispatch confirmation & Time'){
            this.pendingDispatchConfirmTime()
          }else if(this.active_tab == 'Pending ORRD'){
            this.pendingOrrd()
          }else if(this.active_tab == 'Dispatch'){
            this.dispatch();
          }else if(this.active_tab == 'Create Lots (MOQ)'){
            this.createLotsMOQ();
          }else if(this.active_tab == 'Closed'){
            this.closedTabData();
          }else if(this.active_tab == 'Pending For Approval'){
            this.fetchPendingForApproval();
          }
        },
        handlePageChange(value) {
          this.page = value;
          console.log("value"+this.page+"conditin:" +this.isFilteringPage)
          if(this.isFilteringPage){
            this.filterPageNo = value;
            this.applyFilterFunc();
            return;
        }
          if (this.active_tab == 'Channel Allocation') {
            this.channelAllocation();      
          }else if(this.active_tab == 'Price Discovery Method'){
            this.pricediscovery();
          }else if(this.active_tab == 'Create Lots (Con)'){
            this.create_lotCon();
          }else if(this.active_tab == 'Create Lots (ComBid)'){
            this.create_lotCombid();
          }else if(this.active_tab == 'Pending B2B Publish'){
            this.pendingB2b_publish();
          }else if(this.active_tab == 'In Progress B2B'){
            this.inProgressB2B() 
          }else if(this.active_tab == 'Pending Decision'){
            this.pendingDecision();
          }else if(this.active_tab == 'Pending Approval'){
            this.pendingApproval();
          }else if(this.active_tab == 'Pending B2C Publish'){
            this.pendingB2CPublish();
          }else if(this.active_tab == 'In Progress B2C'){
            this.inProgressB2C();
          }else if(this.active_tab == 'Pending Payment'){
            this.pendingPayment();
          }else if(this.active_tab == 'Pending dispatch confirmation & Time'){
            this.pendingDispatchConfirmTime()
          }else if(this.active_tab == 'Pending ORRD'){
            this.pendingOrrd()
          }else if(this.active_tab == 'Dispatch'){
            this.dispatch()
          }else if(this.active_tab == 'Create Lots (MOQ)'){
            this.createLotsMOQ();
          }else if(this.active_tab == 'Closed'){
            this.closedTabData();
          }else if(this.active_tab == 'Pending For Approval'){
            this.fetchPendingForApproval();
          }
        },
        updatePageSizes(totalCount) {
          if (totalCount <= 25) {
            this.pageSizes = [25];
          } else if (totalCount <= 50) {
            this.pageSizes = [25, 50];
          } else if (totalCount <= 75) {
            this.pageSizes = [25, 50, 75];
          } else {
            this.pageSizes = [25, 50, 75, 100];
          }
        },
      // pagination params
        getRequestParams( page, pageSize) {
        let params = {};
        if (page) {
          params["page"] = page;
        }
        if (pageSize) {
          params["size"] = pageSize;
        }
        return params;
      },
      closePopupLotCreate(){
        this.lotCreationdilog = false;
        this.lot_name = ''
        this.liq_id = ''
        this.contracted_buyer = ''
        this.contracted_value = ''
        this.selectedTableItem = []
      },
      createLotContract(){
        this.number++;
        this.$httpSecured.post('/api/v2/warehouse/liquidation/contracted_price/create_lot', {          
           "lot_name":this.lot_name,
          "liquidation_ids":this.liq_id,
          "contracted_liquidation_value":this.contracted_value,
          "assigned_buyer": this.assign_buyer 
         }
          )
        .then(response => {
          if (response.data) {
            this.selectedTableItem = [];
            this.lotCreationdilog = false
            this.lot_name = ''
            this.liq_id = ''
            this.assign_buyer = ''
            this.successmessage = response.data.message
            this.successpopup = true
            // this.showAlert("success", "Successfully created");
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
          this.number = 0;

        });
      },
      get_vendor_liquidation() {
      this.$httpSecured.get("api/v2/warehouse/liquidation/competitive_bidding_price/buyers")
        .then(response => {
            this.assign_user_items = response.data.buyer_masters
        })
        .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
        });
    },

      fileLotCreatecontract(){
        const formData = new FormData();
        formData.append('lot_file', this.file[0])
       if(this.active_tab == 'Create Lots (Con)'){
        this.$httpSecured.post('api/v2/warehouse/liquidation/contracted_price/create_lot', formData, {
        headers: {
        'Content-Type': 'multipart/form-data'
             }
         }
          )
        .then(response => {
          if (response.data) {
            this.uploadlotfiledilog = false;
            this.file = '';
            this.showAlert("success", "Successfully updated");
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.number = 0;
          this.loading = false;

        });
       }
       if(this.active_tab == 'Create Lots (ComBid)'){
        this.$httpSecured.post('api/v2/warehouse/liquidation/competitive_bidding_price/create_lot', formData, {
        headers: {
        'Content-Type': 'multipart/form-data'
             }
         }
          )
        .then(response => {
          if (response.data) {
            this.uploadlotfiledilog = false;
            this.file = '';
            this.showAlert("success", "Successfully created");
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.number = 0;
          this.loading = false;

        });
       }
      },
      closeFilePopup(){
        this.uploadlotfiledilog = false;
        this.file = '';
      },
      editinventorydilog(action, id){
        this.loading = true;
        this.editinventory = true;
        this.tagIds = [];

        let end_point_view = '';
        this.upload_doc_view = action
        if(action === 'upload_doc_view'){
          this.upload_doc = action;
          this.lot_ids = id.id;
          this.id = id.beam_lot_id;
          this.imageUrls = id.lot_image_urls[0]
           this.tagIds = []
        this.itemsheader = [
              { title: "File Name", key: "document_name"},
              { title: "Uploaded On", key: "created_on"},
              { title: "", key: "preview"},
               { title: "", key: "download"},
              { title: "", key: "delete_item"},
            ];
           end_point_view = `/api/v2/warehouse/liquidation_order/compliance_docs/view_compliance_documents?id=${this.lot_ids}`; 
        }else{
          this.tagIds = []
          this.itemsheader = [
            {title: "Tag ID", key: "tag_number", sortable:false},
            {title: "Article ID", key: "sku_code"},
            {title: "", key: "delete_item"},
          ];
          end_point_view = `/api/v2/warehouse/liquidation_order/b2b/pending_publish/${this.lot_ids}/view_inventory`;  
        }
          this.$httpSecured
          .get(end_point_view)
          .then(response => {
            if (response.data) {
              if(action === 'upload_doc_view'){
                this.edit_inventory = response.data.documents_list
              }else{
                this.edit_inventory = response.data.liquidations
              }
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        
      },
      navigateeditinventorydilogToComponent() {
        this.$store.commit("setLotIds", {
            lotIds: this.id,
            action:'edit_lot'

          });
          this.$router.push({ name: 'CreateLotCompBidd', query : { action : "edit-lot" } });
        },
      navigateToComponent() {

           const floor_price_valid = this.selected.filter(liquidation => (liquidation.floor_price === "" || liquidation.floor_price === null || liquidation.floor_price === 0))
           if(floor_price_valid.length > 0 && this.active_tab === 'Create Lots (ComBid)'){
            this.showAlert("warning", "Please update floor price");
            this.selected.splice(0); 
            this.$nextTick(() => {
              this.selectedTableItem.splice(0); 
            });
            return;
          }
        
            var dc = this.selected.map(x =>  x.destination_city)
            var ewaste = Array.from(new Set(this.selected.map(x => x.ewaste)));
            const unique = (value, index, self) => {
              return self.indexOf(value) === index
            }
            dc = dc.filter(function( element ) {
              return element !== undefined;
            });

            if(ewaste.length > 1){
              this.selectedTableItem = []
              this.showAlert("error", "Both E-waste and Non-ewaste items not to be in same lot");
              return
            }
            var unique_array = dc.filter((value, index, self) => unique(value, index, self))
            if (unique_array.length > 1) {
              this.selectedTableItem = []
              this.showAlert("error", "Select Same Cities");
              return
            }
            let benchmarkSum = 0;
            let floorPriceSum = 0;
            for(var i=0; i<this.selected.length; i++){
              benchmarkSum+=  this.formatNumber(this.selected[i].bench_mark_price);
              floorPriceSum+=  this.formatNumber(this.selected[i].floor_price);
            }
            this.$store.commit("setLotIds", {
              lotIds:  JSON.stringify(this.selected.map(a => a.id)),
              action:'create_lot',
              inventoryId : benchmarkSum, //invenoryId as benchmarkPrice
            });
            
            this.$store.commit("setInventoryIDS", {
              inventory_id : JSON.stringify(this.selected.map(a => a.inventory_id)),
            });

            this.$store.commit("ewaste_type", {
              ewaste : ewaste
            });
            this.$store.commit("setFloorPrice", {
              sum_floor_price : floorPriceSum
            });

          this.$router.push({ name: 'CreateLotCompBidd',query : { action : "create-lot" } });
        },
        moveToMAQFromComBidd(){
          this.liq_id = this.selected.map(liquidation => liquidation.id);
        this.$httpSecured.post('api/v2/warehouse/liquidation/competitive_bidding_price/move_to_moq', {
          "liquidation":{
             "ids":this.liq_id
          }
         }
          )
        .then(response => {
          if (response.data) {
            this.liq_id = ''
            this.assign_buyer = ''
            // this.loadData(this.active_tab)
            this.moveItemCommToMoq = false
            this.successmessage = `${this.selected.length} item(s) is successfully allocated to MOQ`
            // this.selectedTableItem = [];
            this.successpopup = true
            this.showAlert("success", "Successfully updated");
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.showAlert("error", "Something went wrong from Network");
          this.loading = false;

        });
      },
      afterClickOkLoadData(){
          this.successpopup = false;
          this.successmessage = ''
          this.$store.commit("setMessage", { responseMessage: undefined });
          this.selectedTableItem = []
          this.ewasteYes = false
          this.loadData(this.active_tab);     
    },
        closeSuccesspopup(){
          this.successpopup = false;
          this.ewasteYes = false
        },
      editbidtiming(){
        if(this.active_tab == "In Progress B2B"){
          const dateStr = this.selected[0].start_date.slice(0, 16);
        const parts = dateStr.split(/[\s/:-]/);
        const startDate = new Date(parts[2],parts[1]-1,parts[0],parts[3],parts[4])
        const currentDate = new Date();
        if(startDate <= currentDate){
            this.showAlert("warning", "Lot already started");
            this.ecitBidTimeDilog = false
            this.selectedTableItem = []
          }else{
            this.ecitBidTimeDilog = true
            this.number=0;
          }       
        }else{
          this.ecitBidTimeDilog = true
          this.time2 = this.timeFormat(new Date()).slice(11)
            this.number=0;
        }
      },
      timeFormat(date){
        const currentDate = new Date(date);
          const currentMinutes = currentDate.getMinutes();
          let minutesToAdd;
          if(IS_QA_SERVER === true){
            minutesToAdd = 5 - (currentMinutes % 5); 
          }else{
            minutesToAdd = 30 - (currentMinutes % 15 || 15);
          }
          const roundedDate = new Date(currentDate.getTime() + minutesToAdd * 60000);
          const year = roundedDate.getFullYear();
          const month = String(roundedDate.getMonth() + 1).padStart(2, '0');
          const day = String(roundedDate.getDate()).padStart(2, '0');
          const hours = String(roundedDate.getHours()).padStart(2, '0');
          const minutes = String(roundedDate.getMinutes()).padStart(2, '0');
          const formattedDate = `${day}/${month}/${year}`;
          const formattedTime = `${hours}:${minutes}`;
          const st_time = `${formattedDate} ${formattedTime}`;
          return st_time
      },
      closeEditBidDailog(){
        this.ecitBidTimeDilog = false
        this.$refs.editDateTimeForm.reset();
        this.time1=null;
        this.time2=null;
        this.selectedTableItem = [];
      },
      formatDate(date) {
        const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hour = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} ${hour}:${minutes}`;
},
      openDialog() {
      this.dialogVisible = true;
    },
      closeDialog() {
        this.dialogVisible = false;
      },
      assignBuyerList() {
      this.$httpSecured.get("api/v2/warehouse/liquidation_order/b2b/in_progress/vendor_list")
        .then(response => {
            this.assign_user_items = response.data.vendor_masters
            this.loading = false;
        })
        .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
        });
    }, 
      reserveLotDialog(){
           const liq_id = this.selected.map(liquidation => liquidation.id);
          let str = String(liq_id);
          this.liq_id = str;
          this.reserveLotPopup = true
          this.get_vendor_liquidation();
      },
      reserveConfirm(){
        this.liq_id = this.selected.map(liquidation => liquidation.id);
        this.$httpSecured.post('/api/v2/warehouse/liquidation_order/b2b/in_progress/reserve', {
          "liquidation_order":{
             "ids":this.liq_id,
             "winner_code":this.assign_buyer
          }
         }
          )
        .then(response => {
          if (response.data) {
            this.reserveLotPopup = false
            this.selectedTableItem = []
            this.liq_id = ''
            this.assign_buyer = ''
            this.successmessage = response.data.message
            this.successpopup = true
            this.showAlert("success", "Successfully updated");
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.showAlert("error", "Something went wrong from Network");
          this.loading = false;

        });
      },
      isMoqLot() {
        return this.selected.length !== 1 || this.selected[0].lot_type === 'MOQ Lot';
      },
      assignLotToBuyer(){
        const selectedItem = this.selected.find(item => item.uniq_bids_no === 0);      
         let reason_text = '';
          if(this.select_reason === 'Others'){
             reason_text = this.reason_others;
          }else{
              reason_text = this.select_reason;
          }
           
          if (selectedItem) {
            this.showAlert("warning", 'Please select a bidder lot.');
            this.selectedTableItem = []
            return;
          }
        this.$store.commit("setLotIds", {
            lotIds: JSON.stringify(this.selected.map(a => a.id)),
            action: reason_text,
            inventoryId: this.remarks_confirm_buyer
          });

          this.$store.commit("setNavigateTab", { navigate_tab:this.active_tab});
          this.$store.commit("setBueyerName", { buyer_name: this.selected[0].buyer_name });
          this.$router.push({ name: 'AssignLotToBuyer' });
        },
        navigateToRepublish(condition) {
          if(this.selected.length == 1){
            if (this.selected[0].lot_type === 'Competitive Lot'){
                  this.$store.commit("setLotIds", {
                  lotIds: this.selected.map(liquidation => liquidation.id),
                  action:condition
                   }); 
                 this.$router.push({ name: 'CreateLotCompBidd', query : { action : "republish" } }); 
            }else if(this.selected[0].lot_type === 'MOQ Lot'){
                this.navigateToMOQGridFrom(condition)
              }                
            }else{
              this.showAlert("warning", "Please select one lot for Republish");
              this.selectedTableItem = []
            }
        },
        opendialogMoveToB2b(){
          this.moveToB2B = true;
          this.b2b_liq_id = this.selected.map(liquidation_order => liquidation_order.id);
        },
        consfirmMoveToB2B(){
          this.$httpSecured
            .post("/api/v2/warehouse/liquidation/b2c_pending_publish/move_to_b2b", 
                {
                  "liquidation":{
                    "ids":this.b2b_liq_id
                  }
                }
            )
            .then(response => {
              if (response.data) {
                // this.showAlert("success", "Successfully alloted!");
                this.selectedTableItem = [];
                this.b2b_liq_id = ''
                this.moveToB2B = false;
                this.successmessage = response.data.message
                this.successpopup = true
              } else {
                this.showAlert("error", "No Data Found");
              }
            }).catch(error => {
                  this.showAlert("error", "Something went wrong from Network" + error);
              });
        },
        openPublishDialog(){
          this.publishDialog = true;
          this.getPlatformList()
          this.b2b_liq_id = this.selected.map(liquidation_order => liquidation_order.id);
          this.benchmark_price = 0;
          this.selected.forEach( item => {
            this.benchmark_price += this.formatNumber(item.bench_mark_price) })
            setTimeout(() => {
              this.$refs.lotPublishForm.reset();
            }, 100);
          this.lotImages = [];
          this.lotImageNames = [];
        },
        openImagePopup(){
        this.initialLotImagesLength = this.lotImages.length;
        this.addImagesPopup = true;        
      },
      openImagePopupSingle(image) {
        this.selectedImage = image;
        this.imagePopup = true;
      },
    handleImageUpload(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        this.lotImageNames.push(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
          // const binaryData = e.target.result;
          this.lotImages.push(reader.result);
          this.lotImagesFileFormat.push(file);
        };

        // Read the image file as binary data
        reader.readAsDataURL(file);
      }
      // this.initialLotImagesLength = this.lotImages.length;
    },
    getImageName(imageUrl) {
    const urlParts = imageUrl.split('/');
    const fileNameWithExtension = urlParts[urlParts.length - 1];
    const fileName = fileNameWithExtension.split('.')[0];
    return fileName;
  },
  removeImage(index) {
    this.lotImages.splice(index, 1);
    this.lotImageNames.splice(index, 1);
    this.lotImagesFileFormat.splice(index,1);
  },
  publishLot(){
        var  start_dtime = this.dateformat(this.bid_start_date + " " + this.time1)
        var  end_dtime   = this.dateformat(this.bid_end_date + " " + this.time2)
        if (this.$refs.lotPublishForm.validate()){
          if(end_dtime <= start_dtime){
            this.showAlert("error", "Invalid Date / Time ..!!");
          }else{
          const formData = new FormData();
          const ecom_liquidation = {
            "discount":this.discount,
            "publish_price": this.publish_price,
            "start_date":(this.bid_start_date + " " + this.time1),
            "end_date":(this.bid_end_date + " " + this.time2),
            "platform":this.platform,
            "liquidation_ids":this.b2b_liq_id,    
         }
          for(var i=0; i < this.lotImagesFileFormat.length; i++){
            formData.append("images[]", this.lotImagesFileFormat[i])
          }
          for (const key in ecom_liquidation) {
              formData.append(`ecom_liquidation[${key}]`, ecom_liquidation[key]);
            }
          this.$httpSecured
          .post(`api/v2/warehouse/liquidation/b2c_pending_publish/publish`, formData,{
              headers: {
              'Content-Type': 'multipart/form-data'
                  }
         })
          .then(response => {
            if (response.data) {  
              this.publishDialog = false
              this.selectedTableItem = []
              this.b2b_liq_id = ''
              this.successmessage = response.data.message
              this.successpopup = true
              this.$refs.lotPublishForm.reset();
              // this.showAlert("success", "Lot Created For Selected Inventory");
              this.files         = [];
            } else {
              this.showAlert("error", "Something went Wrong !!");
              this.createBeamLotDialog = false;
            }                         
          })
          .catch(error => {
            this.showAlert("error", error.response.data.error);
            this.number = 0;
          }); 
        }}
     },
      openUpdateSalesDialog(){
        this.updateSalesPopup = true;
        this.b2b_liq_id = this.selected.map(liquidation_order => liquidation_order.id);
      },
      submitUpdateSalesDetails(){
        this.$httpSecured.post('/api/v2/warehouse/liquidation_order/b2c/in_progress/update_sales', {
          "lot":{
             "buyer_name":this.buyer_name,
             "buyer_address_1":this.address_line_1,
             "buyer_address_2":this.address_line_2,
             "buyer_city":this.city,
             "buyer_state":this.state,
          },
          "liquidation_order": {
            "ids": this.b2b_liq_id
          }
         }
          )
        .then(response => {
          if (response.data) {
            this.updateSalesPopup = false
            this.selectedTableItem = []
            this.b2b_liq_id = ''
            this.buyer_name = ''
            this.address_line_1 = ''
            this.address_line_2 = ''
            this.city = ''
            this.state = ''            
            this.successmessage = response.data.message
            this.successpopup = true
            // this.showAlert("success", "Successfully updated");
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.showAlert("error", "Something went wrong from Network");
          this.loading = false;

        });
      },
      openupdatePaymentDialog(){
        this.get_vendor_liquidation()
        this.updatePaymentPopup = true;
        this.number = 0;
        this.liq_id = this.selected.map(liquidation => liquidation.id);
        for (let i = 0; i < this.selected.length; i++) {
        const selectedItem = this.selected[i];
        this.purchaseAmount = selectedItem.purchase_amount;
        this.amountReceived = selectedItem.amount_received;
        // this.total_amount =   parseInt(this.purchaseAmount.replace(/,/g, "")) - parseInt(this.amountReceived.replace(/,/g, ""))
      }

      },
      paymentUpdateDetailsSubmit() {
        this.number++;
          this.$httpSecured
            .put(`/api/v2/warehouse/liquidation_order/pending/payment/${this.liq_id}`, 
            {
              "payment_received": this.purchase_amount,
              "transaction_id": this.payment_ref_number
            })
            .then(response => {
              if (response.status === 200) {
                this.number = 0
                this.successmessage = response.data.message
                this.updatePaymentPopup = false
                this.successmessage = response.data.message
                this.successpopup = true
                this.selectedTableItem = []
                this.purchase_amount = ''
                this.payment_ref_number = ''
                this.liq_id = ''
              } else {
                this.number = 0
                this.showAlert("error", "Something went Wrong !!");
                this.ecitBidTimeDilog = false;

              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.error);
              this.number = 0;
            }); 
        },
        openCancelPendingPayment(){      
          this.number = 0;    
          this.cancelPaymentPopup = true
          this.select_buyer = ''
          this.liq_id = this.selected.map(liquidation => liquidation.id);
          const itemsWithNullEwaste = this.selected.filter(liquidation => liquidation.lot_type === 'Competitive Lot');
          let itemsWithNullEwasteContarct = this.selected.filter(liquidation => liquidation.lot_type === 'Contract Lot');
          this.reserveLotDisabled = itemsWithNullEwaste.length > 0 || itemsWithNullEwasteContarct.length > 0 ? true : false 
        if (itemsWithNullEwaste.length > 0) {
          // const itemNames = itemsWithNullEwaste.map(liquidation => liquidation.lot_type).join(", ");
          // this.reserveLotDisabled = true
          this.assignDisabled = false
          return; 
        }else{
          // this.reserveLotDisabled = false
          this.assignDisabled = true
        }
        },
        assignLotOne(){
          const amountReceived = this.selected.map(liquidation => liquidation.amount_received);
          if(amountReceived  == 0){
            if(this.selected.length == 1){
          this.$httpSecured
        .get(`/api/v2/warehouse/liquidation_order/pending/decision/get_bidders?id=${this.liq_id}`)
        .then(response => {
          if (response.data) {
            this.assign_user_items = response.data.bids_details
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
         }else{
          this.showAlert("warning", "Please select one lot for assign. ");
                 this.cancelPaymentPopup = false
                 this.select_buyer = ''
                 this.selectedTableItem = []                 
         }
          }else{
            this.showAlert("warning", `Unable to assign lot! ${this.liq_id} have Payment initiated. `);
                 this.cancelPaymentPopup = false
                 this.select_buyer = ''
                 this.selectedTableItem = [] 
          }
        
        },
        getDataAssign() {    
        const filteredItems = this.assign_user_items.filter(data => {
          return data.higest_bid_id === this.assign_buyer;
        });
          this.biddername = filteredItems[0].user_name
          this.highestBidId = filteredItems[0].higest_bid_id
          this.usermail  = filteredItems[0].user_email
          this.highestbid = filteredItems[0].higest_bid
      },
        lotCancelApiCall(){
          this.number++;
          this.liq_id = this.selected.map(liquidation => liquidation.id);
          const id = parseInt(this.liq_id[0])
          if(this.select_buyer === 'option1'){
            this.$httpSecured
            .put(`/api/v2/warehouse/liquidation_order/pending/decision/${this.liq_id}`, 
            {
              "vendor_code":this.highestBidId,
              "user_name":  this.biddername,
              "user_email": this.usermail,
              "higest_bid": this.highestbid     
            })
            .then(response => {
              if (response.status === 200) {
                this.cancelPaymentPopup = false
                this.successmessage = response.data.message
                this.successpopup = true
                this.selectedTableItem = []
                this.assign_buyer = ''
                this.liq_id = ''
                this.highestBidId = ''
                this.biddername = ''
                this.usermail = ''
                this.highestbid = ''
              } else {
                this.showAlert("error", "Something went Wrong !!");
                this.ecitBidTimeDilog = false;

              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.errors);
              this.number = 0;
            });
          }
          if(this.select_buyer === 'option2'){
            if(this.selected.length == 1){
              if (this.selected[0].lot_type === 'Competitive Lot'){
                  this.navigateToRepublish('re_publish_payment')                
              }else if(this.selected[0].lot_type === 'MOQ Sub Lot'){
                this.navigateToMOQGridFrom('re_publish_payment')
              }            
              
            }else{
              if(this.selected.length > 1 && this.selected[0].lot_type === 'Competitive Lot'){
                this.editbidtiming();
                 return;
              }
              this.showAlert("warning", "Please select one lot for Republish");
              this.cancelPaymentPopup = false
              this.selectedTableItem = []
              this.select_buyer = ''
            }
            
          }
          if(this.select_buyer === 'option3'){
            this.$httpSecured
            .post(`/api/v2/warehouse/liquidation_order/pending/decision/delete_lots`, 
            {
              "liquidation_order":{
              "ids": this.liq_id
               }          
            })
            .then(response => {
              if (response.status === 200) {
                this.cancelPaymentPopup = false
                this.successmessage = response.data.message
                this.successpopup = true
                this.selectedTableItem = []
                this.assign_buyer = ''
                this.liq_id = ''
              } else {
                this.showAlert("error", "Something went Wrong !!");
                this.ecitBidTimeDilog = false;

              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.errors);
              this.number = 0;
            });
          }
          if(this.select_buyer === 'option4'){
            this.$httpSecured
            .post(`/api/v2/warehouse/liquidation_order/pending/payment/unreserve_sub_lot`, 
            {
             "id":id           
            })
            .then(response => {
              if (response.status === 200) {
                this.cancelPaymentPopup = false
                this.successmessage = response.data.message
                this.successpopup = true
                this.selectedTableItem = []
                this.assign_buyer = ''
                this.liq_id = ''
              } else {
                this.showAlert("error", "Something went Wrong !!");
                this.ecitBidTimeDilog = false;
                this.number = 0;

              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.error);
              this.number = 0;
            });
          }
        },
        openDispatchDateDialog(){
          this.updateDispatchDatePopup = true
          this.liq_id = this.selected.map(liquidation => liquidation.id);
        },
        submitUpdateDispatchDate(){
          this.$httpSecured
            .post(`api/v2/warehouse/liquidation_order/pending/dispatch_confirmation_time/update_dispatch_date`, 
            {
              "liquidation_order":{
                 "ids": this.liq_id
              },
              "dispatch_date": this.publish_end_date      
            })
            .then(response => {
              if (response.status === 200) {
                this.updateDispatchDatePopup = false
                this.successmessage = response.data.message
                this.successpopup = true
                this.selectedTableItem = []
                this.publish_end_date = ''
                this.liq_id = ''
              } else {
                this.showAlert("error", "Something went Wrong !!");
              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.errors);
              this.number = 0;
            });
        },
        validateInput() {
            this.payment_ref_number = this.payment_ref_number.replace(/[^a-zA-Z0-9]/g, "");
        },
    disableBtn() {
    return this.selected.length === 0 || this.selected.some(item => !item.has_inventory_gate_pass);
    },
      validateAmount(value) {
        const totalAmount = this.formatNumber(value);
        // if(totalAmount === this.formatNumber(this.purchaseAmount)){
        //   return true;
        // }
        const total_value = this.formatNumber(this.purchaseAmount) - this.formatNumber(this.amountReceived)
        if(!(/^(0|[1-9]\d*)(\.\d+)?$/.test(this.formatNumber(value)))){
          this.purchase_amount = 0
          return 'Enter a valid number'
        }
        if (totalAmount > total_value) {
          return 'Total amount received exceeds the purchase amount.';
        }
        return true;
      },
      republishShowAlert(){
        return true;
        // const totalAmountReceived = this.selected.reduce((sum, item) => {
        //   return sum + (Number(item.amount_received) || 0);
        // }, 0);

        // if (totalAmountReceived > 0) {
        //   this.showAlert("warning", `Unable to Re-publish lot! ${this.liq_id} have Payment initiated.`);
        //   this.cancelPaymentPopup = false;
        //   this.ecitBidTimeDilog = false;
        //   this.select_buyer = '';
        //   this.selectedTableItem = [];
        //   return false;
        // }else return true;
      },
      unReserveLotShowAlert(){
        const amountReceived = this.selected.some(liquidation => liquidation.amount_received != 0);
        if(this.selected.length > 1){
          this.showAlert("warning", `Please select one sub lot for un-reserve`);
          this.cancelPaymentPopup = false
          this.select_buyer = ''
          this.selectedTableItem = [] 
        }else{
          if(amountReceived){
            this.showAlert("warning", `Unable to Unreserve sub-lot! ${this.liq_id} have Payment initiated.`);
                 this.cancelPaymentPopup = false
                 this.select_buyer = ''
                 this.selectedTableItem = [] 
          }
        }
         
      },
      deleteShowAlert(){
        return;
        // const amountReceived = this.selected.map(liquidation => liquidation.amount_received);
        //   if(amountReceived.every(amount => amount !== 0 && amount !== null)){
        //     this.showAlert("warning", `Unable to delete lots! ${this.liq_id} have Payment initiated.`);
        //          this.cancelPaymentPopup = false
        //          this.select_buyer = ''
        //          this.selectedTableItem = [] 
        //   }
      },
      calculateDiscPercent(){
        this.showPriceError = false;
        this.discountDisable = true;
        let publishPriceValue = typeof this.publish_price === "string" ? parseFloat(this.publish_price.replace(/,/g, '')) : ""
        if(isNaN(publishPriceValue)){
          this.format_publish_price = ""
          return
        }
        else if(this.publish_price>this.benchmark_price){
          this.showPriceError = true;
        }
        else if(this.publish_price > 0){
          this.discount = ((Number(this.benchmark_price) - Number(this.publish_price))*100/Number(this.benchmark_price)).toFixed(2);
        }
        else {
          this.discount = '';
          this.discountDisable = false;
        }
      },
      calculatePublishPrice(){
        this.showDiscError = false;
        this.publishpriceDisable = true;
        if(this.discount>100){
          this.showDiscError = true;
        }
        else if(this.discount > 0){
        this.format_publish_price = ((100 - Number(this.discount))*Number(this.benchmark_price)/100).toFixed(2);
        } else {
          this.format_publish_price = '';
          this.publishpriceDisable = false;
        }
      },
      navigateToMOQComponent(condition) {
        this.$store.commit("setLotIds", {
            lotIds: this.id,
            action:condition

          });
          this.$router.push({ name: 'CreateLotsMOQ' });
        },
        navigateToMOQGridFrom(condition) {
          if(condition == 're_publish_payment'){
            var dc = this.selected.map(x =>  x.id)
            var id = dc.pop();
        this.$store.commit("setLotIds", {
            lotIds: id,
            action:condition
          });
          this.$router.push({ name: 'PriceGridMoq' });
          }else if(condition == 'edit_lot_moq'){
        this.$store.commit("setLotIds", {
            lotIds: this.id,
            action:condition
          });
          this.$router.push({ name: 'PriceGridMoq' });
          }          
        },
        getPlatformList(){
        this.$httpSecured.get("/api/v2/warehouse/liquidation/b2c_pending_publish/get_platform_list")
        .then(response => {
          if(response.data){
            this.platform_items = response.data.ext_platform_names 
            this.loading = false;
          }else{
            this.loading = true;
          }
        })
        .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
        });
    },
    closeImageDialog() {        
          const newImagesCount = this.lotImages.length - this.initialLotImagesLength;
          if (newImagesCount > 0) {
            // Remove newly added images if any
            this.lotImages.splice(this.initialLotImagesLength, newImagesCount);
            this.lotImageNames.splice(this.initialLotImagesLength, newImagesCount);
            this.lotImagesFileFormat.splice(this.initialLotImagesLength, newImagesCount);
          }
          this.addImagesPopup = false;
        },
    competitivebidding(){
         this.movecommbidd = true
         this.channel_liq_id = this.selected.map(liquidation => liquidation.id);
        },
    submitMoveCommBidd(){
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation/moq/move_to_competative_bidding', 
            {
              "liquidation":{
                "ids":this.channel_liq_id,
              }              
            }
          )
          .then(response => {
            if (response.data) {
                // this.table_data = response.data.liquidations
                this.successmessage = response.data.message
                // this.showAlert("success", "Successfully alloted!");
                this.movecommbidd = false
                this.successpopup = true
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.number = 0;
          this.loading = false;

        });
      },
      navigateToFileUpload(){
        this.$store.commit("setLotIds", {
              lotIds:  JSON.stringify(this.selected.map(a => a.id)),
              action:'create_lot',
              inventoryId: 'Liquidation'
            });
        this.$router.push({ name: 'LotFileuploadComm' });
        },
        itemMoveCommToMoqTab(){
          const itemsWithNullEwaste = this.selected.filter(liquidation => liquidation.ewaste === 'yes');
          if (itemsWithNullEwaste.length > 0) {
          this.showAlert("warning", "Please select only non ewaste items for move to moq");
          this.moveItemCommToMoq = false;
          this.selectedTableItem = []
          return; // Stop further execution
        }
        else{
          this.moveItemCommToMoq = true
        }
          
        },
        downloadInventory() {
          // console.log(JSON.stringify(this.selected))
          this.liq_id = this.selected.map(liquidation => liquidation.id);
          this.$httpSecured.post("/api/v2/warehouse/inventory_file_uploads/download_competitive_liquidations", {
              "liquidation":{
              "ids":this.liq_id
            }
          })
            .then(response => {
              if(!this.liq_id.length){
                  this.successmessage = response.data.message
                  this.successpopup = true
                }else{
                  const link = document.createElement('a');
                  link.href = response.data.url; 
                  link.target = '_blank';
                  link.download = response.data.url.split('/').reverse()[0]; 
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  this.successmessage = "File downloaded successfully!"
                  this.successpopup = true
                }
            })
            .catch(error => {
                this.showAlert("error", "Something went wrong from Network" + error);
                this.loading = false;
            });
        },
        getdisposition(){
            this.$httpSecured
              .get("api/v2/warehouse/liquidation/channel_allocations/get_dispositions")
                  .then(response => {
                  if (response.data) {
                    const list = ['Grading']
                      this.change_disposition_list = response.data.dispositions.filter(disposition => list.includes(disposition.original_code));
                  } else {
                      this.showAlert("error", "No Data Found");
                  }
              })
              .catch(error => {
                  this.showAlert("error", error.response.data.error);
              });
            },
            changeDisposition(item){
                if (this.selected.length === 0) {
                        this.message = "Please select some items.";
                        this.messagePopup = true;
                    } else {
                        const firstLocation = this.selected[0].location;
                        const allLocationsMatch = this.selected.every(item => item.location === firstLocation);

                        if (allLocationsMatch) {
                        this.disposition_action = item.original_code;
                        this.confirmationPopup = true;
                        this.dispositionId = [item];
                        } else {
                        this.showAlert("warning", "Please selecte items with same location")
                        }
                    }
            },
            moveToGradingFromComBidd(){
              const gradingDisposition = this.change_disposition_list.find(disposition => disposition.original_code == 'Grading');
              if(gradingDisposition){
                this.changeDisposition(gradingDisposition);
              } else {
                this.showAlert("error", "Grading disposition not found");
              }
            },
            confirmedDispo(){
              this.number++;
              const dispositionid = this.dispositionId[0].id
              const itemId = this.selected.map(table_data => table_data.id)
              const params = {
                  "liquidation":{
                   ids : itemId,                  
                  },
                  disposition_id: dispositionid
              }
              this.$httpSecured
                  .post("/api/v2/warehouse/liquidation/channel_allocations/change_disposition", params)
              .then((response) => {
                  if (response.data) {
                      this.confirmationPopup = false;
                      this.successmessage = response.data.message
                      this.successpopup = true
                      this.number = 0
                  } else {
                  this.showAlert("error", "No Data Found");
                  this.number = 0
                  }
              })
              .catch((error) => {
                  this.showAlert("error", error.response.data.error);
                  this.number = 0
              });
            },
      handleSaveDate(dateType , dateState, selectDateState, type, endDate, calendarEndDate){
        this[dateState] = this.formatted_filter_date(this[selectDateState])
        if(type){
          let selectedDate = new Date(this[selectDateState])
          if(selectedDate.getTime() > new Date(this[endDate]).getTime()){
            this[calendarEndDate] = this[selectDateState]
            this[endDate] = this[endDate] ?  this.formatted_filter_date(this[selectDateState]) : null
          }
        }
        this[dateType] = false
      },
      viewBidOpenPopup(){
        this.viewBidDetailsPopup = true
        this.bidheader = [
          { text: "Buyer ID", value: "higest_bid_id"},
          { text: "Buyer Name", value: "user_name"},
          { text: "Organization", value: "organization"},
          { text: "Highest Bid", value: "higest_bid"}
        ];
        this.fetchBuyerList()
      },
      fetchBuyerList(){
        let lotIds = this.id;
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        this.$httpSecured
        .get(`/api/v2/warehouse/liquidation_order/pending/decision/get_bidders?id=${lotIds}`)
        .then(response => {
          if (response.data) {
            this.bid_details = response.data.bids_details
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      },  
      isPdfFile(url) {
        return url.split('.').pop().toLowerCase() === 'pdf';
      },
      complianceImageShow(item){
        this.complaince_image_show = true;
        this.imageUrls = item.document_url;
        const fileExtension = this.imageUrls.split('.').pop().toLowerCase();
        this.isPdf = fileExtension === 'pdf';
        if (this.isPdf) {
          this.showPdf(this.imageUrls);
        }
      },
      showPdf(pdfUrl) {
        this.pdfViewerUrl = `https://docs.google.com/gview?url=${pdfUrl}&embedded=true`;
      },
      uploadDocOpenPopup(item) {
         if(this.active_tab === 'Pending Approval'){
           this.lot_ids = item.lot_id;
        }else{
          this.lot_ids = item.id;
        }
        this.item_weight = item.weight;
        this.number = 0;
        this.upload_documents = true;
        this.skip_button = true;
        this.file_data = [];
        this.select_documents = null;
        this.file_compliance = '';
        this.confirmButton = 'CONFIRM';
        if(this.active_tab === 'Compliance Docs'){
            this.getComplianceDocuments();
          }else{
            this.getUploadListTypes();
          }
      },
      getComplianceDocuments() {
        this.$httpSecured
          .get(`/api/v2/warehouse/liquidation_order/compliance_docs/list_of_compliance_documents?id=${this.lot_ids}`)
          .then(response => {
            if (response.data) {
              // this.select_documents_items = response.data.compliance_document_list;
              const uploadedDocumentNames = this.file_data.map(file => file.document_name);
              this.select_documents_items = response.data.compliance_document_list.filter(doc => !uploadedDocumentNames.includes(doc));
            } else {
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
          });
      },
    getUploadListTypes() {
      this.$httpSecured
        .post('/api/v2/warehouse/liquidation_orders/list_of_document_types',{
          "id":this.lot_ids
        })
        .then(response => {
          if (response.data) {
            // this.select_documents_items = response.data.compliance_document_list;
            const uploadedDocumentNames = this.file_data.map(file => file.document_name);
            this.select_documents_items = response.data.document_types_list.filter(doc => !uploadedDocumentNames.includes(doc));

          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
      confirmUploadFile() {
        this.uploadFile('start')
        this.number++;
        const formData = new FormData();
        formData.append('attachment_file', this.file_compliance);
        formData.append('document_name', this.select_documents);
        var apiUrl = '';
            if(this.active_tab === 'Compliance Docs'){
              apiUrl = '/api/v2/warehouse/liquidation_order/compliance_docs/upload_compliance_attachment';
            }else{
              apiUrl = '/api/v2/warehouse/liquidation_orders/upload_lot_attachment';
            }
        this.$httpSecured
          .post(apiUrl, formData)
          .then(response => {
            this.uploadFile('success')
            this.action_name = 'success_msg';
            this.message = "Successfully uploaded.";
            this.messagePopWidth = "424px";
            const fileData = {
              document_name: response.data.attachment_file_name,
              document_url: response.data.attachment_file
            };
            this.file_data.push(fileData);
            this.select_documents_items = this.select_documents_items.filter(item => item !== this.select_documents);
            this.select_documents = '';
            this.file_compliance = '';
          })
          .catch(error => {
            this.number = 0;
            this.showAlert("error", error.response.data.master_file);
          });
      },
      changeFile() {
          if (this.file_compliance) {
            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
            const fileType = this.file_compliance.type;
            this.fileError = false;
            if (!allowedTypes.includes(fileType)) {
              this.fileError = true;
              this.fileErrorMessage = 'Only PDF and JPEG/PNG files are allowed.';
            } else {
              this.fileError = false;
              this.fileErrorMessage = '';
            }
          } else {
            this.confirmButton = 'CONFIRM';
          }
      },
      uploadFile(status) {
        var percentage;
        this.uploading = true;
        let reader = new FileReader();
        if (status === 'start') {
          reader.onprogress = (event) => {
            if (event.lengthComputable) {
              percentage = Math.round((event.loaded / event.total) * 50);
              this.uploadPercentage = percentage;
            }
          };
        } else if (status === 'success') {
          reader.onprogress = (event) => {
            if (event.lengthComputable) {
              percentage = Math.round((event.loaded / event.total) * 100);
              this.uploadPercentage = percentage;
              this.uploading = false;
              this.completed = true;
              this.cancel_button_hide = true;
            }
          };
        }
        reader.onloadend = (event) => {
          if (status === 'success') {
            setTimeout(() => {
              this.uploading = false;
              this.completed = false;
              this.uploadPercentage = 0;
              this.number = 0;
              this.confirmButton = 'FINISH';
            }, 2000);
          }
        };
        reader.readAsDataURL(this.file_compliance);
      },
      clickFinish() {
        this.file_compliance = '';
        this.select_documents = '';
        this.fileName = '';
        this.file_data_cond = true;
        if(this.select_documents_items == '' && this.active_tab === 'Compliance Docs'){
          if(this.active_tab === 'Compliance Docs'){
            this.upload_documents = false;
            this.confirmButton = 'CONFIRM';
            this.add_weight = true;
            this.add_weight_kg = this.item_weight;
            this.skip_button = false;
        }else{
          this.saveFiles();
        }
        }else{
        this.saveFiles();
      }
      },
      closeChip() {
        this.fileName = '';
      },
      removeFile(type, index) {
        const documentName = this.file_data[index].document_name;
        this.file_data.splice(index, 1);
        if (!this.select_documents_items.includes(documentName)) {
          this.select_documents_items.push(documentName);
        }
      },
      saveFiles(condi) {
        this.number++;
        let complianceDocumentHash ={};
        let end_point;
        if(this.active_tab === 'Compliance Docs'){
         if(condi === "skip"){
          complianceDocumentHash = {
            Weight: '',
          };

          this.file_data.forEach(item => {
            complianceDocumentHash[item.document_name] = {
              document_url: item.document_url,
            };
          });
       }else{
         complianceDocumentHash = {
            Weight: this.add_weight_kg,
          };

          this.file_data.forEach(item => {
            complianceDocumentHash[item.document_name] = {
              document_url: item.document_url,
            };
          });
       }
       end_point = '/api/v2/warehouse/liquidation_order/compliance_docs/upload_compliance_documents'
       }else{
        this.file_data.forEach(item => {
            complianceDocumentHash[item.document_name] = {
              document_url: item.document_url,
            };
          });
        end_point = '/api/v2/warehouse/liquidation_orders/upload_lot_documents'
       }
      
       const requestPayload = {
          id: this.lot_ids,
          [this.active_tab === 'Compliance Docs' ? 'compliance_document_hash' : 'lot_attachment_hash']: complianceDocumentHash,
        };
       this.$httpSecured
        .post(end_point, requestPayload)
        .then(response => {
          this.add_weight = false;
          this.upload_documents = false;
          this.add_weight_kg = '';
          this.select_documents_items = ''
          this.select_documents = '';
          this.number = 0;
          this.successmessage = response.data.message
          this.successpopup = true
        })
        .catch(error => {
          this.number = 0;
          this.showAlert("error", error.response.data.master_file);
        });
      },
      deletItemDoc(item) {
        this.number++;          
        this.$httpSecured.post('/api/v2/warehouse/liquidation_order/compliance_docs/delete_compliance_documents', 
            {
              id: this.lot_ids,
              attachment_file_name: item.document_name,
            }
          )
          .then(response => {
            this.successmessage = response.data.message;
            this.successpopup = true;
            this.UpdateDataAfterDelete();
          })
          .catch(error => {
            this.number = 0;
            this.showAlert("error", error.response.data.master_file);
          });
      },
      UpdateDataAfterDelete(){
        this.$httpSecured
        .get(`/api/v2/warehouse/liquidation_order/compliance_docs/view_compliance_documents?id=${this.lot_ids}`)
        .then(response => {
          if (response.data) {
            this.edit_inventory = response.data.documents_list;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      },
      openAddWeight(){
        this.upload_documents = false;
        this.add_weight = true;
        this.add_weight_kg = this.item_weight;
      } ,
      cancelEditInvePopup(){
      this.editinventory = false
      this.edit_inventory = []		  
    },
    openConfirmBuyer(value){
        this.item_id = this.selected[0].id
        this.select_value = value;
        this.confirmBuyerPopup = true;
        this.number = 0;
        this.getReasonData();
        this.remarks_confirm_buyer = '';
        this.select_reason = null;
        this.reason_others = '';
      },
    handleConfirm() {
        if (this.select_value === 're_assign_buyer') {
          this.confirmBuyerPopup = false;
          this.assignLotToBuyer();
        }else{
          this.confirmBuyerPopup = false;
          if(this.select_value === 'reject_from_pending')
          this.confirmReject();
          else if(this.select_value === 'approvefrom_pending')
          this.confirmApprove();
        }      
    },
    confirmReject(){
      this.number++;
      let reason_text = '';
      if(this.select_reason === 'Others')
         reason_text = this.reason_others;
        else
        reason_text = this.select_reason;

      const date = new Date();
        const formattedDate = date.toISOString().slice(0, 19); // Get "YYYY-MM-DDTHH:mm:ss"
        const timezoneOffset = (-date.getTimezoneOffset() / 60).toString().padStart(2, '0') + ':00'; // Get "+05:30" style offset
        const rejectedOn = `${formattedDate}+${timezoneOffset}`;
        const params = {
                    "ids" : this.selected.map(item => item.id),
                    "user_id" : this.$store.state.currentUser.id,
                    "rejected_on": rejectedOn,
                    "reason" : this.select_reason
                }
      this.$httpSecured
            .put(`/api/v1/approval_requests/bulk_update`, { approval_request : params} )
            .then(response => {
              if (response.data) {
                this.successpopup = true
                this.successmessage = "Successfully rejected"
              } else {
                this.showAlert("error", "Something went Wrong !!");
              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.error);
              this.number = 0;
            });
          },
    confirmApprove(){
      this.number++;
       const date = new Date();
        const formattedDate = date.toISOString().slice(0, 19); // Get "YYYY-MM-DDTHH:mm:ss"
        const timezoneOffset = (-date.getTimezoneOffset() / 60).toString().padStart(2, '0') + ':00'; // Get "+05:30" style offset
        const rejectedOn = `${formattedDate}+${timezoneOffset}`;
        const params = {
                    "ids" : this.selected.map(item => item.id),
                    "user_id" : this.$store.state.currentUser.id,
                    "approved_on": rejectedOn,
                    "remarks" : this.remarks_confirm_buyer
                }
      this.$httpSecured
            .put(`/api/v1/approval_requests/bulk_update`, { approval_request : params} )
            .then(response => {
              if (response.data) {
                this.successpopup = true
                this.successmessage = "Successfully approved"
              } else {
                this.showAlert("error", "Something went Wrong !!");
              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.error);
              this.number = 0;
            });
        },
    // Button UI change action
      allocateAction(item){
        if(item === 'Allocate To B2B'){
          this.allocateTob2b();
        }else if(item === 'Allocate To B2C'){
          this.allocateTob2c();
        }
      },
      updatePriceDiscMethod(item){
        if(item == 'Competitive Bidding'){
          this.competitiveBiddibgdilog()
        }else if(item == 'Contracted'){
          this.contractedDialog();
        }else{
          this.createMoqlot();
        } 
      }, 
      updateCreteCombid(item){
        if(item == 'Create Lot')
          this.navigateToComponent();
        else if(item == 'Auto Create Lot')
          this.autocreatelot();
        else if(item == 'Upload Lot File')
          this.navigateToFileUpload();
        else if(item == 'Download Inventory')
         this.downloadInventory();
        else if(item == 'Move To MOQ')
          this.itemMoveCommToMoqTab();
        else if(item == 'Move To Grading')
          this.moveToGradingFromComBidd();
      },
       updateCreteMoqActions(item){
        if(item == 'Create Lots')
          this.navigateToMOQComponent('create_moq')
        else
          this.competitivebidding()
      },
      updateB2bAction(item){
        if(item == 'Edit Bid Timings')
          this.editbidtiming()
        else
          this.deletelot()
      },
      updateDecisionAction(item){
         if(item == 'Re-Assign Buyer')
          this.openConfirmBuyer('re_assign_buyer')
        else if(item == 'Assign Buyer')
          this.assignLotToBuyer()
        else if(item == 'Republish'){
          if(this.selected.length === 1){
            this.navigateToRepublish('re_publish');
          }else{
            this.editbidtiming();
          }
        } else this.deletelot()
      },

      updatePendingPaymentAction(item){
        if(item == 'Re-Assign'){
          this.openConfirmBuyer('re_assign_buyer');
          // const amountReceived = this.selectedTableItem.map(liquidation => liquidation.amount_received);
          //   if(amountReceived == 0){
          //     this.openConfirmBuyer('re_assign_buyer');
          //   }else{
          //     this.showAlert("warning", `Unable to assign lot! ${this.liq_id} have Payment initiated. `);
          //     this.selectedTableItem = []; 
          //   }        
        }else if(item == 'Update Payment'){
          this.openupdatePaymentDialog();
        }else if(item == 'Re-Publish'){
          this.republishShowAlert();
          if(this.selected.length === 1 && this.republishShowAlert()){
            this.navigateToRepublish('re_publish_payment')
          }else if(this.republishShowAlert()){
            this.editbidtiming()
          }
          }else{
          this.openCancelPendingPayment()
        } 
      },
      updateDispacthcConfirmTimeAction(item){
        if(item == 'Upload')
          this.redirect_to_upload();
        else
          this.downloadConfiramtion();
      },
      updatePendingB2cAction(item){
        if(item == 'Move To B2B')
         this.opendialogMoveToB2b();
        else
        this.openPublishDialog(); 
      },
      updateInprB2cAction(item){
        if(item == 'Update Sales')
          this.openUpdateSalesDialog();
        else
        this.deletelot();
      },
      // Button UI change action
       getReasonData(){
        this.$httpSecured
          .post('/api/v2/warehouse/liquidation_orders/list_of_reasons')
          .then(response => {
              if (response.data) {
                this.select_reason_items = response.data.reassign_reason_list
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
          }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
      })
      },
     navigateToBuyerDetails(value) {
       this.$store.commit("setLotIds", {
         lotIds: value.winner_buyer_id,
         action: 'Pending_Approval',
         inventoryId: value.winner_buyer_id
       });      
       this.$router.push({ name: "DetailsOfBuyer" });
     },
    isTabDisabled(tab, user_role) {        
        if ((user_role === 'finance_manager' && tab !== 'Pending Payment') || (user_role === 'warehouse_manager' && tab === 'Pending Approval')) {
          return true;
        }
        return false;
      },
      republishWithDate(){
          var  end_dtime   = this.dateformat(this.bid_end_date + " " + this.time2)
          this.liq_lot_id = this.selected.map(liquidation => liquidation.id);
          const formData = new FormData();
            this.number++;
              this.$httpSecured
            .post("/api/v2/warehouse/liquidation_order/pending/decision/bulk_lot_republish", {
              "liquidation_order": {
                 "ids": this.liq_lot_id               
            },
            "end_date": (this.bid_end_date + " " + this.time2)
            })
            .then(response => {
              if (response) {  
                  // this.showAlert("success", response.data.message);
                  this.ecitBidTimeDilog = false
                  this.successmessage = response.data.message
                  this.successpopup = true
                  this.liq_lot_id = '',
                  this.bid_start_date = '',
                  this.bid_end_date = '',
                  this.number = 0;
              } else {
                this.showAlert("error", "Something went Wrong !!");
                this.ecitBidTimeDilog = false;
                this.number = 0;
              }                         
            })
            .catch(error => {
              this.showAlert("error", error.response.data.error);
              this.number = 0;
            });
      }
    }
  }
</script>

<style scoped>
.filter-liquidation{
  width: auto !important;
}
.v-dialog:has(.filter-liquidation){
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
  }
  .v-dialog>.v-card>:has(.v-card__title){
  overflow-wrap: break-word !important;
}
  .custom-control_outlined .v-expansion-panel:before {
    box-shadow: none;
  }
  .custom-control_outlined-1 .v-expansion-panel--disabled {
    pointer-events: none;
  }
  .custom-control_outlined button {
    min-height: 52px;
    border-width: 1px;
    border-radius: 4px;
    border-color: rgba(0,0,0,.42);
    border-style: solid;
  }
  .custom-control_outlined button:focus {
    outline: none;
  }
  :deep(.v-expansion-panel .v-expansion-panel-title__overlay) {
    opacity: 0 !important;
  }
  :deep(.v-expansion-panel .v-expansion-panel__shadow) {
    box-shadow: none !important;
  }
  .icon-container {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 80px;
    width: 80px;
    border: 1px solid #91C6FF;
  }
  .next_filter_dialog {
    position: absolute;
    left: var(--dialog-leftpos);
    top: var(--dialog-yposi);
    margin: 0;
  }
  .filterchip {
    padding: 7px 10px !important;
    height: auto !important;
  }
  .menuItemCloseIcon {
    min-height: auto !important;
    border: none !important;
  }
  .active_border-primary {
    border-color: #1976d2 !important;
    border-width: 2px !important;
  }
  .active_float-label {
    position: absolute;
    top: 0;
    left: 9px;
    display: table-cell;
    white-space: nowrap;
    margin-top: -7px;
    background-color: #ffffff;
  }
  .creation-date{
    font-size: 12px;
    margin-left: 6px;
    color: #ccc;
  }
  .item-selected{
    margin-top: 23px;
    position: absolute;
    left: 41%;
  }
  @media (max-height: 1104px) {
    .PaddingItemPerPage{
    padding: 8px !important;
  }
}
  @media (min-height: 1126px) {
    .PaddingItemPerPage{
    padding: 24px !important;
  }
  }
  /* .v-data-table {
  height: auto !important;
} */
/* .v-data-simple-adjust{
  height: auto !important;
} */
.resetButton{
  background: #6c757d!important;
  color: #fff !important;
}
.custom-radio {
  width: 20px; /* Adjust the size as needed */
  height: 20px; /* Adjust the size as needed */
}
.custom-label{
  position: absolute;
  margin-left: 10px
}
.disabled-link {
    color: #999; /* Adjust the color to your preference */
    pointer-events: none; /* Prevents any interaction with the link */
    text-decoration: none; /* Optionally remove underline */
  }
/* .v-data-table-header > tr > th {
  background-color: #E1EEFA !important;
}  */
.table-scroll .v-data-table {
  height: 55vh !important;
}
.text-break {
  display: none;
}
@media (max-width: 1510px) {
  .text-break {
    display: block;
  }
}
.text-break-combid{
  display: none;
}
@media (max-width: 1570px) {
  .text-break-combid {
    display: block;
  }
}
.v-slide-group__prev--disabled{
  display: none !important;
}
.v-slide-group__next--disabled {
  display: none !important;
}
.filter_ui{
    margin-left: 28px !important;
    margin-top: 52px !important;
 }
 .ai_img{
  width: 24px;
  height: 24px;
  object-fit: contain;
  border-radius: 8px
 }
</style>
